// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/checkbox-black.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/link.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes logoSliderScroll {
  from {
    transform: translateX(0);
    transform: translate3d(0, 0, 0);
  }

  to {
    transform: translateX(-100%);
    transform: translate3d(-100%, 0, 0);
  }
}

.newpageContent:has(.tiptop-editor) .newpageLeft {
  z-index: 9;
}

.tiptop-editor:has(.uploadMediaPopup) [data-tippy-root] {
  display: none !important;
}

.tiptop-editor [data-tippy-root] {
  z-index: 3 !important;
}

.tiptop-editor *,
.tiptop-editor ::before,
.tiptop-editor ::after {
  box-sizing: border-box;
  border-width: 0;
  border-style: solid;
  border-color: #e5e7eb;
}

.tiptop-editor .ProseMirror {
  outline: none !important;
  border: none !important;
  min-height: 100%;
  z-index: 0;
  margin-left: auto;
  margin-right: auto;
  /* max-width: 740px; */
  width: 100%;
  padding: 15px 20px;
  caret-color: #000;
  outline-width: 0;
  font-size: 16px;
  padding-top: 0;
  margin-top: 25px;
  font-weight: 400;
}


.ProseMirror .is-empty::before {
  pointer-events: none;
  float: left;
  height: 0px;
  width: 100%;
  color: rgb(0 0 0 / 0.4);
}

ProseMirror.ProseMirror-focused>p.is-empty::before,
ProseMirror.ProseMirror-focused>p.has-focus.is-empty::before {
  content: 'Type  /  to browse options';
}

.ProseMirror.ProseMirror-focused>[data-type='columns']>[data-type='column']>p.is-empty.has-focus::before {
  content: 'Type  /  to browse options';
}

.ProseMirror>.is-editor-empty::before {
  content: attr(data-placeholder);
}

.ProseMirror>.is-editor-empty[data-placeholder='']::before,
.ProseMirror>.is-editor-empty:not([data-placeholder])::before {
  content: 'Type / to browse options';
}

.ProseMirror>[data-type="blockquoteFigure"].is-editor-empty::before {
  content: '';
}

.ProseMirror blockquote .is-empty:first-child:last-child::before {
  content: 'Enter a quote...';
}

.ProseMirror blockquote+figcaption.is-empty::before {
  content: 'Author';
}

.ProseMirror [data-placeholder][data-suggestion]::before,
.ProseMirror [data-placeholder][data-suggestion] *::before {
  content: none !important;
}

.ProseMirror .node-aiWriter.has-focus [data-node-view-wrapper]>*,
.ProseMirror .node-aiImage.has-focus [data-node-view-wrapper]>*,
.ProseMirror .node-tableOfContentsNode.has-focus [data-node-view-wrapper]>* {
  border-radius: 0.5rem;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 0 0 2px rgb(0 0 0 / 0.3);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror p {
  margin-top: 0.75rem;
  margin-bottom: 20px;
  line-height: 26px;
  font-size: 18px;
  font-weight: 400;
  color: #101828;
}

.ProseMirror p:first-child {
  margin-top: 0px;
}

.ProseMirror a {
  color: #3b82f6;
}

.ProseMirror a.link {
  font-weight: 500;
  color: rgb(59 130 246 / 1);
}

.ProseMirror>ul,
.ProseMirror>ol {
  margin-top: 0;
  margin-bottom: 1rem;
}

.ProseMirror ul ul,
.ProseMirror ul ol,
.ProseMirror ul li,
.ProseMirror ol ul,
.ProseMirror ol ol,
.ProseMirror ol li {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.ProseMirror ul p,
.ProseMirror ol p {
  margin-top: 0px;
  margin-bottom: 0.25rem;
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror ul[data-type='taskList'] {
  list-style-type: none;
  padding: 0px;
}

.ProseMirror ul[data-type='taskList'] li {
  display: flex;
}

.ProseMirror ul[data-type='taskList'] li[data-checked='true'] div p {
  text-decoration-line: line-through;
}

.ProseMirror ul[data-type='taskList'] li>label {
  margin-top: 5px;
  margin-right: 4px;
  flex: 1 1 auto;
  flex-shrink: 0;
  flex-grow: 0;
  -webkit-user-select: none;
  user-select: none;
}


.ProseMirror ul[data-type='taskList'] li>div {
  flex: 1 1 auto;
}

.ProseMirror ul[data-type='taskList'] p {
  margin: 0px;
}

.ProseMirror ul[data-type='taskList'] input {
  font-style: unset;
  font-weight: unset;
  font-size: unset;
  line-height: unset;
  color: unset;
  padding: unset;
  gap: unset;
  background: unset;
  box-shadow: unset;
  border-radius: unset;
  outline: unset;
  border: unset;
  width: unset;
}

.ProseMirror ul[data-type='taskList'] input {
  font-size: 0;
  width: 18px;
  height: 18px;
  border: 1px solid transparent;
  -o-appearance: none;
  appearance: none;
  position: relative;
  padding: 0 0 0 0;
  margin: 0;
}

.ProseMirror ul[data-type='taskList'] input:before {
  content: "";
  border: 1px solid black;
  display: block;
  width: 15px;
  background: none;
  height: 15px;
  margin-right: 7px;
  border-radius: 4px;
  min-width: 16px;
  min-height: 16px;
  margin-right: 15px;
  background-size: 60%;
  background-position: 4px center;
  background-repeat: no-repeat;
  accent-color: #e6f2ff;
}

.ProseMirror ul[data-type='taskList'] input[type="checkbox"]:checked:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  border: 1px solid black;
}

.ProseMirror b {
  font-weight: bolder;
}

.ProseMirror strong {
  font-weight: 700;
}

.ProseMirror code,
.ProseMirror kbd,
.ProseMirror samp,
.ProseMirror pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}

.ProseMirror h1 {
  font-size: 1.875rem;
  line-height: 2.25rem
}

.ProseMirror h2 {
  font-size: 1.5rem;
  line-height: 2rem
}

.ProseMirror h3 {
  font-size: 1.25rem;
  line-height: 1.75rem
}

.ProseMirror h4 {
  font-size: 1.125rem;
  line-height: 1.75rem
}

.ProseMirror h5 {
  font-size: 1rem;
  line-height: 1.5rem
}

.ProseMirror h6 {
  font-size: 0.875rem;
  line-height: 1.25rem
}

.ProseMirror h1,
.ProseMirror h2,
.ProseMirror h3,
.ProseMirror h4,
.ProseMirror h5,
.ProseMirror h6,
.ProseMirror h1 a.link,
.ProseMirror h2 a.link,
.ProseMirror h3 a.link,
.ProseMirror h4 a.link,
.ProseMirror h5 a.link,
.ProseMirror h6 a.link {
  font-weight: 700
}

.ProseMirror h1:first-child,
.ProseMirror h2:first-child,
.ProseMirror h3:first-child,
.ProseMirror h4:first-child,
.ProseMirror h5:first-child,
.ProseMirror h6:first-child {
  margin-top: 0px
}

.ProseMirror h1:last-child,
.ProseMirror h2:last-child,
.ProseMirror h3:last-child,
.ProseMirror h4:last-child,
.ProseMirror h5:last-child,
.ProseMirror h6:last-child {
  margin-bottom: 0px
}

.ProseMirror h1,
.ProseMirror h2,
.ProseMirror h3,
.ProseMirror h4,
.ProseMirror h5,
.ProseMirror h6 {
  margin-bottom: 20px;
  margin-top: 0;
  color: #000;
}

.ProseMirror>blockquote blockquote,
.ProseMirror [data-type='blockquoteFigure'] blockquote {
  margin: 0px;
}

.ProseMirror [data-type='blockquoteFigure'] blockquote p {
  font-weight: 500;
  font-size: 18px;
  color: #344054;
  margin: 10px 0 0;
}

.ProseMirror figure[data-type='blockquoteFigure'] {
  margin: 0 0 20px 0;
  color: rgb(0 0 0 / 1);
}

.ProseMirror [data-type='blockquoteFigure']>div {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border-left-width: 4px;
  border-left-color: var(--bg-green);
  --tw-bg-opacity: 0.8;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border-radius: 4px;
}

.ProseMirror [data-type='blockquoteFigure'] figcaption {
  margin-top: 1rem;
  overflow: hidden;
  font-size: 16px;
  color: rgb(115 115 115 / 1);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.ProseMirror [data-type='blockquoteFigure'] figcaption span {
  font-size: 16px !important;
  color: rgb(115 115 115 / 1) !important;
}

.ProseMirror blockquote .is-empty:not(.is-editor-empty):first-child:last-child::before {
  content: 'Enter a quote...';
}

.ProseMirror blockquote+figcaption.is-empty:not(.is-editor-empty)::before {
  content: 'Author';
}

.ProseMirror code {
  caret-color: white;
  color: white;
  background-color: #171717;

  border-radius: 0.125rem;

  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);

  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;

  line-height: 24px;
}

.ProseMirror code * {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  line-height: 24px;
}

.ProseMirror code::selection {
  background-color: rgba(255, 255, 255, 0.3);
}

.ProseMirror pre {
  caret-color: white;
  color: #f6f6f6;
  background: #282c34;
  border-radius: 0.375rem;
  margin: 0 0 20px 0;
  padding: 1rem;
  border: 1px solid black;
}

.ProseMirror pre *::selection {
  background-color: rgba(255, 255, 255, 0.2);
}

.ProseMirror pre code {
  color: #f6f6f6;
  background: #282c34;
  padding: 0;
  box-shadow: none;
}

.ProseMirror pre code .hljs-comment,
.ProseMirror pre code .hljs-quote {
  color: #a7a7a7;
  font-style: italic;
}

.ProseMirror pre code .hljs-doctag,
.ProseMirror pre code .hljs-keyword,
.ProseMirror pre code .hljs-formula {
  color: #c678dd;
}

.ProseMirror pre code .hljs-section,
.ProseMirror pre code .hljs-name,
.ProseMirror pre code .hljs-selector-tag,
.ProseMirror pre code .hljs-deletion,
.ProseMirror pre code .hljs-subst {
  color: #e06c75;
}

.ProseMirror pre code .hljs-literal {
  color: #56b6c2;
}

.ProseMirror pre code .hljs-string,
.ProseMirror pre code .hljs-regexp,
.ProseMirror pre code .hljs-addition,
.ProseMirror pre code .hljs-attribute,
.ProseMirror pre code .hljs-meta-string {
  color: #98c379;
}

.ProseMirror pre code .hljs-built_in,
.ProseMirror pre code .hljs-class .hljs-title {
  color: #e6c07b;
}

.ProseMirror pre code .hljs-attr,
.ProseMirror pre code .hljs-variable,
.ProseMirror pre code .hljs-template-variable,
.ProseMirror pre code .hljs-type,
.ProseMirror pre code .hljs-selector-class,
.ProseMirror pre code .hljs-selector-attr,
.ProseMirror pre code .hljs-selector-pseudo,
.ProseMirror pre code .hljs-number {
  color: #d19a66;
}

.ProseMirror pre code .hljs-symbol,
.ProseMirror pre code .hljs-bullet,
.ProseMirror pre code .hljs-link,
.ProseMirror pre code .hljs-meta,
.ProseMirror pre code .hljs-selector-id,
.ProseMirror pre code .hljs-title {
  color: #61aeee;
}

.ProseMirror pre code .hljs-emphasis {
  font-style: italic;
}

.ProseMirror pre code .hljs-strong {
  font-weight: bold;
}

.ProseMirror pre code .hljs-link {
  text-decoration: underline;
}

.ProseMirror .tableWrapper {
  margin-top: 0;
  margin-bottom: 20px;
}

.ProseMirror table {
  box-sizing: border-box;
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border-radius: 0.25rem;
  border-color: rgba(0, 0, 0, 0.1);
}

.ProseMirror table::-webkit-scrollbar,
.ProseMirror table::-webkit-scrollbar-track,
.ProseMirror table::-webkit-scrollbar-thumb {
  cursor: pointer;
}

.tiptop-editor .tableWrapper:has(.ProseMirror-widget) table {
  padding: 10px 0 0 10px;
}

.ProseMirror table td,
.ProseMirror table th {
  position: relative;
  min-width: 150px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.1);
  padding: 0.5rem;
  text-align: left;
  vertical-align: top;
}

.ProseMirror table td:first-of-type:not(a),
.ProseMirror table th:first-of-type:not(a) {
  margin-top: 0px;
}

.ProseMirror table td p,
.ProseMirror table th p {
  margin: 0px;
}

.ProseMirror table td p+p,
.ProseMirror table th p+p {
  margin-top: 0.75rem;
}

.ProseMirror table th {
  font-weight: 700;
}

.ProseMirror table .column-resize-handle {
  pointer-events: none;
  position: absolute;
  bottom: -2px;
  right: -0.25rem;
  top: 0px;
  display: flex;
  width: 0.5rem;
}

.ProseMirror table .column-resize-handle::before {
  margin-left: 0.5rem;
  height: 100%;
  width: 1px;
  background-color: rgba(0, 0, 0, 0.2);
  content: '';
}

.ProseMirror table .selectedCell {
  border-style: double;
  border-color: rgba(0, 0, 0, 0.2);
  background-color: rgba(0, 0, 0, 0.05);
}

.ProseMirror table .grip-column,
.ProseMirror table .grip-row {
  position: absolute;
  z-index: 10;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.05);
}

.ProseMirror table .grip-column {
  left: 0px;
  top: -0.75rem;
  margin-left: -1px;
  height: 0.75rem;
  width: calc(100% + 1px);
  border-left-width: 1px;
  border-color: rgba(0, 0, 0, 0.2);
}

.ProseMirror table .grip-column:hover::before,
.ProseMirror table .grip-column.selected::before {
  content: '';
  width: 0.625rem;
}

.ProseMirror table .grip-column:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.ProseMirror table .grip-column:hover::before {
  border-bottom-width: 2px;
  border-style: dotted;
  border-color: rgba(0, 0, 0, 0.6);
}

.ProseMirror table .grip-column.first {
  border-top-left-radius: 0.125rem;
  border-color: transparent;
}

.ProseMirror table .grip-column.last {
  border-top-right-radius: 0.125rem;
}

.ProseMirror table .grip-column.selected {
  border-color: rgba(0, 0, 0, 0.3);
  background-color: rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.ProseMirror table .grip-column.selected::before {
  border-bottom-width: 2px;
  border-style: dotted;
}

.ProseMirror table .grip-row {
  left: -0.75rem;
  top: 0px;
  margin-top: -1px;
  height: calc(100% + 1px);
  width: 0.75rem;
  border-top-width: 1px;
  border-color: rgba(0, 0, 0, 0.2);
}

.ProseMirror table .grip-row:hover::before,
.ProseMirror table .grip-row.selected::before {
  height: 0.625rem;
  content: '';
}

.ProseMirror table .grip-row:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.ProseMirror table .grip-row:hover::before {
  border-left-width: 2px;
  border-style: dotted;
  border-color: rgba(0, 0, 0, 0.6);
}

.ProseMirror table .grip-row.first {
  border-top-left-radius: 0.125rem;
  border-color: transparent;
}

.ProseMirror table .grip-row.last {
  border-bottom-left-radius: 0.125rem;
}

.ProseMirror table .grip-row.selected {
  border-color: rgba(0, 0, 0, 0.3);
  background-color: rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.ProseMirror table .grip-row.selected::before {
  border-left-width: 2px;
  border-style: dotted;
}

.ProseMirror [data-type='horizontalRule'] {
  margin-bottom: 20px;
  cursor: pointer;
  /* padding-top: 1rem;
  padding-bottom: 1rem; */
  transition-property: all;
  transition-duration: 100ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  animation-duration: 100ms;
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.ProseMirror [data-type='horizontalRule'].ProseMirror-selectednode {
  background-color: rgb(0 0 0 / 0.05);
}

.ProseMirror [data-type='horizontalRule'] hr {
  border-width: 0px;
  border-top-width: 1px;
  border-color: rgb(0 0 0 / 0.2);
  background-color: rgb(0 0 0 / 0.8);
}

.ProseMirror [data-type='horizontalRule'].ProseMirror-selectednode hr {
  border-top-color: rgb(0 0 0 / 0.3);
}

.ProseMirror>*:first-child:first-child,
.ProseMirror [data-type='column']>*:first-child {
  margin-top: 0px;
}

.ProseMirror>*:first-child:last-child,
.ProseMirror [data-type='column']>*:last-child {
  margin-bottom: 0px;
}

.ProseMirror [data-type='column'] {
  border-radius: 0.25rem;
  border-width: 2px;
  border-style: dotted;
  border-color: transparent;
  padding: 0.25rem;
  transition: border 160ms cubic-bezier(0.45, 0.05, 0.55, 0.95);
}

.ProseMirror [data-type='column']:hover {
  border-color: rgb(245 245 245 / 1);
}

.ProseMirror [data-type='column']:has(.is-active),
.ProseMirror [data-type='column'].has-focus {
  border-color: rgb(245 245 245 / 1);
}

.ProseMirror [data-type='columns'] {
  margin-bottom: 20px;
  display: grid;
  gap: 1rem;
}

.ProseMirror [data-type='columns'].layout-sidebar-left {
  grid-template-columns: 40fr 60fr;
}

.ProseMirror [data-type='columns'].layout-sidebar-right {
  grid-template-columns: 60fr 40fr;
}

.ProseMirror [data-type='columns'].layout-two-column {
  grid-template-columns: 1fr 1fr;
}

.ProseMirror [data-type='columns'].layout-three-column {
  grid-template-columns: repeat(3, 1fr);
}

.ProseMirror [data-type='column'] {
  overflow: auto;
}

[data-type="columns"] [data-type="column"]>* {
  padding: 5px 0;
}

[data-type="columns"] [data-type="column"] p.is-empty:before {
  content: 'Type  /  to browse options';
}

[data-type="columns"] p,
[data-type="columns"] [data-type="imageBlock"] .image-block {
  margin-top: 0;
}

.tiptop-editor ul,
.tiptop-editor li {
  list-style-type: unset;
}

.tiptop-editor ul,
.tiptop-editor ol {
  padding-inline-start: 20px;
}

.tiptop-editor ul li::marker {
  color: var(--bg-green);
}

.tiptop-editor ul[data-type="taskList"] {
  padding-inline-start: 0px !important;
}

ul[data-type="taskList"]::before,
.tiptop-editor ol::before,
.tiptop-editor ul::before {
  content: '' !important;
  pointer-events: unset !important;
  float: unset !important;
  height: unset !important;
  width: unset !important;
  color: unset !important;
}

.layout-two-column::before,
.layout-sidebar-left::before,
.layout-sidebar-right::before {
  pointer-events: none !important;
  float: unset !important;
  height: unset !important;
  width: unset !important;
  color: unset !important;
  content: unset !important;
}

::-webkit-scrollbar {
  height: 0.25rem;
  width: 0.25rem;
  background-color: rgb(115 115 115 / 0.2);
}

::-webkit-scrollbar-thumb {
  border-radius: 9999px;
  background-color: rgb(115 115 115 / 0.5);
}

.tiptop-editor .bubble-menu {
  color: #000;
  display: inline-flex;
  height: 100%;
  line-height: 1;
  gap: 0.125rem;
  flex-direction: row;
  padding: 0.25rem;
  align-items: center;
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.tiptop-editor .bubble-menu .divider {
  background-color: #e5e7eb;
  height: 100%;
  min-height: 1.5rem;
  width: 1px;
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.tiptop-editor .bubble-menu button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  height: 2rem;
  min-width: 2rem;
  padding: 0 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 0.375rem;
  background-color: transparent;
  border: 1px solid transparent;
  color: #6b7280;
  white-space: nowrap;
  cursor: pointer;
}

.tiptop-editor .bubble-menu .bubble-menu-item {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 0.375rem;
  opacity: 1;
  white-space: nowrap;
  background-color: rgba(0, 0, 0, 0.1);
  color: #1f2937;
  height: 2rem;
  gap: 0.25rem;
  min-width: 2rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  width: auto;
}

.tiptop-editor .bubble-menu button:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: #374151;
}

.tiptop-editor .toolbar-button>div {
  line-height: 0;
}

.tiptop-editor .toggle-menu {
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: .7rem;
  box-shadow: 3px 2px 5px 2px hsla(0, 0%, 47%, .239);
  display: inline-grid;
  padding: 1rem .5rem;
  position: absolute;
  top: 40px;
}

.tiptop-editor .bubble-toggle-menu {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.5rem 0.5rem;
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
  position: absolute;
  top: 40px;
  min-width: 9rem;
}

.tiptop-editor .bubble-toggle-menu .font-label {
  font-size: 0.65rem;
  font-weight: 600;
  margin: 0.25rem 0;
  text-transform: uppercase;
  color: #6b7280;
  padding: 0 0.375rem;
}

.tiptop-editor .bubble-toggle-menu button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #6b7280;
  text-align: left;
  background-color: transparent;
  width: 100%;
  border: 0;
  border-radius: 0.375rem;
  cursor: pointer;
}

.tiptop-editor .bubble-toggle-menu button.is-active,
.tiptop-editor .bubble-toggle-menu button:hover {
  background-color: #f3f4f6;
  color: #1f2937;
}

.tiptop-editor .bubble-toggle-menu.link-box {
  position: relative;
  top: 0;
  padding: 0.5rem;
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.tiptop-editor .bubble-toggle-menu.link-box form {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.tiptop-editor .bubble-toggle-menu.link-box .url-box {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  border-radius: 0.5rem;
  background-color: #f3f4f6;
  cursor: text;
}

.tiptop-editor .bubble-toggle-menu.link-box input {
  flex: 1 1;
  background-color: transparent;
  outline: none;
  min-width: 12rem;
  color: #000;
  font-size: 0.875rem;
  border: 0;
  padding: 0;
}

.tiptop-editor .bubble-toggle-menu.link-box .setlinkBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 0.375rem;
  padding: 0.25rem 0.5rem;
  border: 1px solid #000;
  color: #fff;
  background-color: #000;
  white-space: nowrap;
  height: 34px;
}

.tiptop-editor .bubble-toggle-menu.link-box .setlinkBtn:disabled {
  opacity: 0.5;
}

.tiptop-editor .bubble-toggle-menu .toggle-button-label {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  color: #6b7280;
  margin-top: 10px;
}

.tiptop-editor .bubble-toggle-menu .toggle-button {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid transparent;
  background-color: #e5e7eb;
  cursor: pointer;
  transition: background-color 0.2s ease;
  height: 1.25rem;
  width: 2.25rem;
  padding: 0 0.125rem;
}

.tiptop-editor .bubble-toggle-menu .toggle-button:hover {
  background-color: #d1d5db;
}

.tiptop-editor .bubble-toggle-menu .toggle-button.checked {
  background-color: #000;
}

.tiptop-editor .bubble-toggle-menu .toggle-button.checked:hover {
  background-color: #374151;
}

.tiptop-editor .bubble-toggle-menu .toggle-button span {
  display: block;
  border-radius: 9999px;
  pointer-events: none;
  background-color: #fff;
  height: 1rem;
  width: 1rem;
  transform: translateX(-0.5rem);
  transition: transform 0.2s ease;
}

.tiptop-editor .bubble-toggle-menu .toggle-button.checked span {
  transform: translateX(0.5rem);
}

.tiptop-editor .bubble-toggle-menu.button-box {
  padding: 1rem;
  min-width: 18rem;
}

.tiptop-editor .bubble-toggle-menu.button-box .alignment-buttons {
  padding: 0.25rem;
  margin-top: 0.5rem;
  display: flex;
  flex-direction: row;
  margin: 0;
  gap: 6px;
  background-color: #EAECF0;
  border-radius: 6px;
}

.tiptop-editor .bubble-toggle-menu.button-box .alignment-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.tiptop-editor .bubble-toggle-menu.button-box .box-title {
  margin: 0;
}

.tiptop-editor .bubble-toggle-menu.button-box .alignment-buttons button {
  width: auto;
}

.tiptop-editor .bubble-toggle-menu.button-box label {
  font-size: 14px;
  font-weight: 500;
}

.tiptop-editor .bubble-toggle-menu.button-box input[type="text"] {
  flex: 1 1;
  background-color: #f3f4f6;
  outline: none;
  min-width: 12rem;
  color: #101828;
  font-size: 14px;
  border: 0;
  height: 45px;
  border-radius: 6px;
  padding: 10px 14px;
  margin-top: 4px;
  width: 100%;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  line-height: 24px;
}

.tiptop-editor .bubble-toggle-menu .text-box input[type="text"].button-url {
  padding-left: 32px;
}

.tiptop-editor .bubble-toggle-menu.button-box #publication-count {
  background: #fff;
  margin-bottom: 5px;
}

.button-box .submit-button {
  text-align: right;
  margin-top: 12px;
}

.tiptop-editor .button-box .submit-button button {
  width: auto;
}

.tiptop-editor .bubble-toggle-menu.button-box .url-block {
  position: relative;
}

.tiptop-editor .bubble-toggle-menu.button-box .url-block::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 100%;
  width: 16px;
  height: 16px;
  position: absolute;
  left: 10px;
  top: 39px;
}

.tiptop-editor .url-block .text-box .button-url {
  padding-left: 32px;
}

.tiptop-editor .link-panel {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background-color: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.tiptop-editor .link-panel a {
  font-size: 0.875rem;
  text-decoration: underline;
}

.tiptop-editor .link-panel .divider {
  background-color: #e5e7eb;
  height: 100%;
  min-height: 1.5rem;
  width: 1px;
  margin: 0 0.25rem;
}

.tiptop-editor .link-panel button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 0.375rem;
  opacity: 1;
  white-space: nowrap;
  background-color: transparent;
  color: #6b7280;
  height: 2rem;
  gap: 0.25rem;
  min-width: 2rem;
  padding: 0 0.5rem;
  width: auto;
  cursor: pointer;
}

.tiptop-editor .link-panel button.active {
  background-color: rgba(0, 0, 0, 0.1);
  color: #1f2937;
}

.tiptop-editor .toolbar-button.active,
.tiptop-editor .bubble-toggle-menu button:hover {
  background-color: #ffffff;
  color: #1f2937;
}

.tiptop-editor .link-panel button:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: #374151;
}

.tiptop-editor .toolbar-button>div {
  line-height: 0;
}

.tiptop-editor .content-type-menu {
  position: absolute;
  left: 0;
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 1rem 0.5rem;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.tiptop-editor .content-type-menu .content-type-menu-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  padding: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #6b7280;
  text-align: left;
  background-color: transparent;
  width: 100%;
  border-radius: 0.375rem;
}

.tiptop-editor .content-type-menu .content-type-menu-item div {
  line-height: 0;
}

.tiptop-editor .content-type-menu .content-type-menu-item.active,
.tiptop-editor .content-type-menu .content-type-menu-item:hover {
  background-color: #f3f4f6;
  color: #111827;
}

.tiptop-editor .content-type-menu .content-type-menu-title {
  font-size: 0.65rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
  margin-top: 0.5rem;
  text-transform: uppercase;
  color: #6b7280;
  padding: 0 0.375rem;
}

.tiptop-editor .content-type-menu .content-type-menu-title:first-child,
.tiptop-editor table tr td ol {
  margin-top: 0;
}

.tiptop-editor .ai-menu {
  position: absolute;
  left: 0;
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 1rem 0.5rem;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.tiptop-editor .ai-menu .ai-menu-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  padding: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #6b7280;
  text-align: left;
  background-color: transparent;
  width: 100%;
  border-radius: 0.375rem;
}

.tiptop-editor .ai-menu .ai-menu-item div {
  line-height: 0;
}

.tiptop-editor .ai-menu .ai-menu-item:hover {
  background-color: #f3f4f6;
  color: #111827;
}

.tiptop-editor .colorpicker-wrapper {
  position: absolute;
  background-color: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
  padding: 0.25rem;
  margin-top: 0.5rem;
  min-width: 16.3rem;
}

.tiptop-editor .colorpicker-cover {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  /* 2 x 0.25rem (8px) */
}

.colorpicker-cover .react-colorful {
  width: auto;
}

.tiptop-editor .colorpicker-input {
  width: 100%;
  padding: 0.5rem;
  /* 2 x 0.25rem (8px) */
  color: #000;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.25rem;
  /* 4px */
}

.tiptop-editor .colorpicker-input:focus {
  outline: 1px solid #d1d5db;
}

.tiptop-editor .colorpicker-buttons {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
  /* 1 x 0.25rem (4px) */
}

.tiptop-editor .colorpicker-buttons .colorpicker-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.375rem;
  /* 6px */
  border-radius: 0.375rem;
  /* 6px */
}

.tiptop-editor .colorpicker-buttons .colorpicker-button:hover,
.tiptop-editor .colorpicker-buttons .colorpicker-button.active {
  background-color: #f5f5f5;
}

.tiptop-editor .colorpicker-buttons .colorpicker-button>div {
  width: 1rem;
  /* 4px */
  height: 1rem;
  /* 4px */
  border-radius: 0.25rem;
  /* 4px */
  background-color: #f1f5f9;
  /* slate-100 */
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  /* shadow-sm */
  outline-offset: 0.125rem;
  /* 2px */
  outline-color: currentColor;
  /* ring-current */
}

.tiptop-editor .colorpicker-buttons .colorpicker-button>div:hover .tiptop-editor .colorpicker-buttons .colorpicker-button>div.active {
  outline-width: 1px;
}

.tiptop-editor .moreoptions-wrapper {
  position: absolute;
  right: -40%;
  bottom: -90%;
  background-color: #ffffff;
  border-radius: 0.5rem;
  /* 8px */
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
  /* neutral-200 */
  padding: 0.25rem;
  /* 4px */
  margin-top: 0.5rem;
  /* 8px */
  display: flex;
  flex-direction: row;
}

.tiptop-editor .tablerow-menu {
  color: #000000;
  /* text-black */
  display: inline-flex;
  height: 100%;
  line-height: 1;
  gap: 0.125rem;
  /* 0.5 */
  flex-direction: column;
  padding: 0.5rem;
  /* 2 */
  background-color: #ffffff;
  /* bg-white */
  border-radius: 0.5rem;
  /* rounded-lg */
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  /* shadow-sm */
  border: 1px solid #e5e7eb;
  /* border-neutral-200 */
}

.tiptop-editor .tablerow-menu .tablerow-menu-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #71717a;
  text-align: left;
  background-color: transparent;
  width: 100%;
  border-radius: 0.375rem;
}

.tiptop-editor .tablerow-menu .tablerow-menu-item:hover {
  background-color: #f5f5f5;
  color: #1f2937;
}

.tiptop-editor .node-tableOfContentsNode.ProseMirror-selectednode .TableOfContentsWrapper {
  border-radius: 0.5rem;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 0 0 2px rgb(0 0 0 / 0.3);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.tiptop-editor .TableOfContentsWrapper {
  padding: 0.5rem;
  margin: 0;
  border-radius: 0.5rem;
}

.tiptop-editor .TableOfContentsTitle {
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  color: #6b7280;
  /* Neutral 500 */
  font-size: 14px;
}

.tiptop-editor .TableOfContentsCover {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  overflow-x: hidden;
}

.tiptop-editor .TableOfContentsCover .TableOfContentsItem {
  display: block;
  font-weight: 500;
  color: #6b7280;
  /* neutral-500 */
  padding: 0.25rem;
  border-radius: 0.25rem;
  font-size: 16px;
  /* text-sm */
  transition: all 0.3s;
  /* width: 100%; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: none;
}

.tiptop-editor .TableOfContentsCover .TableOfContentsItem:hover {
  color: #1f2937;
  /* neutral-800 */
  /* background-color: rgba(0, 0, 0, 0.05); */
}

.tiptop-editor .TableOfContentsWrapper .TableOfContentsNoData {
  font-size: 0.875rem;
  /* text-sm */
  color: #6b7280;
  /* neutral-500 */
}

.tiptop-editor .DragHandleItems {
  display: flex;
  align-items: center;
  gap: 0.125rem;
  background-color: transparent;
}

.DragHandleItems.d-none {
  display: none;
}

.DragHandleItems .DragHandleItem {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  font-size: 0.875rem;
  /* equivalent to text-sm */
  font-weight: 600;
  /* equivalent to font-semibold */
  border-radius: 0.375rem;
  /* equivalent to rounded-md */
  opacity: 1;
  white-space: nowrap;
  background-color: transparent;
  color: #737373;
  /* equivalent to text-neutral-500 */
  height: 2rem;
  gap: 0.30rem;
  /* equivalent to gap-1 */
  width: 2rem;
  cursor: pointer;
}

.DragHandleItems .DragHandleItem:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: #3f3f46;
}

.DragHandleItems .DragHandleItem svg,
.DragHandleSubItems .DragHandleSubItem svg,
.menulist-wrapp .menu-label svg {
  width: 1rem;
  height: 1rem;
}

.DragHandleItems .DragHandleItem svg {
  width: 2rem;
}

.DragHandleSubItems {
  position: fixed;
  left: 0px;
  top: 0px;
  transform: translate(36px, 40px);
  min-width: max-content;
  --radix-popper-transform-origin: 0% 0px;
  z-index: auto;
  --radix-popper-available-width: 1346px;
  --radix-popper-available-height: 383px;
  --radix-popper-anchor-width: 34px;
  --radix-popper-anchor-height: 32px;
}

.DragHandleSubItems .DragHandleSubItemsWrapp {
  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05);
  padding: 0.5rem;
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 0.5rem;
  min-width: 12rem;
  display: flex;
  flex-direction: column;
}

.DragHandleSubItems .DragHandleSubItem {
  -webkit-appearance: button;
  background-color: transparent;
  background-image: none;
  cursor: pointer;
  text-transform: none;

  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #737373;
  text-align: left;
  background-color: transparent;
  border-radius: 0.25rem;
}

.DragHandleSubItems .DragHandleSubItem.dangerItem {
  color: #ef4444;
  background-color: rgba(239, 68, 68, 0.1);
}

.DragHandleSubItems .DragHandleSubItem:hover {
  background-color: #f5f5f5;
  color: #1f2937;
}

.DragHandleSubItems .DragHandleSubItem.dangerItem:hover {
  background-color: rgba(239, 68, 68, 0.2);
}

.DragHandleSubItems .sunItemSivider {
  background-color: #e5e5e5;
  width: 100%;
  min-width: 1.5rem;
  height: 1px;
  margin-bottom: 0.4rem;
}

.menulist-container {
  color: #000000;
  max-height: min(80vh, 24rem);
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 2rem;
  padding: 0.5rem;
  background-color: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e5e5;
  min-width: 12rem;
}

.menulist-wrapp {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 0.125rem;
  width: 100%;
}

.menulist-wrapp .menu-title {
  color: #6b7280;
  font-size: 0.65rem;
  grid-column: 1 / -1;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  margin-top: 1rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  -webkit-user-select: none;
          user-select: none;
  text-transform: uppercase;
  width: 100%;
}

.menulist-wrapp .menu-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #0A0A0A;
  text-align: left;
  background-color: transparent;
  width: 100%;
  border-radius: 0.25rem;
  cursor: pointer;
}

.menulist-wrapp .menu-label div {
  line-height: 0;
}

.menulist-wrapp .menu-label.active,
.menulist-wrapp .menu-label:hover {
  background-color: #f9f9f9;
  color: #1f2937;
}

.ProseMirror [data-type='button'] {
  padding: 12px;
  border: 1px solid #ffffff;
  border-radius: 6px;
  cursor: default;
}

.ProseMirror [data-type='button'].ProseMirror-selectednode {
  border-color: #573CFF;
}

.button-element.align-left {
  text-align: left;
}

.button-element.align-center {
  text-align: center;
}

.button-element.align-right {
  text-align: right;
}

.tiptop-editor .button-element button,
.tiptop-editor .button-element a {
  background-color: #55883D;
  border: 1px solid #55883D;
  border-radius: 6px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  line-height: 28px;
  padding: 5px 10px;
  transition: all .3s linear;
}

.button-element.width-full button {
  width: 100%;
}

.button-element.width-auto button {
  width: auto;
}

/* book mark section */
.tiptop-editor .bookmark-node-wrapper,
.vimeo-node-wrapper,
.other-node-wrapper,
.twitter-node-wrapper,
.spotify-node-wrapper,
.soundcloud-node-wrapper,
.publications-wrapper {
  position: relative;
  margin-top: 0;
}

.twitter-node-wrapper .none,
.spotify-node-wrapper .none,
.soundcloud-node-wrapper .none,
.other-node-wrapper .none {
  display: none;
}

.tiptop-editor .bookmark-node-wrapper label,
.twitter-node-wrapper label,
.spotify-node-wrapper label,
.soundcloud-node-wrapper label {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #0a2540;
  margin-bottom: 5px !important;
}

.tiptop-editor .bookmark-node-wrapper .urlInputLeft,
.vimeo-node-wrapper .urlInput,
.tiptop-editor .other-node-wrapper .urlInput,
.twitter-node-wrapper .urlInputLeft,
.tiptop-editor .spotify-node-wrapper .urlInputLeft,
.tiptop-editor .soundcloud-node-wrapper .urlInputLeft {
  padding: 8px 12px;
  gap: 8px;
  height: 45px;
  width: 100%;
  background: #ffffff;
  border: 1px solid #573CFF;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 6px;
  outline: none;
  margin-top: 10px;
  margin-bottom: 10px;
  padding-left: 40px;
  font-size: 14px;
  color: #000;
}

.tiptop-editor .other-urlInput .urlInput.embedCode {
  padding: 10px 10px 10px 40px;
  width: 100%;
  min-height: 120px;
  resize: vertical;
  font-size: 16px;
  line-height: 26px;
}

.embed-code iframe {
  max-width: 100%;
}

.tiptop-editor .bookmark-node-wrapper svg,
.vimeo-node-wrapper svg,
.other-node-wrapper svg,
.twitter-node-wrapper svg,
.spotify-node-wrapper svg,
.soundcloud-node-wrapper svg {
  position: absolute;
  top: 0.8rem;
  left: 14px;
  width: 20px;
}

.other-node-wrapper svg {
  top: 0.99rem !important;
}

.twitter-node-wrapper svg,
.spotify-node-wrapper svg,
.soundcloud-node-wrapper svg,
.vimeo-node-wrapper svg {
  top: 1.4rem !important;
}

.tiptop-editor .bookmark-node-wrapper svg {
  top: 1.5rem;
}

.tiptop-editor .bookmark-node-wrapper .linkbutton-loader,
.vimeo-node-wrapper .linkbutton-loader,
.tiptop-editor .other-node-wrapper .linkbutton-loader,
.tiptop-editor .twitter-node-wrapper .linkbutton-loader,
.tiptop-editor .spotify-node-wrapper .linkbutton-loader,
.tiptop-editor .soundcloud-node-wrapper .linkbutton-loader {
  min-width: 100%;
  padding: 8px 12px;
  gap: 8px;
  height: 45px;
  width: 100%;
  background: #ffffff;
  border: 1px solid #eaecf0;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 6px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.tiptop-editor .bookmark-node-wrapper .ring-loader,
.vimeo-node-wrapper .ring-loader,
.tiptop-editor .other-node-wrapper .ring-loader,
.twitter-node-wrapper .ring-loader,
.tiptop-editor .spotify-node-wrapper .ring-loader,
.tiptop-editor .soundcloud-node-wrapper .ring-loader,
.publications-wrapper .ring-loader {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  position: absolute;
  margin: 7px auto;
  top: 6px;
  left: 0;
  right: 0;
  animation: rotate 1s linear infinite;
}

.publications-wrapper .ring-loader {
  top: 2px !important;
}

.tiptop-editor .bookmark-node-wrapper .ring-loader:before,
.vimeo-node-wrapper .ring-loader:before,
.tiptop-editor .other-node-wrapper .ring-loader:before,
.twitter-node-wrapper .ring-loader:before,
.tiptop-editor .spotify-node-wrapper .ring-loader:before,
.tiptop-editor .soundcloud-node-wrapper .ring-loader:before,
.publications-wrapper .ring-loader:before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  inset: 0px;
  border-radius: 50%;
  border: 3px solid black;
  animation: prixClipFix 2s linear infinite;
  top: 0;
}

#widget .privacyPolicy {
  display: none !important;
}

.tiptop-editor .twitter-node-wrapper .twitter-embed,
.tiptop-editor .node-urlPaste .twitter-node-wrapper.twitter-block .twitter-tweet {
  width: 100%;
  max-width: 550px;
  margin: 20px auto !important;
}

.twitter-node-wrapper .twitter-embed .twitter-tweet-rendered {
  margin-top: 1.5rem !important;
}

.spotifyEmbed iframe {
  border-radius: 0.5rem !important;
}

.spotifyEmbed[data-spotify-type="track"] iframe {
  max-height: 232px;
}

.spotifyEmbed[data-spotify-type="episode"] iframe {
  max-height: 352px;
}

.tiptop-editor .bookmark-node-wrapper .ring-loader.dark:before,
.vimeo-node-wrapper .ring-loader.dark:before,
.other-node-wrapper .ring-loader.dark:before,
.publications-wrapper .ring-loader.dark:before {
  border: 3px solid #868c98;
}

.video-section {
  margin: 20px 0;
}

.tiptop-editor .linkBox {
  display: flex;
  box-shadow: none;
  align-items: center;
  border: 1px solid #8080805c;
  border-radius: 0;
  padding: 15px;
}

.tiptop-editor .node-bookmarkBlock .link-content {
  margin: 15px 0;
}

.tiptop-editor .link-content a {
  text-decoration: none;
}

.tiptop-editor .link-content img {
  width: 100%;
  height: 90px;
  object-fit: cover;
  border-radius: 0;
}

.tiptop-editor .textBlock.linkBox .linkImageSection {
  display: flex;
  align-items: center;
  width: 90px !important;
  height: auto;
}

.tiptop-editor .linkBox .linkData {
  width: calc(100% - 90px);
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 15px;
  padding-left: 15px;
}

.tiptop-editor .link-content p.linkDataTitle {
  color: #101828;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 0;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.tiptop-editor .link-content .linkDataDiscripation {
  display: none;
}

.tiptop-editor .link-content .siteData {
  display: flex;
  align-items: center;
  width: 100%;
}

.tiptop-editor .link-content .siteData.siteUrl {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tiptop-editor .linkData .siteData:nth-child(3) {
  margin-top: -10px;
}

.tiptop-editor .link-content .siteData img {
  margin-right: 6px;
  border-radius: 0;
  object-fit: unset;
  width: 18px;
  height: 18px;
}

.tiptop-editor .link-content .siteData p {
  margin: 0;
  font-size: 14px;
  color: #475467;
}

.tiptop-editor .error-message {
  font-size: 14px;
  color: #d92d20;
  display: block;
  margin-top: 0px !important;
}

.video-wrapper .error-message {
  margin: 5px !important;
}

.tiptop-editor .video-wrapper .video-caption,
.gallery-block .video-caption {
  min-height: 24px;
  text-align: left;
  margin-bottom: 0 !important;
  border: none;
  box-shadow: none;
  outline: none;
  font-size: 14px;
}

.tiptop-editor .video-wrapper .video-caption:empty:before {
  pointer-events: none;
  float: left;
  height: 0px;
  width: 100%;
  color: rgb(0 0 0 / 0.4);
  content: 'Write a caption for the video (optional)';
  line-height: 26px;
}

.tiptop-editor .file-block .file-detail .file-caption:empty:before {
  pointer-events: none;
  float: left;
  height: 0px;
  width: 100%;
  color: rgb(0 0 0 / 0.4);
  content: 'Write a caption for the file (optional)';
  line-height: 26px;
}

.youtube-video,
.vimeo-video {
  font-size: 14px;
  /* border: 1px solid #573CFF;
  border-radius: 6px; */
  background-color: #fff;
  color: #101828;
  margin-bottom: 20px;
}

.toolbar-button .menu-icon {
  margin-top: 2px;
}

.toolbar-button .font-size-picker {
  font-weight: 600;
  color: #6b7280;
}

.player-wrapper {
  display: none;
}

.player-wrapper.player-ready {
  display: block;
  position: relative;
  padding-top: 56.25%;
  border-radius: 6px;
  overflow: hidden;
}

.player-wrapper.player-ready .react-player {
  position: absolute;
  top: 0;
  left: 0;
}

.tiptop-editor .image-preview .player-wrapper.player-ready {
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  line-height: 0;
  overflow: hidden;
  height: 350px;
  display: block;
  margin-bottom: 0;
  border-radius: 0;
}

.tiptop-editor .node-vimeoBlock .player-wrapper.player-ready,
.tiptop-editor .video-wrapper.youtube-video .player-wrapper.player-ready {
  margin: 0 !important;
}

.tiptop-editor [data-type='video'] .video-wrapper .player-wrapper.player-ready {
  height: auto;
  min-height: 300px;
}

.tiptop-editor .video-title {
  padding: 5px 0;
  outline: none;
}

.node-youtubeBlock .video-wrapper.youtube-video .video-title {
  padding-top: 0;
}

.toolbar-button .content-icon {
  margin-top: 3px;
}

.tiptop-editor .video-wrapper .skeleton-video-wrapper {
  position: relative;
  padding-top: 56.25%;
}

.tiptop-editor .video-wrapper .skeleton-video {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: #ececee;
  border-radius: 6px 6px 0 0;
  animation: loading 1.5s infinite;
}

.tiptop-editor .node-vimeoBlock .video-wrapper.vimeo-video .video-title {
  margin-top: -6px !important;
}

.tiptop-editor .node-vimeoBlock .video-wrapper.vimeo-video .player-wrapper.player-ready {
  margin-top: -1px;
}


/* publication */
.tiptop-editor .publication-list.list .publication-item {
  display: flex;
  align-items: flex-start;
  margin-top: 20px;
}

.tiptop-editor .publication-list.list .publication-item:first-child {
  margin-top: 0 !important;
}

.tiptop-editor .publication-list.list .publication-data {
  padding-left: 15px;
  width: calc(100% - 25%);
  font-size: 14px;
}

.tiptop-editor .publications-wrapper .publication-title.two-line {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.ProseMirror .publications-wrapper a {
  pointer-events: none;
  cursor: pointer;
  color: #000;
  text-decoration: none;
  font-weight: 700;
}

.tiptop-editor .publications-wrapper .publication-description.four-line {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  margin-top: 0;
  margin-bottom: 5px;
  font-size: 14px;
  line-height: 22px;
}

.tiptop-editor .publications-wrapper .publication-title {
  margin-bottom: 0;
  line-height: 22px;
  font-size: 18px;
  font-weight: 400;
  color: #101828;
}

.tiptop-editor .publications-wrapper .publication-list.list .publication-image {
  width: 25%;
  border-radius: 6px;
  line-height: 0;
}

.tiptop-editor .publications-wrapper .publication-image img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
}

.alignment-box .menu-title.layout-title {
  margin-bottom: 0;
}

.tiptop-editor .publications-wrapper .publication-list.list {
  display: block;
}

.tiptop-editor .node-publications .publications-wrapper,
.tiptop-editor .node-products .products-node-wrapper {
  margin-left: -14px;
  margin-right: -14px;
}

.tiptop-editor .node-publications .publication-list {
  /*border: 1px solid #573CFF;*/
  border-radius: 6px;
  padding: 14px;
}

.publication-image img {
  width: 100%;
  height: auto;
}

.tiptop-editor .node-publications .publication-list.grid {
  display: grid;
  align-items: start;
  column-gap: 12px;
  row-gap: 25px;
  grid-template-columns: repeat(3, minmax(0px, 1fr));
}

.publication-list .publication-date {
  font-size: 16px;
  padding: 10px 0 0;
  color: #101828;
}

.tiptop-editor .categories-box .categories-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #d0d5dd;
  background: #fff;
  padding: 10px 14px;
  border-radius: 6px;
  margin: 5px 0;
  cursor: pointer;
  height: 46px;
  font-weight: 400;
  color: #101828;
}

.tiptop-editor .bubble-toggle-menu.button-box .categories-box .select-categories {
  font-size: 14px;
  color: #101828;
  line-height: 24px;
}

.tiptop-editor .publications-wrapper .categories-box .menu-title,
.layout-box .menu-title {
  font-size: 14px;
  line-height: 20px;
  color: #0A0A0A;
}

.tiptop-editor .page-not-found .NoResults {
  padding-top: 0;
  padding-bottom: 0;
  text-align: center;
  border-bottom-left-radius: 12px;
  min-height: 300px;
  align-items: center;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  border: 0;
}

.tiptop-editor .NoResults .noResultsBody {
  max-width: 350px;
}

.tiptop-editor .NoResults .noResultsBody>svg {
  width: 170px;
  margin-top: 12px;

}

.tiptop-editor .page-not-found .noResTitle {
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  text-align: center;
  color: #101828;
  margin-top: 20px;
  margin-bottom: 8px;
}

.tiptop-editor .page-not-found .noResDesc {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #475467;
  margin-bottom: 30px;
}

.viemo-urlInput {
  margin-top: calc(1.5rem - 10px);
}

.image-node-wrapper .mediaGallery .ulpoadImageBlock {
  padding-left: 36px;
  padding-right: 36px;
}

.tiptop-editor .image-node-wrapper .textBlock {
  margin-top: 0;
  margin-bottom: 20px;
  position: relative;
  top: 0;
}

.tiptop-editor .image-node-wrapper .newpageLeftRow input {
  background: #fff;
  border: none;
  border-radius: 6px;
  box-shadow: 0 1px 2px #1018280d;
  color: #667085;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  gap: 8px;
  line-height: 24px;
  outline: none;
  padding: 14px 14px 12px;
  width: 100%;
}

.tiptop-editor .image-node-wrapper .uploadFileBlock {
  margin: 0 auto;
  width: 100%;
  min-height: 250px;
  padding: 50px 10px;
  box-shadow: 0 1px 2px #1018280d;
  cursor: pointer;
  justify-content: center;
  position: relative;
  z-index: 0;
  border: 1px solid #573cff;
  border-radius: 6px;
}

.image-node-wrapper .fileUploadBox .fileUploadCover_Img {
  align-items: center;
  background: #f2f4f7;
  border: 6px solid #f9fafb;
  border-radius: 50%;
  display: flex;
  height: 40px;
  justify-content: center;
  margin: 0 auto 5px;
  padding: 5px !important;
  width: 40px;
}

.tiptop-editor .image-node-wrapper .newPageImageUploadText,
.uploadFileBlock .newPageImageUploadText {
  color: #475467;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  -webkit-user-select: none;
          user-select: none;
  margin-bottom: 0;
  padding-top: 0;
  text-align: center;
}

.tiptop-editor .image-node-wrapper .newPageImageUploadText span {
  color: #573cff;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}

.image-node-wrapper .image-size-text {
  font-size: 14px;
}

.tiptop-editor .progress-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tiptop-editor .popupBlock .progress-wrap {
  margin: 0 auto;
}

.tiptop-editor .progress {
  position: relative;
  height: 7px;
  width: 100%;
  border: 1px solid rgb(246, 246, 250);
  border-radius: 15px;
  top: 0;
  left: 0;
}

.tiptop-editor .popupBlock .progress {
  width: 70%;
}

.tiptop-editor .progress .color {
  position: absolute;
  background-color: #573CFF;
  width: 0px;
  height: 6px;
  border-radius: 15px;
  animation: progress 4s infinite linear;
}

.image-node-wrapper .uploadRunning {
  width: 100%;
  min-height: 250px;
  padding: 100px;
  box-shadow: 0 1px 2px #1018280d;
  position: relative;
  z-index: 0;
  border: 1px solid #573cff;
  border-radius: 6px;
}

.image-block .video-caption,
.node-youtubeBlock .video-wrapper .video-caption {
  min-height: 24px;
  text-align: left;
  margin-bottom: 0 !important;
  outline: none;
}

.image-block .video-caption:before,
.node-youtubeBlock .video-wrapper .video-caption::before {
  outline: none;
}

.image-block .video-caption:empty:before {
  pointer-events: none;
  float: left;
  height: 0px;
  width: 100%;
  color: rgb(0 0 0 / 0.4);
  content: 'Write a caption for the image (optional)';
  font-size: 14px;
  outline: none;
  line-height: 26px;
}

.tiptop-editor .node-VideoBlock .video-wrapper .video-caption:empty:before {
  pointer-events: none;
  float: left;
  height: 0px;
  width: 100%;
  color: rgb(0 0 0 / 0.4);
  content: 'Write a caption for the video (optional)';
  font-size: 14px;
  outline: none;
  line-height: 26px;
}

.tiptop-editor .image-block {
  /* border: 1px solid #573cff; */
  border-radius: 0.5rem;
  margin-bottom: 20px;
}

.tiptop-editor .image-preview-cover {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.tiptop-editor .image-preview-cover .image-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
}

.tiptop-editor .image-block .image-preview.image-width-full,
.tiptop-editor .video-wrapper .image-preview.image-width-wide,
.tiptop-editor .logoslider-wapper.image-width-full {
  width: calc(100vw - 312px - 375px - 36px - 40px - 40px);
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  max-width: 1200px;
}

.tiptop-editor .image-block .image-preview img {
  height: 100%;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
  object-fit: cover;
}

.tiptop-editor .image-bubble-menu {
  padding: 0.5rem !important;
  top: -9px !important;
  min-width: 5rem !important;
  transform: translateX(-50%);
}

.tiptop-editor .image-bubble-menu.products {
  padding: 0.5rem !important;
  top: 0 !important;
  min-width: 5rem !important;
  transform: translateX(0);
}

.tiptop-editor .image-bubble-menu.page-bubble-menu {
  min-width: 3rem !important;
}

.tiptop-editor .image-bubble-menu button {
  padding: 0 !important;
  display: block;
  width: unset;
  line-height: 0;
}

.tiptop-editor .image-bubble-menu .image-bubble-block {
  display: flex;
  justify-content: space-evenly;
  gap: 10px;
}

.toggle-button-image {
  padding: 9px !important;
}

.image-node-wrapper .errorMessages {
  text-align: center;
  margin-top: 10px;
}

/* .image-block {
  padding: 10px;
} */

.node-fileBlock.ProseMirror-selectednode .fileblock-wrapper {
  border: 1px solid #573cff;
  border-radius: 6px;
}

.tiptop-editor .node-fileBlock .fileblock-wrapper {
  margin-left: -10px;
  margin-right: -10px;
}

.tiptop-editor .file-block .file-detail .filedescription .file-caption {
  outline: none;
  width: calc(100% - 75px);
  font-size: 15px;
  color: rgb(55 65 81);
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 0;
}

.file-caption:empty:before {
  content: 'Enter a description'
}

.tiptop-editor .file-block .file-detail .file-caption.file-title {
  color: #000;
  font-weight: 600;
  font-size: 16px;
  outline: none;
  margin-bottom: 0;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.tiptop-editor .fileblock-wrapper .image-block.file-block .uploadFileBlock {
  display: flex;
  align-items: center;
  gap: 20px;
  min-height: unset;
  max-width: unset;
  background: transparent;
  border: none;
  box-shadow: none;
  cursor: unset;
  justify-content: unset;
}

.tiptop-editor .file-block .file-detail .filedescription,
.tiptop-editor .file-block .uploadFileBlock .file-detail {
  width: 100%;
}

.uploadFileBlock .newPagefileUploadText {
  margin-top: 10px;
  margin-bottom: 0;
}

.tiptop-editor .fileblock-wrapper .file-block {
  padding: 10px;
  margin: 0;
}

.tiptop-editor .fileblock-wrapper .file-block .featureImgMiddleContent svg {
  height: 40px;
}

.tiptop-editor .fileblock-wrapper .file-block .featureImgMiddleContent .icon-img {
  max-width: 40px;
  margin-left: 0.4rem;
}

.tiptop-editor .fileblock-wrapper .file-block .featureImgMiddleContent .file-icon {
  max-width: calc(40px + 0.4rem);
}

.tiptop-editor .newPageImageUploadText span {
  color: #573cff;
}

.tiptop-editor .uploadFileBlock .newPageImageUploadText.fileupload {
  display: block;
}

.tiptop-editor .uploadFileBlock .uploaded-file .newPagefileUploadText {
  font-size: 14px;
}

.tiptop-editor .file-block .uploaded-file .newPagefileUploadText span {
  color: #777;
}

.bubble-toggle-menu.file-bubble-menu {
  min-width: 2.4rem !important;
  top: -9px !important;
  display: block;
  padding: 2px 0 !important;
}

.file-bubble-menu .file-bubble .full-display-button {
  padding: 5px !important;
  margin-left: 2px;
}

.tiptop-editor .publications-wrapper .publication-list.grid .publication-item {
  display: flex;
  flex-direction: column;
  width: 100%;

}

.tiptop-editor .publications-wrapper .publication-list.grid .publication-item .publication-image {
  width: 100%;
  height: 100%;
  border-radius: 6px;
  line-height: 0;
  position: relative;
  overflow: hidden;
  height: 220px;
}

.tiptop-editor .publications-wrapper .publication-list.list .publication-item .publication-image .publicationTypeWrapper {
  display: none;
}

.publicationTypeWrapper .corner-top-left path,
.corner-top-right path,
.corner-bottom-left path,
.corner-bottom-right path {
  fill: #fff;
}

.tiptop-editor .publications-wrapper .publication-list.grid .publication-item .publication-image .publicationTypeWrapper {
  background-color: #fff;
  color: #101828;
  position: absolute;
  top: 0;
  left: 0;
  font-size: 15px;
  line-height: 1.2;
  padding: 6px 12px 12px 6px;
  border-bottom-right-radius: 20px;
}

.tiptop-editor .publications-wrapper .publication-list.grid .publication-item .publication-image .publicationTypeWrapper .corner-top-left {
  width: 18px;
  height: 18px;
  overflow: hidden;
}

.tiptop-editor .publications-wrapper .publication-list.grid .publication-item .publication-image .publicationTypeWrapper .corner-top-left.top {
  position: absolute;
  right: -18px;
  top: 0;
}

.tiptop-editor .publications-wrapper .publication-list.grid .publication-item .publication-image .publicationTypeWrapper .corner-top-left.bottom {
  position: absolute;
  left: 0;
  bottom: -18px;
}

.tiptop-editor .publications-wrapper .publication-list.grid .publication-data {
  margin-top: 12px;
}

.publication-list.grid .publication-item .publication-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  overflow: hidden;
}

.bubble-toggle-menu.button-box .publication-count .zoom-range,
.bubble-toggle-menu.button-box .publication-column .zoom-range {
  width: 100%;
}

.bubble-toggle-menu.button-box .publication-count input.zoom-range,
.bubble-toggle-menu.button-box .publication-column input.zoom-range {
  height: 4px;
  background-color: #0A2540;
  border-radius: 6px;
  appearance: none;
  padding: 0;
  margin-bottom: 10px;
}

.bubble-toggle-menu.button-box .publication-count input.zoom-range::-webkit-slider-thumb,
.bubble-toggle-menu.button-box .publication-column input.zoom-range::-webkit-slider-thumb {
  height: 15px;
  width: 15px;
  background-color: #0A2540;
  border-radius: 50%;
  appearance: none;
  z-index: 99;
  cursor: grab;
}

.bubble-toggle-menu.button-box .publication-count input.zoom-range.slider-cursor::-webkit-slider-thumb,
.bubble-toggle-menu.button-box .publication-column input.zoom-range.slider-cursor::-webkit-slider-thumb {
  cursor: grabbing;
}

.bubble-toggle-menu.button-box .publication-count input.zoom-range::-moz-range-thumb,
.bubble-toggle-menu.button-box .publication-column input.zoom-range::-moz-range-thumb {
  height: 15px;
  width: 15px;
  background-color: #344054;
  border-radius: 50%;
  appearance: none;
  z-index: 99;
}

.bubble-toggle-menu.button-box .publication-count input.zoom-range::-ms-thumb,
.bubble-toggle-menu.button-box .publication-column input.zoom-range::-ms-thumb {
  height: 15px;
  width: 15px;
  background-color: #344054;
  border-radius: 50%;
  appearance: none;
  z-index: 99;
}

.tiptop-editor .bubble-toggle-menu.button-box .publication-count .count-title,
.tiptop-editor .bubble-toggle-menu.button-box .publication-column .column-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tiptop-editor .bubble-toggle-menu.button-box .publication-count .count-title label,
.tiptop-editor .bubble-toggle-menu.button-box .publication-column .column-title label {
  margin-bottom: 0;
  color: #0A0A0A;
}

.tiptop-editor .publications-wrapper .publication-list.grid.one-column {
  grid-template-columns: repeat(1, minmax(0px, 1fr))
}

.tiptop-editor .publications-wrapper .publication-list.grid.two-column {
  grid-template-columns: repeat(2, minmax(0px, 1fr))
}

.tiptop-editor .publications-wrapper .publication-list.grid.three-column {
  grid-template-columns: repeat(3, minmax(0px, 1fr))
}

.tiptop-editor .publications-wrapper .publication-list.grid.four-column {
  grid-template-columns: repeat(4, minmax(0px, 1fr))
}

.tiptop-editor .bubble-toggle-menu .content-type-menu.categories-menu {
  width: calc(100% - 2rem);
  margin-left: 1rem;
  top: 83px;
  max-height: 170px;
  overflow-y: scroll;
  box-shadow: none;
  height: auto;
  padding: 0;
  border-radius: 6px;
}

.categories-menu .categories {
  font-size: 14px;
  color: #101828;
  padding-left: 6px;
  cursor: pointer;
  margin: 0;
  font-weight: 400;
}

.categories-box .categories {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
  margin: 10px 0;
}

.categories-box .selected-categorie {
  display: flex;
  gap: 2px;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  align-items: center;
  font-size: 13px;
  padding: 2px 6px;
  padding-right: 0 !important;
  background-color: #fff;
}

.categories-box .selected-categorie p {
  margin: 0 !important;
  font-weight: 400;
}

.categories-box .selected-categorie svg {
  cursor: pointer;
}

.categories-menu .selectedcat:hover {
  background: #f9f9f9;
  color: #101828;
}

.tiptop-editor .bubble-toggle-menu .categories-menu .selectedcat {
  display: flex;
  justify-content: flex-start;
  padding: 10px 16px 10px 10px;
  color: #111827;
  cursor: pointer;
  align-items: center;
}

.tiptop-editor .bubble-toggle-menu .categories-menu .selectedcat p {
  margin: 0;
  line-height: 24px;
}

.content-type-menu.categories-menu input[type="checkbox"]:before {
  height: 18px;
  width: 18px;
}

.tiptop-editor .bubble-toggle-menu.button-box .content-type-menu.categories-menu .selectedcat input {
  height: 18px;
  min-width: unset;
  width: 20px;
  flex: unset;
  margin-left: 4px;
  margin-right: 0;
  cursor: pointer;
  background: transparent;
  appearance: unset;
  border: none;
  padding: 0;
  box-shadow: none;
  margin-top: 0;
  margin-bottom: 0;
  min-height: unset;
}

.column-bubble-menu {
  padding-top: 9px !important;
  min-width: 7rem !important;
  top: -40px !important;
}

.AiWriter-node-wrapper {
  border: 1px solid #573cff;
  border-radius: 0.5rem;
}

.AiWriter-node-wrapper .aitext-generator {
  color: rgba(0, 0, 0, 0.8);
  font-size: 0.75rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  margin-left: 0.375rem;
}

.tiptop-editor .bubble-toggle-menu.button-box .publication-submit-button {
  text-align: right;
}

.product .publication-submit-button {
  margin-top: 10px;
}

.bubble-toggle-menu.button-box .publication-submit-button button {
  width: auto;
}

/* .video-wrapper.video-preview .image-preview{
  border: 1px solid #573cff;
  border-radius: 0.5rem;
  margin: 20px 0;
  overflow: hidden;
} */
.tiptop-editor .node-VideoBlock.ProseMirror-selectednode .player-wrapper.player-ready {
  border-radius: 6px;
}

.tiptop-editor .uploadFileBlock .videoMiddleContent {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tiptop-editor .video-wrapper .react-player {
  margin-top: -5px;
}

.upload-thumbnail {
  position: relative;
  background: rgba(250, 250, 251, 1);
  width: 100%;
  height: 150px;
  margin-bottom: 15px;
  border-radius: 6px;
  cursor: pointer;
}

.button-box .upload-thumbnail .uploadBtn svg {
  position: absolute;
  left: 112px;
  top: 69px;
  padding-top: 3px;
}

.image-bubble-menu-position {
  top: -5px !important;
}

.loop-box p {
  margin: 0 !important;
}

.loop-box .toggle-button span {
  transform: translateX(0) !important;
}

.loop-box .toggle-button.checked span {
  transform: translateX(0.9rem) !important;
}

.tiptop-editor .image-row .gallery-image {
  position: relative;
}

.gallery-image:hover .delete-item-block,
.gallery-image:hover .layout-wrapper {
  display: block;
}

.layout-wrapper {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #00000033;
}

.tiptop-editor .delete-item-block {
  position: absolute;
  top: 10px;
  display: none;
  right: 10px;
  z-index: 9;
}

.tiptop-editor .delete-item-block .delete-item {
  display: flex;
  flex-direction: row-reverse;
}

.tiptop-editor .delete-item-block .delete-item .delete-button {
  pointer-events: auto;
  position: relative;
  display: flex;
  height: 1.8rem;
  /* width: 1.8rem;  */
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  background-color: rgba(255, 255, 255, 0.9);
  color: #1F2937;
  transition: all 0.2s;
}

.tiptop-editor .delete-item-block .delete-item .delete-button svg {
  stroke: #6b7280;
  margin-left: 1px;
}

.tiptop-editor .delete-item-block .delete-item .delete-button:hover svg {
  stroke: #0A0A0A;
}

.tiptop-editor .gallery-bubble {
  min-width: 0 !important;
}

.tiptop-editor .products-node-wrapper .image-node-wrapper .textBlock {
  margin-top: 0;
}

.tiptop-editor .products-node-wrapper .product-button {
  margin-top: 10px;
}

.tiptop-editor .products-node-wrapper .products-content .product-title-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
}

.tiptop-editor .products-content .product-title,
.tiptop-editor .products-content .product-description {
  cursor: text;
}

.tiptop-editor .products-content .product-title-wrapper:has(.rating) .product-title {
  max-width: calc(100% - 110px);
  font-weight: 600;
}

.tiptop-editor .products-content .product-title-wrapper .rating {
  display: flex;
  flex-direction: row;
  margin: 0;
  gap: 3px;
}

.tiptop-editor .products-content .product-title-wrapper .rating .highlighted svg {
  fill: #F2AE40;
}

.tiptop-editor .products-node-wrapper .product-title {
  margin-bottom: 5px;
  line-height: unset;
  font-weight: 400;
}

.tiptop-editor .products-node-wrapper .product-title:empty:before {
  content: 'Product title' !important;
  color: #7777;
}

.tiptop-editor .product-title:focus-visible {
  outline: 0 !important;
  border: 0 !important;
}

.tiptop-editor .product-description {
  margin: 0 !important;
  cursor: auto;
}

.tiptop-editor .product-description:empty:before {
  content: 'Description' !important;
  color: #7777;
}

.tiptop-editor .product-description:focus-visible {
  outline: 0 !important;
  border: 0 !important;
}

.node-products .products-node-wrapper {
  border: 1px solid #573cff;
  border-radius: 0.5rem;
  padding: 14px;
}

.tiptop-editor .products-node-wrapper .image-block {
  padding: 0 !important;
  margin: 0 !important;
}

.tiptop-editor .products-node-wrapper .image-preview {
  border: 0 !important;
  border-radius: 0.5rem !important;
  margin: 0;
  line-height: 0;
}

.tiptop-editor .product .toggle-button span {
  transform: translateX(0) !important;
}

.tiptop-editor .product .toggle-button.checked span {
  transform: translateX(0.9rem) !important;
}

.tiptop-editor .product .toggle-button-label {
  justify-content: space-between !important;
}

.tiptop-editor .product {
  min-width: 18rem !important;
  padding: 15px !important;
}

.tiptop-editor .product .button-element button {
  background-color: #1c1c1c !important;
  border: 1px solid #1c1c1c;
  border-radius: 6px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  line-height: 28px;
  padding: 5px 10px !important;
  transition: all .3s linear;
}

.tiptop-editor .product-button button {
  width: 100% !important;
}

.tiptop-editor .products-node-wrapper .rating .rate {
  font-size: 24px;
}

.tiptop-editor .product-bubble-block .button-wrapp:has(.rating) .rating-label {
  margin-bottom: 3px;
}

.tiptop-editor .product-bubble-block .button-wrapp .rating .highlighted svg {
  fill: #F2AE40;
}

.tiptop-editor .product-bubble-block .button-wrapp .rating {
  text-align: right;
  margin-bottom: 15px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 3px;
  margin-top: 10px;
  color: #737373;
}

.tiptop-editor .AiWriter-wrapper,
.tiptop-editor .category-wrapper {
  padding: 0.5rem;
  width: 100%;
  background-color: white;
  border-radius: 6px;
  border: 1px solid #E5E7EB;
  margin-top: 0;
  margin-bottom: 20px;
}

.tiptop-editor.AiWriter-wrapper .aitext-generator {
  display: flex;
  flex-direction: column;
  padding: 0.25rem;
}

.tiptop-editor .AiWriter-wrapper .aitext-generator label {
  color: rgba(0, 0, 0, 0.8);
  font-size: 0.75rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  margin-left: 0.375rem;
}

.tiptop-editor .node-aiWriter.ProseMirror-selectednode .AiWriter-wrapper {
  overflow: unset;
}

.tiptop-editor .AiWriter-wrapper .prompt-textarea {
  background-color: rgba(0, 0, 0, 0.05);
  border: 0;
  border-radius: 6px;
  caret-color: black;
  display: block;
  color: black;
  font-size: 0.875rem;
  font-weight: 500;
  height: 4.5rem;
  padding: 0.25rem 0.5rem;
  width: 100%;
  margin-bottom: 0.5rem;
  transition: background-color 0.2s, outline-color 0.2s;
  max-width: 100%;
  min-height: 100px;
  resize: vertical;
  margin-top: 0.5rem;
}

.tiptop-editor .AiWriter-wrapper .prompt-textarea:focus,
.tiptop-editor .AiWriter-wrapper .prompt-textarea:active {
  background-color: transparent;
  outline: 1px solid black;
}

.tiptop-editor .AiWriter-wrapper .generator-menu {
  display: flex;
  justify-content: space-between;
  width: auto;
  gap: 0.25rem;
}

.tiptop-editor .AiWriter-wrapper .generator-menulist {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 0.375rem;
  opacity: 1;
  white-space: nowrap;
  background-color: #F9FAFB;
  color: #111827;
  padding: 0.5rem 0.55rem;
  transition: background-color 0.2s;
  height: 38px;
  position: relative;
  cursor: pointer;
}

.tiptop-editor .AiWriter-wrapper .generator-menulist:hover {
  background-color: #E5E7EB;
}

.tiptop-editor .AiWriter-wrapper .generator-menulist:active {
  background-color: #EDE9FE;
}

.tiptop-editor .generator-menulist .menuitem {
  padding: 0.5rem;
  min-width: 12rem;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  border: 1px solid #E5E7EB;
  position: absolute;
  top: 41px;
  left: -4px;
  z-index: 1;
}

.tiptop-editor .AiWriter-wrapper .menuitem .categories {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #6B7280;
  text-align: left;
  background-color: transparent;
  width: 100%;
  border-radius: 0.375rem;
  transition: background-color 0.2s, color 0.2s;
}

.tiptop-editor .AiWriter-wrapper .menuitem .categories:hover {
  background-color: #F3F4F6;
  color: #1F2937;
}

.tiptop-editor .AiWriter-wrapper .generate-button {
  display: flex;
  justify-content: space-between;
  width: auto;
  gap: 0.25rem;
}

.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid black;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 0.375rem;
  opacity: 1;
  white-space: nowrap;
  color: white;
  background-color: black;
  padding: 0.5rem 0.55rem;
  transition: background-color 0.2s;
  cursor: pointer;
}

.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button:hover {
  background-color: #1F2937;
}

.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button:active {
  background-color: #1E3A8A;
}

.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button:disabled {
  opacity: 0.5;
  pointer-events: none;
}

.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button.button-discard {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 0.375rem;
  opacity: 1;
  white-space: nowrap;
  background-color: transparent;
  color: #F87171;
  padding: 0.5rem 0.55rem;
  transition: background-color 0.2s, color 0.2s;
  cursor: pointer;
}

.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button.button-discard:hover {
  background-color: rgba(248, 113, 113, 0.1);
  color: #F87171;
}

.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button.button-discard:active {
  background-color: rgba(0, 0, 0, 0.1);
  color: #1F2937;
}

.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button.button-discard:disabled {
  opacity: 0.5;
  pointer-events: none;
}

.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button.button-insert {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 0.375rem;
  opacity: 1;
  white-space: nowrap;
  background-color: transparent;
  color: #6B7280;
  padding: 0.5rem 0.55rem;
  transition: background-color 0.2s, color 0.2s;
  cursor: pointer;
}

.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button.button-insert:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: #374151;
}

.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button.button-insert:active {
  background-color: rgba(0, 0, 0, 0.1);
  color: #1F2937;
}

.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button.button-insert:disabled {
  opacity: 0.5;
  pointer-events: none;
}

.tiptop-editor .AiWriter-wrapper .preview-title {
  color: rgba(0, 0, 0, 0.8);
  font-size: 0.75rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  margin-left: 0.375rem;
}

.tiptop-editor .AiWriter-wrapper .aitext-preview {
  background-color: white;
  border-left: 4px solid #e5e7eb;
  color: black;
  font-size: 1rem;
  max-height: 14rem;
  margin-bottom: 1rem;
  margin-left: 0.625rem;
  overflow-y: auto;
  padding-left: 1rem;
  position: relative;
}

.tiptop-editor .AiWriter-wrapper .button .generate-button.insertbtn {
  display: block;
}

.tiptop-editor .AiWriter-wrapper .button .generate-button .mobile-button {
  display: none;
}

.tiptop-editor .generator-menu .ai-button {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tiptop-editor .AiWriter-wrapper .dropdown .downarrow {
  position: absolute;
  top: 12px;
}

.tiptop-editor .logoslider-wapper {
  margin-bottom: 20px;
}

.tiptop-editor .logoslider-wapper .swiper-wrapper {
  align-items: center;
}

.tiptop-editor .logoslider-wapper .swiper-slide {
  margin: 20px auto;
}

.tiptop-editor .logoslider-wapper .swiper-slide img {
  max-width: 100%;
}

.tiptop-editor .bubble-toggle-menu .categories-button .menu-icon {
  height: 24px !important;
}

.tiptop-editor .node-VideoBlock .video-wrapper {
  margin-bottom: 20px;
}

.tiptop-editor .node-VideoBlock.ProseMirror-selectednode .video-wrapper.video-preview,
.node-galleryBlock .image-block,
.node-imageBlock .image-block .image-preview {
  border: 0;
  overflow: unset;
}

.tiptop-editor .ProseMirror-selectednode .video-wrapper .image-preview.image-width-wide,
.tiptop-editor .ProseMirror-selectednode .video-wrapper .image-preview.image-width-default {
  border: 1px solid #573cff;
  border-radius: 0.5rem;
}

.node-fileBlock .fileblock-wrapper,
.node-publications .publications-wrapper,
.node-products .products-node-wrapper,
.node-whychoosemalmart .whychoosemalmart-node-wrapper,
.node-ourservices .ourservices-node-wrapper,
.node-galleryBlock .image-preview,
.node-VideoBlock .video-wrapper.video-preview,
.node-logoSliderBlock .logoslider-wapper,
.node-imageBlock .image-block .image-preview,
.node-reviewBlock .review-node-wrapper {
  border: 1px solid transparent;
}

/* .node-vimeoBlock .vimeo-video,.gallery-block .image-preview, .image-block .image-preview {
  overflow: hidden;
} */
.node-aiWriter.ProseMirror-selectednode .AiWriter-wrapper,
.node-categoryBlock.ProseMirror-selectednode .category-wrapper,
.node-publications.ProseMirror-selectednode .publications-wrapper,
.node-products.ProseMirror-selectednode .products-node-wrapper,
.node-vimeoBlock.ProseMirror-selectednode .vimeo-video,
.tiptop-editor .node-galleryBlock.ProseMirror-selectednode .image-preview,
.node-VideoBlock.ProseMirror-selectednode .video-wrapper.video-preview,
.node-imageBlock.ProseMirror-selectednode .image-block .image-preview,
.tiptop-editor .node-logoSliderBlock.ProseMirror-selectednode .logoslider-wapper,
.tiptop-editor .node-brand.ProseMirror-selectednode .brand-node-wrapper,
.tiptop-editor .node-whychoosemalmart.ProseMirror-selectednode .whychoosemalmart-node-wrapper,
.tiptop-editor .node-ourservices.ProseMirror-selectednode .ourservices-node-wrapper,
.tiptop-editor .node-parentCategoryBlock.ProseMirror-selectednode .category-wrapper ,
.tiptop-editor .node-reviewBlock.ProseMirror-selectednode .review-node-wrapper {
  border: 1px solid #573cff;
  border-radius: 0.5rem;
  overflow: hidden;
}

.node-VideoBlock .video-preview,
.node-imageBlock.ProseMirror-selectednode .image-preview,
.gallery-block .gallery-preview {
  border: none;
  border-radius: 0;
}

.tiptop-editor .image-block .image-preview.image-width-default .image-title {
  margin-top: -5px;
}

.tiptop-editor .image-block .video-title.image-title p {
  font-size: 14px;
}

.tiptop-editor .video-wrapper.video-preview .player-wrapper.player-ready {
  margin-top: 0;
}

.tiptop-editor .video-wrapper.video-preview .video-title {
  margin-top: -5px;
}

.node-parentCategoryBlock{
  margin-block: 20px;
}

.ProseMirror [data-type='columns'] [data-position='left']:hover,
.ProseMirror [data-type='columns'] [data-position='right']:hover,
.ProseMirror [data-type='columns'] [data-position='left'].has-focus,
.ProseMirror [data-type='columns'] [data-position='right'].has-focus,
.ProseMirror [data-type='columns'] [data-position='center']:hover,
.ProseMirror [data-type='columns'] [data-position='center'].has-focus {
  border: 1px solid #573cff;
}

.ProseMirror [data-type='columns'] [data-position='left'],
.ProseMirror [data-type='columns'] [data-position='right'],
.ProseMirror [data-type='columns'] [data-position='center'] {
  border: 1px solid transparent;
}

.gallery-block .video-caption:empty:before {
  content: 'Write a caption for the Gallery (Optional)'
}

.gallery-block {
  position: relative;
}

.galley-layout-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #00000033;
}

.image-node-wrapper .dragging {
  opacity: 0.6;
}

.tiptop-editor .image-node-wrapper .progress{
  top: 20px;
}

.node-VideoBlock.ProseMirror-selectednode .image-preview,
.node-imageBlock.ProseMirror-selectednode .image-preview,
.node-galleryBlock.ProseMirror-selectednode .image-preview {
  border: none;
  border-radius: 0;
}

.node-image .tabTitle,
.node-video .tabTitle,
.node-gallery .tabTitle,
.node-products .tabTitle,
.node-file .tabTitle,
.node-logoSlider .tabTitle {
  list-style-type: none !important;
  padding-inline-start: 0 !important;
  padding: 0 24px !important;
}

.node-image .tabTitle li,
.node-video .tabTitle li,
.node-gallery .tabTitle li,
.node-products .tabTitle li,
.node-file .tabTitle li,
.node-logoSlider .tabTitle li {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}

.node-image .popupTitle,
.node-video .popupTitle,
.node-gallery .popupTitle,
.node-products .popupTitle,
.node-file .popupTitle,
.node-logoSlider .popupTitle {
  font-weight: 600;
  font-size: 16px;
  line-height: 28px;
  color: #101828;
  margin-bottom: 10px;
}

.node-image .pageSearchInput input,
.node-video .pageSearchInput input,
.node-gallery .pageSearchInput input,
.node-products .pageSearchInput input,
.node-file .pageSearchInput input,
.node-logoSlider .pageSearchInput input {
  width: calc(100% - 5px);
  height: 40px !important;
  background: #ffffff;
  border: 1px solid #eaecf0;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 6px;
  padding-left: 40px;
  outline: none;
  right: 15px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #667085;
}

.node-image .dropdown-wrapp ul,
.node-video .dropdown-wrapp ul,
.node-gallery .dropdown-wrapp ul,
.node-products .dropdown-wrapp ul,
.node-file .dropdown-wrapp ul,
.node-logoSlider .dropdown-wrapp ul {
  border: none;
  padding: 10px;
}

.node-image .dropdown,
.node-video .dropdown,
.node-gallery .dropdown,
.node-products .dropdown,
.node-file .dropdown,
.node-logoSlider .dropdown {
  background: white;
  border: 1px solid #eaecf0;
  box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
  border-radius: 6px;
  position: absolute;
  right: 0;
  top: 50px;
  min-width: 170px;
  z-index: 999999;
}

.node-file .dropdown.countryDropdown {
  min-width: 160px;
}

.node-image .dropdown.addDropdown,
.node-video .dropdown.addDropdown,
.node-gallery .dropdown.addDropdown,
.node-products .dropdown.addDropdown,
.node-file .dropdown.addDropdown,
.node-logoSlider .dropdown.addDropdown {
  right: auto;
}

.node-image .dropdown.dateDropdown {
  width: max-content;
}

.node-image .dropdown-wrapp ul li:not(:last-child),
.node-video .dropdown-wrapp ul li:not(:last-child),
.node-gallery .dropdown-wrapp ul li:not(:last-child),
.node-products .dropdown-wrapp ul li:not(:last-child),
.node-file .dropdown-wrapp ul li:not(:last-child),
.node-logoSlider .dropdown-wrapp ul li:not(:last-child) {
  margin-bottom: 10px;
}

.node-image .dropdown-wrapp ul li,
.node-video .dropdown-wrapp ul li,
.node-gallery .dropdown-wrapp ul li,
.node-products .dropdown-wrapp ul li,
.node-file .dropdown-wrapp ul li,
.node-logoSlider .dropdown-wrapp ul li {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.node-image .media-grid-layout .list-search input[type="checkbox"],
.node-video .media-grid-layout .list-search input[type="checkbox"],
.node-gallery .media-grid-layout .list-search input[type="checkbox"],
.node-products .media-grid-layout .list-search input[type="checkbox"],
.node-file .media-grid-layout .list-search input[type="checkbox"],
.node-logoSlider .media-grid-layout .list-search input[type="checkbox"] {
  font-size: 0;
  width: 18px;
  height: 18px;
  border: 1px solid transparent;
  -o-appearance: none;
  appearance: none;
  position: relative;
  padding: 0 0 0 0;
  margin: 0;
  margin-right: 9px !important;
  right: 0;
  top: 0;
}

.node-image .media-grid-layout input[type="checkbox"]:not(:checked)::before,
.node-video .media-grid-layout input[type="checkbox"]:not(:checked)::before,
.node-gallery .media-grid-layout input[type="checkbox"]:not(:checked)::before,
.node-products .media-grid-layout input[type="checkbox"]:not(:checked)::before,
.node-file .media-grid-layout input[type="checkbox"]:not(:checked)::before,
.node-logoSlider .media-grid-layout input[type="checkbox"]:not(:checked)::before {
  background-color: #fff;
}

.node-image .media-grid-layout input[type="checkbox"]::before,
.node-video .media-grid-layout input[type="checkbox"]::before,
.node-gallery .media-grid-layout input[type="checkbox"]::before,
.node-products .media-grid-layout input[type="checkbox"]::before,
.node-file .media-grid-layout input[type="checkbox"]::before,
.node-logoSlider .media-grid-layout input[type="checkbox"]::before {
  margin-right: 0;
}

.node-image .list-search input[type="checkbox"]:before,
.node-video .list-search input[type="checkbox"]:before,
.node-gallery .list-search input[type="checkbox"]:before,
.node-products .list-search input[type="checkbox"]:before,
.node-file .list-search input[type="checkbox"]:before,
.node-logoSlider .list-search input[type="checkbox"]:before {
  position: absolute;
  left: 0;
  top: -1px;
  margin-right: 0;
}

.node-image input[type="checkbox"]:before,
.node-video input[type="checkbox"]:before,
.node-gallery input[type="checkbox"]:before,
.node-products input[type="checkbox"]:before,
.node-file input[type="checkbox"]:before,
.node-logoSlider input[type="checkbox"]:before {
  content: "";
  font-size: 15px;
  border: 1px solid #d0d5dd;
  display: block;
  width: 15px;
  background: none;
  height: 15px;
  margin-right: 7px;
  border-radius: 4px;
  min-width: 18px;
  min-height: 18px;
  margin-right: 15px;
  background-size: 60%;
  background-position: 4px center;
  background-repeat: no-repeat;
  accent-color: #e6f2ff;
}

.node-image .dropdown-wrapp ul li span,
.node-video .dropdown-wrapp ul li span,
.node-gallery .dropdown-wrapp ul li span,
.node-products .dropdown-wrapp ul li span,
.node-file .dropdown-wrapp ul li span,
.node-logoSlider .dropdown-wrapp ul li span {
  margin-left: 0;
  color: #101828;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
}

.node-image input[type="checkbox"]:checked:before,
.node-video input[type="checkbox"]:checked:before,
.node-gallery input[type="checkbox"]:checked:before,
.node-products input[type="checkbox"]:checked:before,
.node-file input[type="checkbox"]:checked:before,
.node-logoSlider input[type="checkbox"]:checked:before {
  /* background-image: url('../../images/checkbox.svg'); */
  border: 1px solid #2b59ff;
  background-color: #fff;
}

.node-image .gridImg input,
.node-video .gridImg input,
.node-gallery .gridImg input,
.node-products .gridImg input,
.node-file .gridImg input,
.node-logoSlider .gridImg input {
  position: absolute !important;
  top: 10px;
  right: 10px;
  appearance: none;
  width: auto !important;
  background: unset;
  height: 0;
  padding: 0;
}

.node-image .file-wrapper .filename,
.node-video .file-wrapper .filename,
.node-gallery .file-wrapper .filename,
.node-products .file-wrapper .filename,
.node-file .file-wrapper .filename,
.node-logoSlider .file-wrapper .filename {
  margin-top: 0 !important;
  line-height: unset !important;
}

.node-image .file-wrapper .formUrlImg,
.node-video .file-wrapper .formUrlImg,
.node-gallery .file-wrapper .formUrlImg,
.node-products .file-wrapper .formUrlImg,
.node-file .file-wrapper .formUrlImg,
.node-logoSlider .file-wrapper .formUrlImg {
  margin-top: 14px;
}

.node-image .file-wrapper.show-wrapper,
.node-video .file-wrapper.show-wrapper,
.node-gallery .file-wrapper.show-wrapper,
.node-products .file-wrapper.show-wrapper,
.node-file .file-wrapper.show-wrapper,
.node-logoSlider .file-wrapper.show-wrapper {
  z-index: 0 !important;
}

.node-image .featuredImageModal input.zoom-range,
.node-video .featuredImageModal input.zoom-range,
.node-gallery .featuredImageModal input.zoom-range,
.node-products .featuredImageModal input.zoom-range,
.node-file .featuredImageModal input.zoom-range,
.node-logoSlider .featuredImageModal input.zoom-range {
  padding: 0 !important;
}

.node-image .ring-loader:before,
.node-video .ring-loader:before,
.node-gallery .ring-loader:before,
.node-products .ring-loader:before,
.node-file .ring-loader:before,
.node-logoSlider .ring-loader:before {
  border: 3px solid #fff !important;
}

.products-node-wrapper .gallery-image .image-preview {
  position: relative;
}

.publications-wrapper .publication-image {
  overflow: hidden;
}

.publications-wrapper .publication-image img {
  width: 100%;
  max-width: 100%;
  height: 300px;
  object-fit: cover;
  transform: scale(1, 1);
  transition-property: transform, filter, opacity;
  transition-timing-function: cubic-bezier(0.57, 0.21, 0.69, 1);
  transition-duration: 0.3s;
}

.publications-wrapper .publication-image:hover img {
  transform: scale(1.05, 1.05);
}

.tiptop-editor .node-bookmarkBlock,
.tiptop-editor .node-tableOfContentsNode,
.tiptop-editor .node-spotifyBlock,
.tiptop-editor .node-soundCloudBlock,
.tiptop-editor .node-other,
.tiptop-editor .node-products {
  margin-bottom: 20px;
}

.tiptop-editor .node-fileBlock,
.tiptop-editor .node-publications {
  margin-bottom: 10px;
}

.dashboard.new-publication:has(.popupContainer),
.dashboard.new-page:has(.popupContainer),
.dashboard.new-newsletter:has(.popupContainer) {
  position: relative;
  z-index: 15;
}

.main-wrapper:has(.uploadMediaPopup) .sidebar, .main-wrapper:has(.uploadMediaPopup) .topbar-container, .main-wrapper:has(.uploadMediaPopup) .page-right-sidebar {
  z-index: -1;
}
.tiptop-editor .main-wrapper .main-content {
  z-index: 10;
}

.swiper-slider {
  z-index: 50;
  grid-column-gap: 1.5rem;
  grid-row-gap: 1.5rem;
  text-align: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  display: flex;
  position: relative;
  overflow: hidden;
}

.swiper-slider-container {
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  width: 100%;
  display: flex;
}

.swiper-slider-list {
  animation: logoSliderScroll 15s linear infinite;
  -webkit-user-select: none;
  user-select: none;
  will-change: transform;
  transform-style: preserve-3d;
  animation-duration: 66.8s;
  flex: none;
}

.swiper-items {
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  display: flex;
}

.swiper-slide-item {
  height: 4.5rem;
}

.swiper-slide-item img {
  vertical-align: middle;
  max-width: 100%;
  display: inline-block;
  height: 100%;
  border: 0;
}

.twitterBlock td,
.twitterBlock th {
  border: 0 !important
}

.twitterBlock tr td table tr td {
  padding: 0;
}

.tiptop-editor .twitterBlock .userSubPanel .userName {
  display: block;
  font-size: 16px;
  color: #1c2022;
  font-weight: 700;
  margin-bottom: 0;
  line-height: unset;
}

.tiptop-editor .twitterBlock .userSubPanel .userNamewithLink {
  display: block;
  color: #697882;
  font-size: 16px;
  margin-bottom: 0;
  line-height: unset;
  margin-top: 0;
}

.tiptop-editor .twitterBlock .retweetCount {
  margin-left: 5px
}

.tiptop-editor .twitterBlock .likeCount,
.tiptop-editor .twitterBlock .retweetCount {
  color: #697882;
  font-size: 14px
}

.tiptop-editor .twitterBlock .likeCount span,
.tiptop-editor .twitterBlock .retweetCount span {
  color: #1C2022;
  font-weight: bold;
}

.field-info {
  font-weight: 400;
}

.tiptop-editor .category-grid-wrapper {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.tiptop-editor .parent-category-grid-wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.tiptop-editor .category-item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 25px 30px;
  flex-wrap: wrap;
  border-radius: 8px;
  background-color: #f6f6f6;
  flex: 1 1;
}

.tiptop-editor .parent-category-grid-wrapper .category-item{
  padding: 12px 20px;
}

body:has(.layout-two-column .parent-category-grid-wrapper) .image-block .image-preview img {
  max-height: 300px;
}

body:has(.layout-two-column .parent-category-grid-wrapper) .image-block{
  margin-bottom: 0;
}

.tiptop-editor .category-item img {
  width: 100%;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 30px;
}
.tiptop-editor .parent-category-grid-wrapper .category-item{
  background-color: #fff;
  border: 1px solid #b4b4b4;
  border-radius: 4px;
}

.tiptop-editor .parent-category-grid-wrapper .category-item img{
  margin-bottom: 0;
}

.tiptop-editor .category-item .heading {
  font-size: 24px;
  font-weight: 600;
  color: #55883b;
}
.tiptop-editor .parent-category-grid-wrapper .category-item .heading {
  font-size: 16px;
  font-weight: 600;
  color: #55883b;
  margin: 0;
}

.tiptop-editor .category-link {
  background-color: #55883b;
  color: #fff;
  padding: 5px 8px;
  border-radius: 4px;
  text-decoration: none;
  font-size: 12px;
  font-weight: 600;
}

.tiptop-editor .top-deal-grid-wrapper {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;
  margin-bottom: 20px;
}

.tiptop-editor .top-deal-columns-block {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-radius: 8px;
  background-color: #fff;
}

.tiptop-editor .top-deal-columns-block.layout-top-deal-two-column {
  grid-template-columns: repeat(2, 1fr);
}

.tiptop-editor [data-type='columns'].top-deal-columns-block.is-editor-empty::before {
  content: '';
  display: none;
}

.tiptop-editor .top-deal-item img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
}

.tiptop-editor .category-selector {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.tiptop-editor .product-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0px, 1fr));
  gap: 16px;
}

.tiptop-editor .product-card {
  border: 1px solid #b4b4b4;
  border-radius: 4px;
  padding: 16px;
  background: #fff;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.tiptop-editor .brand-content {
  display: flex;
  padding: 12px;
  gap: 10px;
}

.tiptop-editor .discount-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  background: #e53935;
  color: #fff;
  font-size: 12px;
  padding: 3px 6px;
  border-radius: 4px;
}

.tiptop-editor .product-image img {
  width: 100%;
  height: 150px;
  object-fit: contain;
}

.tiptop-editor .product-category {
  font-size: 12px;
  color: #777;
  margin: 0;
}

.tiptop-editor .product-title {
  font-size: 14px;
  font-weight: 600;
  margin: 4px 0;
}

.tiptop-editor .price-wrapper {
  margin: 6px 0;
}

.tiptop-editor .old-price {
  text-decoration: line-through;
  color: #999;
  margin-right: 6px;
}

.tiptop-editor .new-price,
.tiptop-editor .unit {
  font-weight: 600;
  color: #2e7d32;
}

.tiptop-editor .rating {
  font-size: 12px;
  margin: 6px 0;
}

.tiptop-editor .add-to-cart-btn {
  width: 100%;
  padding: 8px;
  border: 1px solid #b4b4b4;
  background: #fff;
  cursor: pointer;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
}

.products-bubble-block .button-wrapp {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 6px;
}

.products-bubble-block .button-wrapp input[type="checkbox"]::before {
  margin-right: 0;
}

.products-bubble-block .button-wrapp input[type="checkbox"] {
  margin: 0;
}

.tiptop-editor .bubble-toggle-menu .products-bubble-block .toggle-button-label {
  margin: 0;
  margin-bottom: 0;
}

.bubble-toggle-menu.button-box.image-bubble-menu.products,
.bubble-toggle-menu.button-box.image-bubble-menu.brand {
  padding: 12px !important;
}

.products-bubble-block .button-element button,
.brand-bubble-block .button-element button {
  line-height: unset !important;
  padding: 8px 12px !important;
  margin-top: 15px;
}

.products-node-wrapper .ringLoader:before,
.brand-node-wrapper .ringLoader:before,
.review-wrapper .ringLoader:before,
.review-node-wrapper .ringLoader:before {
  border: 2px solid #000000;
}

.brand-node-wrapper .brand-image {
  height: 100px;
  width: 200px;
}

.brand-node-wrapper .brand-image img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

@media screen and (max-width: 1450px) {

  .tiptop-editor .publications-wrapper .publication-list.grid.three-column,
  .tiptop-editor .publications-wrapper .publication-list.grid.four-column {
    grid-template-columns: repeat(2, minmax(0px, 1fr))
  }

  .tiptop-editor .publications-wrapper .publication-list.grid .publication-item .publication-image {
    height: 160px;
  }

  .tiptop-editor .product-grid {
    grid-template-columns: repeat(3, minmax(0px, 1fr));
  }
}

@media screen and (max-width: 1260px) {

  .new-publication .publication-Regular.newpageContent .newpageLeft,
  .new-page .newpageLeft,
  .new-newsletter .newpageLeft {
    padding-right: 80px;
    padding-left: 80px;
  }

  .tiptop-editor .video-wrapper .image-preview.image-width-wide,
  .tiptop-editor .image-block .image-preview.image-width-full,
  .tiptop-editor .logoslider-wapper.image-width-full {
    width: calc(100vw - 312px - 36px - 36px - 40px);
  }

  .tiptop-editor .publication-list.list .publication-item {
    display: flex;
    align-items: flex-start;
    margin-top: 20px;
  }

  .tiptop-editor .publications-wrapper .publication-list.list .publication-image {
    width: 40%;
  }

  .tiptop-editor .publications-wrapper .publication-image img {
    width: 100%;
  }

  .tiptop-editor .publication-list.list .publication-data {
    width: 60%;
    padding-left: 15px;
    padding-top: 0;
  }

  .dashboard.new-publication:has(.popupContainer) .newpageRight,
  .dashboard.new-page:has(.popupContainer) .newpageRight,
  .dashboard.new-newsletter:has(.popupContainer) .newpageRight {
    visibility: hidden;
  }

  .tiptop-editor .publications-wrapper .publication-list.grid .publication-item .publication-image {
    height: 220px;
  }

  .tiptop-editor .product-grid {
    grid-template-columns: repeat(2, minmax(0px, 1fr));
  }
}

@media screen and (max-width: 1240px) {

  .tiptop-editor .video-wrapper .image-preview.image-width-wide,
  .tiptop-editor .image-block .image-preview.image-width-full,
  .tiptop-editor .logoslider-wapper.image-width-full {
    width: calc(100vw - 312px - 36px - 40px);
  }
}

@media screen and (max-width: 1024px) {

  .tiptop-editor .video-wrapper .image-preview.image-width-wide,
  .tiptop-editor .image-block .image-preview.image-width-full,
  .tiptop-editor .logoslider-wapper.image-width-full {
    width: calc(90vw - 36px);
  }

  .tiptop-editor .publications-wrapper .publication-list.grid.three-column {
    grid-template-columns: repeat(3, minmax(0px, 1fr))
  }

  .tiptop-editor .publications-wrapper .publication-list.grid.four-column {
    grid-template-columns: repeat(4, minmax(0px, 1fr))
  }

  .tiptop-editor .publications-wrapper .publication-list.list .publication-image {
    width: 30%;
  }

  .tiptop-editor .publications-wrapper .publication-image img {
    width: 100%;
  }

  .tiptop-editor .publication-list.list .publication-data {
    width: 70%;
    padding-left: 15px;
    padding-top: 0;
  }

  .new-publication .publication-Regular.newpageContent .newpageLeft,
  .new-page .newpageContent .newpageLeft,
  .new-newsletter .newpageContent .newpageLeft {
    padding-right: 45px;
    padding-left: 45px;
  }

  .tiptop-editor .DragHandleItems {
    flex-wrap: wrap;
  }

  .DragHandleItems .DragHandleItem {
    width: 100%;
  }

  .tiptop-editor [data-tippy-root] {
    z-index: 5 !important;
  }

  .dashboard.new-publication:has(.popupContainer),
  .dashboard.new-page:has(.popupContainer),
  .dashboard.new-newsletter:has(.popupContainer) {
    position: relative;
    z-index: 20;
  }

  .main-wrapper .main-content {
    z-index: 0;
  }

  .board:has(.popupContainer) .sidebar {
    z-index: 0;
  }

  .tiptop-editor .product-grid {
    grid-template-columns: repeat(5, minmax(0px, 1fr));
  }

}

@media (max-width: 767px) {

  .tiptop-editor .publications-wrapper .publication-list.grid {
    grid-template-columns: repeat(2, minmax(0px, 1fr));
    gap: 20px;
  }

  .tiptop-editor .linkBox {
    flex-direction: column;
  }

  .tiptop-editor .textBlock.linkBox .linkImageSection {
    width: 100% !important;
  }

  .tiptop-editor .linkBox .linkData {
    width: 100%;
    padding-left: 0;
    padding-top: 15px;
  }

  .tiptop-editor .link-content img {
    height: auto;
  }

  .tiptop-editor .video-wrapper .image-preview.image-width-wide,
  .tiptop-editor .image-block .image-preview.image-width-full,
  .tiptop-editor .logoslider-wapper.image-width-full {
    width: calc(100vw - 36px);
  }

  .tiptop-editor .publications-wrapper .publication-list.grid.three-column,
  .tiptop-editor .publications-wrapper .publication-list.grid.four-column {
    grid-template-columns: repeat(2, minmax(0px, 1fr))
  }

  .tiptop-editor [data-type='video'] .video-wrapper .player-wrapper.player-ready {
    min-height: auto;
  }

  .new-publication .publication-Regular.newpageContent .newpageLeft,
  .new-page .newpageContent .newpageLeft,
  .new-newsletter .newpageContent .newpageLeft {
    margin-left: 22px;
    margin-right: 22px !important;
  }

  .newpageContent .newpageLeft {
    width: calc(100% - 44px);
  }

  .tiptop-editor .product-grid {
    grid-template-columns: repeat(2, minmax(0px, 1fr));
  }
}

@media (max-width: 590px) {
  .tiptop-editor .publications-wrapper .publication-list.grid .publication-item .publication-image {
    height: 160px;
  }

  .tiptop-editor .parent-category-grid-wrapper {
    grid-template-columns: repeat(1, 1fr);
  }
}

@media (max-width: 430px) {
  .tiptop-editor .tiptap.ProseMirror {
    padding-bottom: 10px;
  }

  .publication-list.list .publication-item {
    flex-direction: row;
    margin-top: 20px;
  }

  .publication-list.list .publication-data {
    width: 100%;
    padding-left: 0;
  }

  .publication-list.list .publication-date {
    font-size: 14px;
  }

  .tiptop-editor .publications-wrapper .publication-list.list .publication-image {
    width: 30%;
  }

  .tiptop-editor .publication-list.list .publication-data {
    width: 70%;
    padding-left: 10px;
  }

  .publication-list.list .publication-image,
  .publication-list.grid .publication-image {
    width: 100%;
  }

  .publication-list.list .publication-image img,
  .publication-list.grid .publication-image img {
    width: 100%;
  }

  .tiptop-editor .publications-wrapper .tiptop-editor .publication-list.grid {
    grid-template-columns: repeat(1, minmax(0px, 1fr));
  }

  .tiptop-editor .AiWriter-wrapper .generator-menulist,
  .tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button {
    padding: 0.5rem 0.60rem;
    gap: 0.2rem;
  }

  .tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button {
    width: 100%;
  }

  .tiptop-editor .generator-menulist .menuitem {
    width: 100%;
    height: 11rem;
    overflow-y: scroll;
    margin-left: 4px;
  }

  .tiptop-editor .generator-menu .ai-button,
  .tiptop-editor .AiWriter-wrapper .generator-menu {
    flex-direction: column;
  }

  .AiWriter-wrapper .generator-menu {
    gap: 0.5rem;
  }

  .tiptop-editor .AiWriter-wrapper .generate-button {
    width: 100%;
  }

  .tiptop-editor .AiWriter-wrapper .button .generate-button.insertbtn {
    display: none;
  }

  .tiptop-editor .AiWriter-wrapper .button .generate-button .mobile-button {
    display: block;
  }

  .tiptop-editor .publications-wrapper .publication-list.grid.three-column,
  .tiptop-editor .publications-wrapper .publication-list.grid.four-column,
  .tiptop-editor .publications-wrapper .publication-list.grid.two-column {
    grid-template-columns: repeat(1, minmax(0px, 1fr))
  }
}


@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes prixClipFix {
  0% {
    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
  }

  25% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
  }

  50% {
    clip-path: polygon(50% 50%,
        0 0,
        100% 0,
        100% 100%,
        100% 100%,
        100% 100%);
  }

  75% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);
  }

  100% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
  }
}

@keyframes loading {
  0% {
    opacity: 0.6;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.6;
  }
}

@keyframes progress {
  0% {
    width: 0%;
  }

  25% {
    width: 50%;
  }

  50% {
    width: 75%;
  }

  75% {
    width: 85%;
  }

  100% {
    width: 100%;
  }
}

;

/* Why Choose Mal Mart Styles */
.whychoosemalmart-node-wrapper {
  margin-bottom: 20px;
}

.whychoosemalmart-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.whychoosemalmart-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
}

.whychoosemalmart-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.whychoosemalmart-image {
  width: 70px;
  height: 70px;
  margin-bottom: 8px;
}

.whychooseus-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.whychooseus-item {
  display: flex;
  flex-direction: column;
  /* align-items: center;
  text-align: center; */
}

.whychooseus-image {
  width: 150px;
  height: 110px;
  margin-bottom: 8px;
}

.whychoosemalmart-image img, .whychooseus-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

h3.whychoosemalmart-title {
  font-size: 16px;
  color: #1a1a1a;
  margin-bottom: 4px;
}

h3.whychooseus-title {
  font-size: 18px;
  color: #1a1a1a;
  margin-bottom: 4px;
  text-align: left;
  font-weight: 500;
}

/* Our Services Styles */
.ourservices-node-wrapper {
  margin-bottom: 20px;
}

.ourservices-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.ourservices-content h5{
  font-size: 28px;
  text-align: center;
  font-weight: 600;
  margin-bottom: 8px;
  margin-top: 20px !important;
}

.ourservices-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
}

.ourservices-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.ourservices-image {
  width: 150px;
  height: 100px;
}

.ourservices-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

p.ourservices-title {
  font-size: 18px;
  color: #5f5f5f;
  margin-bottom: 4px;
  margin-top: 8px;
  line-height: unset;
}

.ProseMirror p.ourservices-description {
  font-size: 14px;
  color: #737373;
  margin: 0;
  line-height: unset;
}

@media (max-width: 1024px) {
  .ourservices-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
  }
}

@media (max-width: 768px) {
  .ourservices-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  .ourservices-item {
    padding: 15px;
  }

  .ourservices-image {
    width: 60px;
    height: 60px;
    margin-bottom: 10px;
  }

  .ourservices-title {
    font-size: 16px;
  }

  .ourservices-description {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .ourservices-grid {
    grid-template-columns: repeat(1, 1fr);
    gap: 10px;
  }

  .ourservices-item {
    padding: 15px;
  }
}

/* Offers Block Styles */

.offers-node-wrapper {
  padding: 0.5rem;
}

.offers-content {
  text-align: center;
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
}

.offers-content h5{
  font-size: 32px;
  font-weight: 600;
  color: #333;
  margin-bottom: 30px;
  margin-top: 0;
}

.offers-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.offers-item {
    padding: 20px;
    border-radius: 12px;
    width: calc(33.33% - 20px);
}

.offers-image {
  width: 150px;
  height: 110px;
  margin: 0 auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.offers-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

p.offers-title {
  font-size: 18px;
  color: #5f5f5f;
  margin-bottom: 4px;
  margin-top: 8px;
  line-height: unset;
}

@media (max-width: 1024px) {
  .offers-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
  }
}

@media (max-width: 768px) {
  .offers-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  .offers-item {
    padding: 15px;
  }

  .offers-image {
    width: 60px;
    height: 60px;
    margin-bottom: 10px;
  }

  .offers-title {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .offers-grid {
    grid-template-columns: repeat(1, 1fr);
    gap: 10px;
  }

  .offers-item {
    padding: 15px;
  }
}

/* Review Block Styles */
.tiptop-editor .review-node-wrapper {
  padding: 0.5rem;
}

.tiptop-editor .review-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.tiptop-editor .review-item {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border: 1px solid #b4b4b4;
  border-radius: 16px;
  background-color: #fff;
}

.tiptop-editor .review-stars {
  display: flex;
  margin-bottom: 16px;
}

.tiptop-editor .review-stars img{
  height: 20px;
  width: 20px;
}

.tiptop-editor .review-description {
  flex: 1 1;
  margin-bottom: 16px;
}

.tiptop-editor .review-name {
  font-size: 14px;
  color: #737373;
}

@media (max-width: 768px) {
  .tiptop-editor .review-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}

@media (max-width: 1024px) {
  .tiptop-editor .review-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.ProseMirror p.whychoosemalmart-description {
  font-size: 16px;
  color: #737373;
  margin: 0;
  line-height: unset;
}

/* Top Deal Styles */


/* Responsive for Why Choose Mal Mart */
@media (max-width: 1024px) {
  .whychoosemalmart-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
}

@media (max-width: 768px) {

  .whychoosemalmart-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  .whychoosemalmart-item, .whychooseus-item {
    padding: 15px;
  }

  .whychoosemalmart-image, .whychooseus-image {
    width: 60px;
    height: 60px;
    margin-bottom: 10px;
  }

  .whychoosemalmart-title {
    font-size: 16px;
  }

  .whychoosemalmart-description {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .whychoosemalmart-grid {
    grid-template-columns: repeat(1, 1fr);
    gap: 10px;
  }

  .whychoosemalmart-item, .whychooseus-item {
    padding: 15px;
  }
}

/* Responsive for Top Deal */
@media (max-width: 768px) {
  .tiptop-editor .top-deal-grid-wrapper {
    grid-template-columns: repeat(1, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TiptapEditor/Editor.css"],"names":[],"mappings":"AAAA;EACE;IACE,wBAAwB;IACxB,+BAA+B;EACjC;;EAEA;IACE,4BAA4B;IAC5B,mCAAmC;EACrC;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;;AAGA;EACE,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX,WAAW;EACX,uBAAuB;AACzB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;EAGE,qBAAqB;EACrB,4DAA4D;EAC5D,wBAAwB;EACxB,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;;;EAME,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,YAAY;EACZ,yBAAyB;EAEzB,iBAAiB;AACnB;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,+BAA+B;EAC/B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,oEAA0E;EAC1E,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,+GAA+G;EAC/G,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;;;;;;;;;;;;EAYE;AACF;;AAEA;;;;;;EAME;AACF;;AAEA;;;;;;EAME;AACF;;AAEA;;;;;;EAME,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;EACtB,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,wBAAwB;EACxB,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;;EAEzB,uBAAuB;;EAEvB,uEAAuE;;EAEvE,+GAA+G;;EAE/G,iBAAiB;AACnB;;AAEA;EACE,+GAA+G;EAC/G,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;;;;;EAQE,cAAc;AAChB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,iEAAiE;AACnE;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,QAAQ;EACR,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,iEAAiE;AACnE;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf;yBACuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,wDAAwD;EACxD,yBAAyB;EACzB,uDAAuD;AACzD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,sBAAsB;EACtB,gCAAgC;EAChC,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;;;EAGE,+BAA+B;EAC/B,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,kDAAkD;EAClD,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,eAAe;EACf,sBAAsB;EACtB,qBAAqB;EACrB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,sCAAsC;EACtC,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mDAA+C;EAC/C,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,mFAAmF;EACnF,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,QAAQ;EACR,uBAAuB;EACvB,QAAQ;AACV;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,QAAQ;EACR,sBAAsB;EACtB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,yCAAyC;EACzC,cAAc;EACd,wBAAwB;EACxB,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,QAAQ;EACR,mFAAmF;EACnF,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,QAAQ;EACR,sBAAsB;EACtB,eAAe;EACf,MAAM;EACN,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,yCAAyC;EACzC,cAAc;EACd,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,4DAA4D;EAC5D,wBAAwB;EACxB,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,gCAAgC;EAChC,uBAAuB;EACvB,6BAA6B;EAC7B,UAAU;EACV,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,sBAAsB;EACtB,uCAAuC;EACvC,aAAa;EACb,sCAAsC;EACtC,sCAAsC;EACtC,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,+DAA+D;EAC/D,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,sBAAsB;EACtB,eAAe;EACf,oBAAoB;;EAEpB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,cAAc;EACd,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,sBAAsB;AACtB;;;;;;;EAOE,kBAAkB;EAClB,aAAa;AACf;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;;;;EAME,iBAAiB;EACjB,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;EAME,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;;EAME,eAAe;EACf,iBAAiB;EACjB,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,yCAAyC;EACzC,MAAM;AACR;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,mDAAmD;EACnD,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,kDAAkD;EAClD,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf;uBACqB;EACrB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;;AAGA,gBAAgB;AAChB;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;;AAElB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,mDAAmD;EACnD,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,mDAAmD;EACnD,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;;;EAGE,uDAAuD;EACvD,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;;AAEb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;GAKG;AACH;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,0CAA0C;EAC1C,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,qDAAqD;EACrD,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,wCAAwC;EACxC,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;EACX,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,uBAAuB;EACvB,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,uBAAuB;EACvB,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;;;;;;;EAUE,6BAA6B;AAC/B;;AAEA;;GAEG;AACH;;;;;;;;;;;;;;EAcE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;;;EAGE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;;;;EAME,gCAAgC;EAChC,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;;;;;EAME,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;;;;;EAME,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;;;EAME,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;;;EAME,YAAY;EACZ,aAAa;AACf;;AAEA;;;;;;EAME,iBAAiB;EACjB,yBAAyB;EACzB,8FAA8F;EAC9F,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;;;;EAME,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,4BAA4B;EAC5B,QAAQ;EACR,MAAM;AACR;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;;;;;;EAME,eAAe;AACjB;;AAEA;;;;;;EAME,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,eAAe;AACjB;;AAEA;;;;;;EAME,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,+BAA+B;EAC/B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;;;;;;EAME,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;;;EAME,wDAAwD;EACxD,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;;;;EAME,6BAA6B;EAC7B,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;;AAEA;;;;;;EAME,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;;;;;;EAME,gBAAgB;AAClB;;AAEA;;;;;;EAME,qBAAqB;AACvB;;AAEA;;;;;;EAME,qBAAqB;AACvB;;AAEA;;;;;;EAME,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,+CAA+C;EAC/C,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EAEzB,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,SAAS;AACX;;AAEA;;EAEE;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE;AACF;;AAEA;;EAEE,cAAc;EACd;AACF;;AAEA;;EAEE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,6BAA6B;EAC7B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE;;IAEE;EACF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kDAAkD;EACpD;AACF;;AAEA;;EAEE;;;IAGE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;;IAGE,+CAA+C;EACjD;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,cAAc;EAChB;;EAEA;;;IAGE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kDAAkD;EACpD;AACF;;AAEA;;EAEE;;;IAGE,wCAAwC;EAC1C;AACF;;AAEA;;EAEE;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,cAAc;EAChB;;EAEA;;;IAGE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;;IAGE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kDAAkD;EACpD;;AAEF;;AAEA;;EAEE;IACE,kDAAkD;IAClD,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;;;IAGE,yBAAyB;EAC3B;;EAEA;;IAEE;EACF;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;IAGE,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,kDAAkD;EACpD;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,kDAAkD;EACpD;;EAEA;;IAEE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;;;IAGE;EACF;AACF;;;AAGA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,oDAAoD;EACtD;;EAEA;IACE,gEAAgE;EAClE;;EAEA;IACE;;;;;kBAKc;EAChB;;EAEA;IACE,mEAAmE;EACrE;;EAEA;IACE,gEAAgE;EAClE;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF;;;;AAIA,+BAA+B;AAC/B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB;uBACqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,wBAAwB;;AAExB;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,wBAAwB;AACxB;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA,oBAAoB;;;AAGpB,uCAAuC;AACvC;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;;EAEE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":["@keyframes logoSliderScroll {\n  from {\n    transform: translateX(0);\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    transform: translateX(-100%);\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n\n.newpageContent:has(.tiptop-editor) .newpageLeft {\n  z-index: 9;\n}\n\n.tiptop-editor:has(.uploadMediaPopup) [data-tippy-root] {\n  display: none !important;\n}\n\n.tiptop-editor [data-tippy-root] {\n  z-index: 3 !important;\n}\n\n.tiptop-editor *,\n.tiptop-editor ::before,\n.tiptop-editor ::after {\n  box-sizing: border-box;\n  border-width: 0;\n  border-style: solid;\n  border-color: #e5e7eb;\n}\n\n.tiptop-editor .ProseMirror {\n  outline: none !important;\n  border: none !important;\n  min-height: 100%;\n  z-index: 0;\n  margin-left: auto;\n  margin-right: auto;\n  /* max-width: 740px; */\n  width: 100%;\n  padding: 15px 20px;\n  caret-color: #000;\n  outline-width: 0;\n  font-size: 16px;\n  padding-top: 0;\n  margin-top: 25px;\n  font-weight: 400;\n}\n\n\n.ProseMirror .is-empty::before {\n  pointer-events: none;\n  float: left;\n  height: 0px;\n  width: 100%;\n  color: rgb(0 0 0 / 0.4);\n}\n\nProseMirror.ProseMirror-focused>p.is-empty::before,\nProseMirror.ProseMirror-focused>p.has-focus.is-empty::before {\n  content: 'Type  /  to browse options';\n}\n\n.ProseMirror.ProseMirror-focused>[data-type='columns']>[data-type='column']>p.is-empty.has-focus::before {\n  content: 'Type  /  to browse options';\n}\n\n.ProseMirror>.is-editor-empty::before {\n  content: attr(data-placeholder);\n}\n\n.ProseMirror>.is-editor-empty[data-placeholder='']::before,\n.ProseMirror>.is-editor-empty:not([data-placeholder])::before {\n  content: 'Type / to browse options';\n}\n\n.ProseMirror>[data-type=\"blockquoteFigure\"].is-editor-empty::before {\n  content: '';\n}\n\n.ProseMirror blockquote .is-empty:first-child:last-child::before {\n  content: 'Enter a quote...';\n}\n\n.ProseMirror blockquote+figcaption.is-empty::before {\n  content: 'Author';\n}\n\n.ProseMirror [data-placeholder][data-suggestion]::before,\n.ProseMirror [data-placeholder][data-suggestion] *::before {\n  content: none !important;\n}\n\n.ProseMirror .node-aiWriter.has-focus [data-node-view-wrapper]>*,\n.ProseMirror .node-aiImage.has-focus [data-node-view-wrapper]>*,\n.ProseMirror .node-tableOfContentsNode.has-focus [data-node-view-wrapper]>* {\n  border-radius: 0.5rem;\n  box-shadow: 0 0 #0000, 0 0 #0000, 0 0 0 2px rgb(0 0 0 / 0.3);\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.ProseMirror [contenteditable=\"false\"] {\n  white-space: normal;\n}\n\n.ProseMirror p {\n  margin-top: 0.75rem;\n  margin-bottom: 20px;\n  line-height: 26px;\n  font-size: 18px;\n  font-weight: 400;\n  color: #101828;\n}\n\n.ProseMirror p:first-child {\n  margin-top: 0px;\n}\n\n.ProseMirror a {\n  color: #3b82f6;\n}\n\n.ProseMirror a.link {\n  font-weight: 500;\n  color: rgb(59 130 246 / 1);\n}\n\n.ProseMirror>ul,\n.ProseMirror>ol {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\n.ProseMirror ul ul,\n.ProseMirror ul ol,\n.ProseMirror ul li,\n.ProseMirror ol ul,\n.ProseMirror ol ol,\n.ProseMirror ol li {\n  margin-top: 0.25rem;\n  margin-bottom: 0.25rem;\n}\n\n.ProseMirror ul p,\n.ProseMirror ol p {\n  margin-top: 0px;\n  margin-bottom: 0.25rem;\n}\n\n.ProseMirror [contenteditable=\"false\"] {\n  white-space: normal;\n}\n\n.ProseMirror ul[data-type='taskList'] {\n  list-style-type: none;\n  padding: 0px;\n}\n\n.ProseMirror ul[data-type='taskList'] li {\n  display: flex;\n}\n\n.ProseMirror ul[data-type='taskList'] li[data-checked='true'] div p {\n  text-decoration-line: line-through;\n}\n\n.ProseMirror ul[data-type='taskList'] li>label {\n  margin-top: 5px;\n  margin-right: 4px;\n  flex: 1 1 auto;\n  flex-shrink: 0;\n  flex-grow: 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n}\n\n\n.ProseMirror ul[data-type='taskList'] li>div {\n  flex: 1 1 auto;\n}\n\n.ProseMirror ul[data-type='taskList'] p {\n  margin: 0px;\n}\n\n.ProseMirror ul[data-type='taskList'] input {\n  font-style: unset;\n  font-weight: unset;\n  font-size: unset;\n  line-height: unset;\n  color: unset;\n  padding: unset;\n  gap: unset;\n  background: unset;\n  box-shadow: unset;\n  border-radius: unset;\n  outline: unset;\n  border: unset;\n  width: unset;\n}\n\n.ProseMirror ul[data-type='taskList'] input {\n  font-size: 0;\n  width: 18px;\n  height: 18px;\n  border: 1px solid transparent;\n  -o-appearance: none;\n  appearance: none;\n  position: relative;\n  padding: 0 0 0 0;\n  margin: 0;\n}\n\n.ProseMirror ul[data-type='taskList'] input:before {\n  content: \"\";\n  border: 1px solid black;\n  display: block;\n  width: 15px;\n  background: none;\n  height: 15px;\n  margin-right: 7px;\n  border-radius: 4px;\n  min-width: 16px;\n  min-height: 16px;\n  margin-right: 15px;\n  background-size: 60%;\n  background-position: 4px center;\n  background-repeat: no-repeat;\n  accent-color: #e6f2ff;\n}\n\n.ProseMirror ul[data-type='taskList'] input[type=\"checkbox\"]:checked:before {\n  background-image: url('../../assets/images/checkbox-black.svg') !important;\n  border: 1px solid black;\n}\n\n.ProseMirror b {\n  font-weight: bolder;\n}\n\n.ProseMirror strong {\n  font-weight: 700;\n}\n\n.ProseMirror code,\n.ProseMirror kbd,\n.ProseMirror samp,\n.ProseMirror pre {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  font-size: 1em;\n}\n\n.ProseMirror h1 {\n  font-size: 1.875rem;\n  line-height: 2.25rem\n}\n\n.ProseMirror h2 {\n  font-size: 1.5rem;\n  line-height: 2rem\n}\n\n.ProseMirror h3 {\n  font-size: 1.25rem;\n  line-height: 1.75rem\n}\n\n.ProseMirror h4 {\n  font-size: 1.125rem;\n  line-height: 1.75rem\n}\n\n.ProseMirror h5 {\n  font-size: 1rem;\n  line-height: 1.5rem\n}\n\n.ProseMirror h6 {\n  font-size: 0.875rem;\n  line-height: 1.25rem\n}\n\n.ProseMirror h1,\n.ProseMirror h2,\n.ProseMirror h3,\n.ProseMirror h4,\n.ProseMirror h5,\n.ProseMirror h6,\n.ProseMirror h1 a.link,\n.ProseMirror h2 a.link,\n.ProseMirror h3 a.link,\n.ProseMirror h4 a.link,\n.ProseMirror h5 a.link,\n.ProseMirror h6 a.link {\n  font-weight: 700\n}\n\n.ProseMirror h1:first-child,\n.ProseMirror h2:first-child,\n.ProseMirror h3:first-child,\n.ProseMirror h4:first-child,\n.ProseMirror h5:first-child,\n.ProseMirror h6:first-child {\n  margin-top: 0px\n}\n\n.ProseMirror h1:last-child,\n.ProseMirror h2:last-child,\n.ProseMirror h3:last-child,\n.ProseMirror h4:last-child,\n.ProseMirror h5:last-child,\n.ProseMirror h6:last-child {\n  margin-bottom: 0px\n}\n\n.ProseMirror h1,\n.ProseMirror h2,\n.ProseMirror h3,\n.ProseMirror h4,\n.ProseMirror h5,\n.ProseMirror h6 {\n  margin-bottom: 20px;\n  margin-top: 0;\n  color: #000;\n}\n\n.ProseMirror>blockquote blockquote,\n.ProseMirror [data-type='blockquoteFigure'] blockquote {\n  margin: 0px;\n}\n\n.ProseMirror [data-type='blockquoteFigure'] blockquote p {\n  font-weight: 500;\n  font-size: 18px;\n  color: #344054;\n  margin: 10px 0 0;\n}\n\n.ProseMirror figure[data-type='blockquoteFigure'] {\n  margin: 0 0 20px 0;\n  color: rgb(0 0 0 / 1);\n}\n\n.ProseMirror [data-type='blockquoteFigure']>div {\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  border-left-width: 4px;\n  border-left-color: var(--bg-green);\n  --tw-bg-opacity: 0.8;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  border-radius: 4px;\n}\n\n.ProseMirror [data-type='blockquoteFigure'] figcaption {\n  margin-top: 1rem;\n  overflow: hidden;\n  font-size: 16px;\n  color: rgb(115 115 115 / 1);\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.ProseMirror [data-type='blockquoteFigure'] figcaption span {\n  font-size: 16px !important;\n  color: rgb(115 115 115 / 1) !important;\n}\n\n.ProseMirror blockquote .is-empty:not(.is-editor-empty):first-child:last-child::before {\n  content: 'Enter a quote...';\n}\n\n.ProseMirror blockquote+figcaption.is-empty:not(.is-editor-empty)::before {\n  content: 'Author';\n}\n\n.ProseMirror code {\n  caret-color: white;\n  color: white;\n  background-color: #171717;\n\n  border-radius: 0.125rem;\n\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);\n\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n\n  line-height: 24px;\n}\n\n.ProseMirror code * {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  line-height: 24px;\n}\n\n.ProseMirror code::selection {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n\n.ProseMirror pre {\n  caret-color: white;\n  color: #f6f6f6;\n  background: #282c34;\n  border-radius: 0.375rem;\n  margin: 0 0 20px 0;\n  padding: 1rem;\n  border: 1px solid black;\n}\n\n.ProseMirror pre *::selection {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.ProseMirror pre code {\n  color: #f6f6f6;\n  background: #282c34;\n  padding: 0;\n  box-shadow: none;\n}\n\n.ProseMirror pre code .hljs-comment,\n.ProseMirror pre code .hljs-quote {\n  color: #a7a7a7;\n  font-style: italic;\n}\n\n.ProseMirror pre code .hljs-doctag,\n.ProseMirror pre code .hljs-keyword,\n.ProseMirror pre code .hljs-formula {\n  color: #c678dd;\n}\n\n.ProseMirror pre code .hljs-section,\n.ProseMirror pre code .hljs-name,\n.ProseMirror pre code .hljs-selector-tag,\n.ProseMirror pre code .hljs-deletion,\n.ProseMirror pre code .hljs-subst {\n  color: #e06c75;\n}\n\n.ProseMirror pre code .hljs-literal {\n  color: #56b6c2;\n}\n\n.ProseMirror pre code .hljs-string,\n.ProseMirror pre code .hljs-regexp,\n.ProseMirror pre code .hljs-addition,\n.ProseMirror pre code .hljs-attribute,\n.ProseMirror pre code .hljs-meta-string {\n  color: #98c379;\n}\n\n.ProseMirror pre code .hljs-built_in,\n.ProseMirror pre code .hljs-class .hljs-title {\n  color: #e6c07b;\n}\n\n.ProseMirror pre code .hljs-attr,\n.ProseMirror pre code .hljs-variable,\n.ProseMirror pre code .hljs-template-variable,\n.ProseMirror pre code .hljs-type,\n.ProseMirror pre code .hljs-selector-class,\n.ProseMirror pre code .hljs-selector-attr,\n.ProseMirror pre code .hljs-selector-pseudo,\n.ProseMirror pre code .hljs-number {\n  color: #d19a66;\n}\n\n.ProseMirror pre code .hljs-symbol,\n.ProseMirror pre code .hljs-bullet,\n.ProseMirror pre code .hljs-link,\n.ProseMirror pre code .hljs-meta,\n.ProseMirror pre code .hljs-selector-id,\n.ProseMirror pre code .hljs-title {\n  color: #61aeee;\n}\n\n.ProseMirror pre code .hljs-emphasis {\n  font-style: italic;\n}\n\n.ProseMirror pre code .hljs-strong {\n  font-weight: bold;\n}\n\n.ProseMirror pre code .hljs-link {\n  text-decoration: underline;\n}\n\n.ProseMirror .tableWrapper {\n  margin-top: 0;\n  margin-bottom: 20px;\n}\n\n.ProseMirror table {\n  box-sizing: border-box;\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  border-radius: 0.25rem;\n  border-color: rgba(0, 0, 0, 0.1);\n}\n\n.ProseMirror table::-webkit-scrollbar,\n.ProseMirror table::-webkit-scrollbar-track,\n.ProseMirror table::-webkit-scrollbar-thumb {\n  cursor: pointer;\n}\n\n.tiptop-editor .tableWrapper:has(.ProseMirror-widget) table {\n  padding: 10px 0 0 10px;\n}\n\n.ProseMirror table td,\n.ProseMirror table th {\n  position: relative;\n  min-width: 150px;\n  border-width: 1px;\n  border-color: rgba(0, 0, 0, 0.1);\n  padding: 0.5rem;\n  text-align: left;\n  vertical-align: top;\n}\n\n.ProseMirror table td:first-of-type:not(a),\n.ProseMirror table th:first-of-type:not(a) {\n  margin-top: 0px;\n}\n\n.ProseMirror table td p,\n.ProseMirror table th p {\n  margin: 0px;\n}\n\n.ProseMirror table td p+p,\n.ProseMirror table th p+p {\n  margin-top: 0.75rem;\n}\n\n.ProseMirror table th {\n  font-weight: 700;\n}\n\n.ProseMirror table .column-resize-handle {\n  pointer-events: none;\n  position: absolute;\n  bottom: -2px;\n  right: -0.25rem;\n  top: 0px;\n  display: flex;\n  width: 0.5rem;\n}\n\n.ProseMirror table .column-resize-handle::before {\n  margin-left: 0.5rem;\n  height: 100%;\n  width: 1px;\n  background-color: rgba(0, 0, 0, 0.2);\n  content: '';\n}\n\n.ProseMirror table .selectedCell {\n  border-style: double;\n  border-color: rgba(0, 0, 0, 0.2);\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.ProseMirror table .grip-column,\n.ProseMirror table .grip-row {\n  position: absolute;\n  z-index: 10;\n  display: flex;\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.ProseMirror table .grip-column {\n  left: 0px;\n  top: -0.75rem;\n  margin-left: -1px;\n  height: 0.75rem;\n  width: calc(100% + 1px);\n  border-left-width: 1px;\n  border-color: rgba(0, 0, 0, 0.2);\n}\n\n.ProseMirror table .grip-column:hover::before,\n.ProseMirror table .grip-column.selected::before {\n  content: '';\n  width: 0.625rem;\n}\n\n.ProseMirror table .grip-column:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.ProseMirror table .grip-column:hover::before {\n  border-bottom-width: 2px;\n  border-style: dotted;\n  border-color: rgba(0, 0, 0, 0.6);\n}\n\n.ProseMirror table .grip-column.first {\n  border-top-left-radius: 0.125rem;\n  border-color: transparent;\n}\n\n.ProseMirror table .grip-column.last {\n  border-top-right-radius: 0.125rem;\n}\n\n.ProseMirror table .grip-column.selected {\n  border-color: rgba(0, 0, 0, 0.3);\n  background-color: rgba(0, 0, 0, 0.3);\n  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.ProseMirror table .grip-column.selected::before {\n  border-bottom-width: 2px;\n  border-style: dotted;\n}\n\n.ProseMirror table .grip-row {\n  left: -0.75rem;\n  top: 0px;\n  margin-top: -1px;\n  height: calc(100% + 1px);\n  width: 0.75rem;\n  border-top-width: 1px;\n  border-color: rgba(0, 0, 0, 0.2);\n}\n\n.ProseMirror table .grip-row:hover::before,\n.ProseMirror table .grip-row.selected::before {\n  height: 0.625rem;\n  content: '';\n}\n\n.ProseMirror table .grip-row:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.ProseMirror table .grip-row:hover::before {\n  border-left-width: 2px;\n  border-style: dotted;\n  border-color: rgba(0, 0, 0, 0.6);\n}\n\n.ProseMirror table .grip-row.first {\n  border-top-left-radius: 0.125rem;\n  border-color: transparent;\n}\n\n.ProseMirror table .grip-row.last {\n  border-bottom-left-radius: 0.125rem;\n}\n\n.ProseMirror table .grip-row.selected {\n  border-color: rgba(0, 0, 0, 0.3);\n  background-color: rgba(0, 0, 0, 0.3);\n  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.ProseMirror table .grip-row.selected::before {\n  border-left-width: 2px;\n  border-style: dotted;\n}\n\n.ProseMirror [data-type='horizontalRule'] {\n  margin-bottom: 20px;\n  cursor: pointer;\n  /* padding-top: 1rem;\n  padding-bottom: 1rem; */\n  transition-property: all;\n  transition-duration: 100ms;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  animation-duration: 100ms;\n  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.ProseMirror [data-type='horizontalRule'].ProseMirror-selectednode {\n  background-color: rgb(0 0 0 / 0.05);\n}\n\n.ProseMirror [data-type='horizontalRule'] hr {\n  border-width: 0px;\n  border-top-width: 1px;\n  border-color: rgb(0 0 0 / 0.2);\n  background-color: rgb(0 0 0 / 0.8);\n}\n\n.ProseMirror [data-type='horizontalRule'].ProseMirror-selectednode hr {\n  border-top-color: rgb(0 0 0 / 0.3);\n}\n\n.ProseMirror>*:first-child:first-child,\n.ProseMirror [data-type='column']>*:first-child {\n  margin-top: 0px;\n}\n\n.ProseMirror>*:first-child:last-child,\n.ProseMirror [data-type='column']>*:last-child {\n  margin-bottom: 0px;\n}\n\n.ProseMirror [data-type='column'] {\n  border-radius: 0.25rem;\n  border-width: 2px;\n  border-style: dotted;\n  border-color: transparent;\n  padding: 0.25rem;\n  transition: border 160ms cubic-bezier(0.45, 0.05, 0.55, 0.95);\n}\n\n.ProseMirror [data-type='column']:hover {\n  border-color: rgb(245 245 245 / 1);\n}\n\n.ProseMirror [data-type='column']:has(.is-active),\n.ProseMirror [data-type='column'].has-focus {\n  border-color: rgb(245 245 245 / 1);\n}\n\n.ProseMirror [data-type='columns'] {\n  margin-bottom: 20px;\n  display: grid;\n  gap: 1rem;\n}\n\n.ProseMirror [data-type='columns'].layout-sidebar-left {\n  grid-template-columns: 40fr 60fr;\n}\n\n.ProseMirror [data-type='columns'].layout-sidebar-right {\n  grid-template-columns: 60fr 40fr;\n}\n\n.ProseMirror [data-type='columns'].layout-two-column {\n  grid-template-columns: 1fr 1fr;\n}\n\n.ProseMirror [data-type='columns'].layout-three-column {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.ProseMirror [data-type='column'] {\n  overflow: auto;\n}\n\n[data-type=\"columns\"] [data-type=\"column\"]>* {\n  padding: 5px 0;\n}\n\n[data-type=\"columns\"] [data-type=\"column\"] p.is-empty:before {\n  content: 'Type  /  to browse options';\n}\n\n[data-type=\"columns\"] p,\n[data-type=\"columns\"] [data-type=\"imageBlock\"] .image-block {\n  margin-top: 0;\n}\n\n.tiptop-editor ul,\n.tiptop-editor li {\n  list-style-type: unset;\n}\n\n.tiptop-editor ul,\n.tiptop-editor ol {\n  padding-inline-start: 20px;\n}\n\n.tiptop-editor ul li::marker {\n  color: var(--bg-green);\n}\n\n.tiptop-editor ul[data-type=\"taskList\"] {\n  padding-inline-start: 0px !important;\n}\n\nul[data-type=\"taskList\"]::before,\n.tiptop-editor ol::before,\n.tiptop-editor ul::before {\n  content: '' !important;\n  pointer-events: unset !important;\n  float: unset !important;\n  height: unset !important;\n  width: unset !important;\n  color: unset !important;\n}\n\n.layout-two-column::before,\n.layout-sidebar-left::before,\n.layout-sidebar-right::before {\n  pointer-events: none !important;\n  float: unset !important;\n  height: unset !important;\n  width: unset !important;\n  color: unset !important;\n  content: unset !important;\n}\n\n::-webkit-scrollbar {\n  height: 0.25rem;\n  width: 0.25rem;\n  background-color: rgb(115 115 115 / 0.2);\n}\n\n::-webkit-scrollbar-thumb {\n  border-radius: 9999px;\n  background-color: rgb(115 115 115 / 0.5);\n}\n\n.tiptop-editor .bubble-menu {\n  color: #000;\n  display: inline-flex;\n  height: 100%;\n  line-height: 1;\n  gap: 0.125rem;\n  flex-direction: row;\n  padding: 0.25rem;\n  align-items: center;\n  background-color: #fff;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  border: 1px solid #e5e7eb;\n}\n\n.tiptop-editor .bubble-menu .divider {\n  background-color: #e5e7eb;\n  height: 100%;\n  min-height: 1.5rem;\n  width: 1px;\n  margin-left: 0.25rem;\n  margin-right: 0.25rem;\n}\n\n.tiptop-editor .bubble-menu button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.25rem;\n  height: 2rem;\n  min-width: 2rem;\n  padding: 0 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  border-radius: 0.375rem;\n  background-color: transparent;\n  border: 1px solid transparent;\n  color: #6b7280;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.tiptop-editor .bubble-menu .bubble-menu-item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid transparent;\n  font-size: 0.875rem;\n  font-weight: 600;\n  border-radius: 0.375rem;\n  opacity: 1;\n  white-space: nowrap;\n  background-color: rgba(0, 0, 0, 0.1);\n  color: #1f2937;\n  height: 2rem;\n  gap: 0.25rem;\n  min-width: 2rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  width: auto;\n}\n\n.tiptop-editor .bubble-menu button:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  color: #374151;\n}\n\n.tiptop-editor .toolbar-button>div {\n  line-height: 0;\n}\n\n.tiptop-editor .toggle-menu {\n  background-color: #fff;\n  border: 1px solid #e5e5e5;\n  border-radius: .7rem;\n  box-shadow: 3px 2px 5px 2px hsla(0, 0%, 47%, .239);\n  display: inline-grid;\n  padding: 1rem .5rem;\n  position: absolute;\n  top: 40px;\n}\n\n.tiptop-editor .bubble-toggle-menu {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  padding: 0.5rem 0.5rem;\n  background-color: #fff;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  border: 1px solid #e5e7eb;\n  position: absolute;\n  top: 40px;\n  min-width: 9rem;\n}\n\n.tiptop-editor .bubble-toggle-menu .font-label {\n  font-size: 0.65rem;\n  font-weight: 600;\n  margin: 0.25rem 0;\n  text-transform: uppercase;\n  color: #6b7280;\n  padding: 0 0.375rem;\n}\n\n.tiptop-editor .bubble-toggle-menu button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #6b7280;\n  text-align: left;\n  background-color: transparent;\n  width: 100%;\n  border: 0;\n  border-radius: 0.375rem;\n  cursor: pointer;\n}\n\n.tiptop-editor .bubble-toggle-menu button.is-active,\n.tiptop-editor .bubble-toggle-menu button:hover {\n  background-color: #f3f4f6;\n  color: #1f2937;\n}\n\n.tiptop-editor .bubble-toggle-menu.link-box {\n  position: relative;\n  top: 0;\n  padding: 0.5rem;\n  background-color: #fff;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  border: 1px solid #e5e7eb;\n}\n\n.tiptop-editor .bubble-toggle-menu.link-box form {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.tiptop-editor .bubble-toggle-menu.link-box .url-box {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem;\n  border-radius: 0.5rem;\n  background-color: #f3f4f6;\n  cursor: text;\n}\n\n.tiptop-editor .bubble-toggle-menu.link-box input {\n  flex: 1;\n  background-color: transparent;\n  outline: none;\n  min-width: 12rem;\n  color: #000;\n  font-size: 0.875rem;\n  border: 0;\n  padding: 0;\n}\n\n.tiptop-editor .bubble-toggle-menu.link-box .setlinkBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  border-radius: 0.375rem;\n  padding: 0.25rem 0.5rem;\n  border: 1px solid #000;\n  color: #fff;\n  background-color: #000;\n  white-space: nowrap;\n  height: 34px;\n}\n\n.tiptop-editor .bubble-toggle-menu.link-box .setlinkBtn:disabled {\n  opacity: 0.5;\n}\n\n.tiptop-editor .bubble-toggle-menu .toggle-button-label {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  user-select: none;\n  color: #6b7280;\n  margin-top: 10px;\n}\n\n.tiptop-editor .bubble-toggle-menu .toggle-button {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 9999px;\n  border: 1px solid transparent;\n  background-color: #e5e7eb;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  height: 1.25rem;\n  width: 2.25rem;\n  padding: 0 0.125rem;\n}\n\n.tiptop-editor .bubble-toggle-menu .toggle-button:hover {\n  background-color: #d1d5db;\n}\n\n.tiptop-editor .bubble-toggle-menu .toggle-button.checked {\n  background-color: #000;\n}\n\n.tiptop-editor .bubble-toggle-menu .toggle-button.checked:hover {\n  background-color: #374151;\n}\n\n.tiptop-editor .bubble-toggle-menu .toggle-button span {\n  display: block;\n  border-radius: 9999px;\n  pointer-events: none;\n  background-color: #fff;\n  height: 1rem;\n  width: 1rem;\n  transform: translateX(-0.5rem);\n  transition: transform 0.2s ease;\n}\n\n.tiptop-editor .bubble-toggle-menu .toggle-button.checked span {\n  transform: translateX(0.5rem);\n}\n\n.tiptop-editor .bubble-toggle-menu.button-box {\n  padding: 1rem;\n  min-width: 18rem;\n}\n\n.tiptop-editor .bubble-toggle-menu.button-box .alignment-buttons {\n  padding: 0.25rem;\n  margin-top: 0.5rem;\n  display: flex;\n  flex-direction: row;\n  margin: 0;\n  gap: 6px;\n  background-color: #EAECF0;\n  border-radius: 6px;\n}\n\n.tiptop-editor .bubble-toggle-menu.button-box .alignment-box {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.tiptop-editor .bubble-toggle-menu.button-box .box-title {\n  margin: 0;\n}\n\n.tiptop-editor .bubble-toggle-menu.button-box .alignment-buttons button {\n  width: auto;\n}\n\n.tiptop-editor .bubble-toggle-menu.button-box label {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.tiptop-editor .bubble-toggle-menu.button-box input[type=\"text\"] {\n  flex: 1 1;\n  background-color: #f3f4f6;\n  outline: none;\n  min-width: 12rem;\n  color: #101828;\n  font-size: 14px;\n  border: 0;\n  height: 45px;\n  border-radius: 6px;\n  padding: 10px 14px;\n  margin-top: 4px;\n  width: 100%;\n  border: 1px solid #d0d5dd;\n  border-radius: 6px;\n  line-height: 24px;\n}\n\n.tiptop-editor .bubble-toggle-menu .text-box input[type=\"text\"].button-url {\n  padding-left: 32px;\n}\n\n.tiptop-editor .bubble-toggle-menu.button-box #publication-count {\n  background: #fff;\n  margin-bottom: 5px;\n}\n\n.button-box .submit-button {\n  text-align: right;\n  margin-top: 12px;\n}\n\n.tiptop-editor .button-box .submit-button button {\n  width: auto;\n}\n\n.tiptop-editor .bubble-toggle-menu.button-box .url-block {\n  position: relative;\n}\n\n.tiptop-editor .bubble-toggle-menu.button-box .url-block::after {\n  content: \"\";\n  background: url('../../assets/images/link.svg');\n  background-size: 100%;\n  width: 16px;\n  height: 16px;\n  position: absolute;\n  left: 10px;\n  top: 39px;\n}\n\n.tiptop-editor .url-block .text-box .button-url {\n  padding-left: 32px;\n}\n\n.tiptop-editor .link-panel {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem;\n  background-color: #ffffff;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  border: 1px solid #e5e7eb;\n}\n\n.tiptop-editor .link-panel a {\n  font-size: 0.875rem;\n  text-decoration: underline;\n}\n\n.tiptop-editor .link-panel .divider {\n  background-color: #e5e7eb;\n  height: 100%;\n  min-height: 1.5rem;\n  width: 1px;\n  margin: 0 0.25rem;\n}\n\n.tiptop-editor .link-panel button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid transparent;\n  font-size: 0.875rem;\n  font-weight: 600;\n  border-radius: 0.375rem;\n  opacity: 1;\n  white-space: nowrap;\n  background-color: transparent;\n  color: #6b7280;\n  height: 2rem;\n  gap: 0.25rem;\n  min-width: 2rem;\n  padding: 0 0.5rem;\n  width: auto;\n  cursor: pointer;\n}\n\n.tiptop-editor .link-panel button.active {\n  background-color: rgba(0, 0, 0, 0.1);\n  color: #1f2937;\n}\n\n.tiptop-editor .toolbar-button.active,\n.tiptop-editor .bubble-toggle-menu button:hover {\n  background-color: #ffffff;\n  color: #1f2937;\n}\n\n.tiptop-editor .link-panel button:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  color: #374151;\n}\n\n.tiptop-editor .toolbar-button>div {\n  line-height: 0;\n}\n\n.tiptop-editor .content-type-menu {\n  position: absolute;\n  left: 0;\n  margin-top: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  padding: 1rem 0.5rem;\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.tiptop-editor .content-type-menu .content-type-menu-item {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.5rem;\n  padding: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #6b7280;\n  text-align: left;\n  background-color: transparent;\n  width: 100%;\n  border-radius: 0.375rem;\n}\n\n.tiptop-editor .content-type-menu .content-type-menu-item div {\n  line-height: 0;\n}\n\n.tiptop-editor .content-type-menu .content-type-menu-item.active,\n.tiptop-editor .content-type-menu .content-type-menu-item:hover {\n  background-color: #f3f4f6;\n  color: #111827;\n}\n\n.tiptop-editor .content-type-menu .content-type-menu-title {\n  font-size: 0.65rem;\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n  margin-top: 0.5rem;\n  text-transform: uppercase;\n  color: #6b7280;\n  padding: 0 0.375rem;\n}\n\n.tiptop-editor .content-type-menu .content-type-menu-title:first-child,\n.tiptop-editor table tr td ol {\n  margin-top: 0;\n}\n\n.tiptop-editor .ai-menu {\n  position: absolute;\n  left: 0;\n  margin-top: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  padding: 1rem 0.5rem;\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.tiptop-editor .ai-menu .ai-menu-item {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.5rem;\n  padding: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #6b7280;\n  text-align: left;\n  background-color: transparent;\n  width: 100%;\n  border-radius: 0.375rem;\n}\n\n.tiptop-editor .ai-menu .ai-menu-item div {\n  line-height: 0;\n}\n\n.tiptop-editor .ai-menu .ai-menu-item:hover {\n  background-color: #f3f4f6;\n  color: #111827;\n}\n\n.tiptop-editor .colorpicker-wrapper {\n  position: absolute;\n  background-color: #ffffff;\n  border-radius: 0.5rem;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  border: 1px solid #e5e7eb;\n  padding: 0.25rem;\n  margin-top: 0.5rem;\n  min-width: 16.3rem;\n}\n\n.tiptop-editor .colorpicker-cover {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  /* 2 x 0.25rem (8px) */\n}\n\n.colorpicker-cover .react-colorful {\n  width: auto;\n}\n\n.tiptop-editor .colorpicker-input {\n  width: 100%;\n  padding: 0.5rem;\n  /* 2 x 0.25rem (8px) */\n  color: #000;\n  background-color: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.25rem;\n  /* 4px */\n}\n\n.tiptop-editor .colorpicker-input:focus {\n  outline: 1px solid #d1d5db;\n}\n\n.tiptop-editor .colorpicker-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.25rem;\n  /* 1 x 0.25rem (4px) */\n}\n\n.tiptop-editor .colorpicker-buttons .colorpicker-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.375rem;\n  /* 6px */\n  border-radius: 0.375rem;\n  /* 6px */\n}\n\n.tiptop-editor .colorpicker-buttons .colorpicker-button:hover,\n.tiptop-editor .colorpicker-buttons .colorpicker-button.active {\n  background-color: #f5f5f5;\n}\n\n.tiptop-editor .colorpicker-buttons .colorpicker-button>div {\n  width: 1rem;\n  /* 4px */\n  height: 1rem;\n  /* 4px */\n  border-radius: 0.25rem;\n  /* 4px */\n  background-color: #f1f5f9;\n  /* slate-100 */\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  /* shadow-sm */\n  outline-offset: 0.125rem;\n  /* 2px */\n  outline-color: currentColor;\n  /* ring-current */\n}\n\n.tiptop-editor .colorpicker-buttons .colorpicker-button>div:hover .tiptop-editor .colorpicker-buttons .colorpicker-button>div.active {\n  outline-width: 1px;\n}\n\n.tiptop-editor .moreoptions-wrapper {\n  position: absolute;\n  right: -40%;\n  bottom: -90%;\n  background-color: #ffffff;\n  border-radius: 0.5rem;\n  /* 8px */\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  border: 1px solid #e5e7eb;\n  /* neutral-200 */\n  padding: 0.25rem;\n  /* 4px */\n  margin-top: 0.5rem;\n  /* 8px */\n  display: flex;\n  flex-direction: row;\n}\n\n.tiptop-editor .tablerow-menu {\n  color: #000000;\n  /* text-black */\n  display: inline-flex;\n  height: 100%;\n  line-height: 1;\n  gap: 0.125rem;\n  /* 0.5 */\n  flex-direction: column;\n  padding: 0.5rem;\n  /* 2 */\n  background-color: #ffffff;\n  /* bg-white */\n  border-radius: 0.5rem;\n  /* rounded-lg */\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  /* shadow-sm */\n  border: 1px solid #e5e7eb;\n  /* border-neutral-200 */\n}\n\n.tiptop-editor .tablerow-menu .tablerow-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #71717a;\n  text-align: left;\n  background-color: transparent;\n  width: 100%;\n  border-radius: 0.375rem;\n}\n\n.tiptop-editor .tablerow-menu .tablerow-menu-item:hover {\n  background-color: #f5f5f5;\n  color: #1f2937;\n}\n\n.tiptop-editor .node-tableOfContentsNode.ProseMirror-selectednode .TableOfContentsWrapper {\n  border-radius: 0.5rem;\n  box-shadow: 0 0 #0000, 0 0 #0000, 0 0 0 2px rgb(0 0 0 / 0.3);\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.tiptop-editor .TableOfContentsWrapper {\n  padding: 0.5rem;\n  margin: 0;\n  border-radius: 0.5rem;\n}\n\n.tiptop-editor .TableOfContentsTitle {\n  margin-bottom: 0.5rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #6b7280;\n  /* Neutral 500 */\n  font-size: 14px;\n}\n\n.tiptop-editor .TableOfContentsCover {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  overflow-x: hidden;\n}\n\n.tiptop-editor .TableOfContentsCover .TableOfContentsItem {\n  display: block;\n  font-weight: 500;\n  color: #6b7280;\n  /* neutral-500 */\n  padding: 0.25rem;\n  border-radius: 0.25rem;\n  font-size: 16px;\n  /* text-sm */\n  transition: all 0.3s;\n  /* width: 100%; */\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-decoration: none;\n}\n\n.tiptop-editor .TableOfContentsCover .TableOfContentsItem:hover {\n  color: #1f2937;\n  /* neutral-800 */\n  /* background-color: rgba(0, 0, 0, 0.05); */\n}\n\n.tiptop-editor .TableOfContentsWrapper .TableOfContentsNoData {\n  font-size: 0.875rem;\n  /* text-sm */\n  color: #6b7280;\n  /* neutral-500 */\n}\n\n.tiptop-editor .DragHandleItems {\n  display: flex;\n  align-items: center;\n  gap: 0.125rem;\n  background-color: transparent;\n}\n\n.DragHandleItems.d-none {\n  display: none;\n}\n\n.DragHandleItems .DragHandleItem {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid transparent;\n  font-size: 0.875rem;\n  /* equivalent to text-sm */\n  font-weight: 600;\n  /* equivalent to font-semibold */\n  border-radius: 0.375rem;\n  /* equivalent to rounded-md */\n  opacity: 1;\n  white-space: nowrap;\n  background-color: transparent;\n  color: #737373;\n  /* equivalent to text-neutral-500 */\n  height: 2rem;\n  gap: 0.30rem;\n  /* equivalent to gap-1 */\n  width: 2rem;\n  cursor: pointer;\n}\n\n.DragHandleItems .DragHandleItem:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  color: #3f3f46;\n}\n\n.DragHandleItems .DragHandleItem svg,\n.DragHandleSubItems .DragHandleSubItem svg,\n.menulist-wrapp .menu-label svg {\n  width: 1rem;\n  height: 1rem;\n}\n\n.DragHandleItems .DragHandleItem svg {\n  width: 2rem;\n}\n\n.DragHandleSubItems {\n  position: fixed;\n  left: 0px;\n  top: 0px;\n  transform: translate(36px, 40px);\n  min-width: max-content;\n  --radix-popper-transform-origin: 0% 0px;\n  z-index: auto;\n  --radix-popper-available-width: 1346px;\n  --radix-popper-available-height: 383px;\n  --radix-popper-anchor-width: 34px;\n  --radix-popper-anchor-height: 32px;\n}\n\n.DragHandleSubItems .DragHandleSubItemsWrapp {\n  box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / 0.05);\n  padding: 0.5rem;\n  background-color: #fff;\n  border: 1px solid #e5e5e5;\n  border-radius: 0.5rem;\n  min-width: 12rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.DragHandleSubItems .DragHandleSubItem {\n  -webkit-appearance: button;\n  background-color: transparent;\n  background-image: none;\n  cursor: pointer;\n  text-transform: none;\n\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #737373;\n  text-align: left;\n  background-color: transparent;\n  border-radius: 0.25rem;\n}\n\n.DragHandleSubItems .DragHandleSubItem.dangerItem {\n  color: #ef4444;\n  background-color: rgba(239, 68, 68, 0.1);\n}\n\n.DragHandleSubItems .DragHandleSubItem:hover {\n  background-color: #f5f5f5;\n  color: #1f2937;\n}\n\n.DragHandleSubItems .DragHandleSubItem.dangerItem:hover {\n  background-color: rgba(239, 68, 68, 0.2);\n}\n\n.DragHandleSubItems .sunItemSivider {\n  background-color: #e5e5e5;\n  width: 100%;\n  min-width: 1.5rem;\n  height: 1px;\n  margin-bottom: 0.4rem;\n}\n\n.menulist-container {\n  color: #000000;\n  max-height: min(80vh, 24rem);\n  overflow: auto;\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 2rem;\n  padding: 0.5rem;\n  background-color: #ffffff;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  border: 1px solid #e5e5e5;\n  min-width: 12rem;\n}\n\n.menulist-wrapp {\n  display: grid;\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n  gap: 0.125rem;\n  width: 100%;\n}\n\n.menulist-wrapp .menu-title {\n  color: #6b7280;\n  font-size: 0.65rem;\n  grid-column: 1 / -1;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n  margin-top: 1rem;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  user-select: none;\n  text-transform: uppercase;\n  width: 100%;\n}\n\n.menulist-wrapp .menu-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #0A0A0A;\n  text-align: left;\n  background-color: transparent;\n  width: 100%;\n  border-radius: 0.25rem;\n  cursor: pointer;\n}\n\n.menulist-wrapp .menu-label div {\n  line-height: 0;\n}\n\n.menulist-wrapp .menu-label.active,\n.menulist-wrapp .menu-label:hover {\n  background-color: #f9f9f9;\n  color: #1f2937;\n}\n\n.ProseMirror [data-type='button'] {\n  padding: 12px;\n  border: 1px solid #ffffff;\n  border-radius: 6px;\n  cursor: default;\n}\n\n.ProseMirror [data-type='button'].ProseMirror-selectednode {\n  border-color: #573CFF;\n}\n\n.button-element.align-left {\n  text-align: left;\n}\n\n.button-element.align-center {\n  text-align: center;\n}\n\n.button-element.align-right {\n  text-align: right;\n}\n\n.tiptop-editor .button-element button,\n.tiptop-editor .button-element a {\n  background-color: #55883D;\n  border: 1px solid #55883D;\n  border-radius: 6px;\n  color: #fff;\n  cursor: pointer;\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 28px;\n  padding: 5px 10px;\n  transition: all .3s linear;\n}\n\n.button-element.width-full button {\n  width: 100%;\n}\n\n.button-element.width-auto button {\n  width: auto;\n}\n\n/* book mark section */\n.tiptop-editor .bookmark-node-wrapper,\n.vimeo-node-wrapper,\n.other-node-wrapper,\n.twitter-node-wrapper,\n.spotify-node-wrapper,\n.soundcloud-node-wrapper,\n.publications-wrapper {\n  position: relative;\n  margin-top: 0;\n}\n\n.twitter-node-wrapper .none,\n.spotify-node-wrapper .none,\n.soundcloud-node-wrapper .none,\n.other-node-wrapper .none {\n  display: none;\n}\n\n.tiptop-editor .bookmark-node-wrapper label,\n.twitter-node-wrapper label,\n.spotify-node-wrapper label,\n.soundcloud-node-wrapper label {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #0a2540;\n  margin-bottom: 5px !important;\n}\n\n.tiptop-editor .bookmark-node-wrapper .urlInputLeft,\n.vimeo-node-wrapper .urlInput,\n.tiptop-editor .other-node-wrapper .urlInput,\n.twitter-node-wrapper .urlInputLeft,\n.tiptop-editor .spotify-node-wrapper .urlInputLeft,\n.tiptop-editor .soundcloud-node-wrapper .urlInputLeft {\n  padding: 8px 12px;\n  gap: 8px;\n  height: 45px;\n  width: 100%;\n  background: #ffffff;\n  border: 1px solid #573CFF;\n  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);\n  border-radius: 6px;\n  outline: none;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  padding-left: 40px;\n  font-size: 14px;\n  color: #000;\n}\n\n.tiptop-editor .other-urlInput .urlInput.embedCode {\n  padding: 10px 10px 10px 40px;\n  width: 100%;\n  min-height: 120px;\n  resize: vertical;\n  font-size: 16px;\n  line-height: 26px;\n}\n\n.embed-code iframe {\n  max-width: 100%;\n}\n\n.tiptop-editor .bookmark-node-wrapper svg,\n.vimeo-node-wrapper svg,\n.other-node-wrapper svg,\n.twitter-node-wrapper svg,\n.spotify-node-wrapper svg,\n.soundcloud-node-wrapper svg {\n  position: absolute;\n  top: 0.8rem;\n  left: 14px;\n  width: 20px;\n}\n\n.other-node-wrapper svg {\n  top: 0.99rem !important;\n}\n\n.twitter-node-wrapper svg,\n.spotify-node-wrapper svg,\n.soundcloud-node-wrapper svg,\n.vimeo-node-wrapper svg {\n  top: 1.4rem !important;\n}\n\n.tiptop-editor .bookmark-node-wrapper svg {\n  top: 1.5rem;\n}\n\n.tiptop-editor .bookmark-node-wrapper .linkbutton-loader,\n.vimeo-node-wrapper .linkbutton-loader,\n.tiptop-editor .other-node-wrapper .linkbutton-loader,\n.tiptop-editor .twitter-node-wrapper .linkbutton-loader,\n.tiptop-editor .spotify-node-wrapper .linkbutton-loader,\n.tiptop-editor .soundcloud-node-wrapper .linkbutton-loader {\n  min-width: 100%;\n  padding: 8px 12px;\n  gap: 8px;\n  height: 45px;\n  width: 100%;\n  background: #ffffff;\n  border: 1px solid #eaecf0;\n  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);\n  border-radius: 6px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.tiptop-editor .bookmark-node-wrapper .ring-loader,\n.vimeo-node-wrapper .ring-loader,\n.tiptop-editor .other-node-wrapper .ring-loader,\n.twitter-node-wrapper .ring-loader,\n.tiptop-editor .spotify-node-wrapper .ring-loader,\n.tiptop-editor .soundcloud-node-wrapper .ring-loader,\n.publications-wrapper .ring-loader {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  position: absolute;\n  margin: 7px auto;\n  top: 6px;\n  left: 0;\n  right: 0;\n  animation: rotate 1s linear infinite;\n}\n\n.publications-wrapper .ring-loader {\n  top: 2px !important;\n}\n\n.tiptop-editor .bookmark-node-wrapper .ring-loader:before,\n.vimeo-node-wrapper .ring-loader:before,\n.tiptop-editor .other-node-wrapper .ring-loader:before,\n.twitter-node-wrapper .ring-loader:before,\n.tiptop-editor .spotify-node-wrapper .ring-loader:before,\n.tiptop-editor .soundcloud-node-wrapper .ring-loader:before,\n.publications-wrapper .ring-loader:before {\n  content: \"\";\n  box-sizing: border-box;\n  position: absolute;\n  inset: 0px;\n  border-radius: 50%;\n  border: 3px solid black;\n  animation: prixClipFix 2s linear infinite;\n  top: 0;\n}\n\n#widget .privacyPolicy {\n  display: none !important;\n}\n\n.tiptop-editor .twitter-node-wrapper .twitter-embed,\n.tiptop-editor .node-urlPaste .twitter-node-wrapper.twitter-block .twitter-tweet {\n  width: 100%;\n  max-width: 550px;\n  margin: 20px auto !important;\n}\n\n.twitter-node-wrapper .twitter-embed .twitter-tweet-rendered {\n  margin-top: 1.5rem !important;\n}\n\n.spotifyEmbed iframe {\n  border-radius: 0.5rem !important;\n}\n\n.spotifyEmbed[data-spotify-type=\"track\"] iframe {\n  max-height: 232px;\n}\n\n.spotifyEmbed[data-spotify-type=\"episode\"] iframe {\n  max-height: 352px;\n}\n\n.tiptop-editor .bookmark-node-wrapper .ring-loader.dark:before,\n.vimeo-node-wrapper .ring-loader.dark:before,\n.other-node-wrapper .ring-loader.dark:before,\n.publications-wrapper .ring-loader.dark:before {\n  border: 3px solid #868c98;\n}\n\n.video-section {\n  margin: 20px 0;\n}\n\n.tiptop-editor .linkBox {\n  display: flex;\n  box-shadow: none;\n  align-items: center;\n  border: 1px solid #8080805c;\n  border-radius: 0;\n  padding: 15px;\n}\n\n.tiptop-editor .node-bookmarkBlock .link-content {\n  margin: 15px 0;\n}\n\n.tiptop-editor .link-content a {\n  text-decoration: none;\n}\n\n.tiptop-editor .link-content img {\n  width: 100%;\n  height: 90px;\n  object-fit: cover;\n  border-radius: 0;\n}\n\n.tiptop-editor .textBlock.linkBox .linkImageSection {\n  display: flex;\n  align-items: center;\n  width: 90px !important;\n  height: auto;\n}\n\n.tiptop-editor .linkBox .linkData {\n  width: calc(100% - 90px);\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  gap: 15px;\n  padding-left: 15px;\n}\n\n.tiptop-editor .link-content p.linkDataTitle {\n  color: #101828;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  margin-bottom: 0;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.tiptop-editor .link-content .linkDataDiscripation {\n  display: none;\n}\n\n.tiptop-editor .link-content .siteData {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.tiptop-editor .link-content .siteData.siteUrl {\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.tiptop-editor .linkData .siteData:nth-child(3) {\n  margin-top: -10px;\n}\n\n.tiptop-editor .link-content .siteData img {\n  margin-right: 6px;\n  border-radius: 0;\n  object-fit: unset;\n  width: 18px;\n  height: 18px;\n}\n\n.tiptop-editor .link-content .siteData p {\n  margin: 0;\n  font-size: 14px;\n  color: #475467;\n}\n\n.tiptop-editor .error-message {\n  font-size: 14px;\n  color: #d92d20;\n  display: block;\n  margin-top: 0px !important;\n}\n\n.video-wrapper .error-message {\n  margin: 5px !important;\n}\n\n.tiptop-editor .video-wrapper .video-caption,\n.gallery-block .video-caption {\n  min-height: 24px;\n  text-align: left;\n  margin-bottom: 0 !important;\n  border: none;\n  box-shadow: none;\n  outline: none;\n  font-size: 14px;\n}\n\n.tiptop-editor .video-wrapper .video-caption:empty:before {\n  pointer-events: none;\n  float: left;\n  height: 0px;\n  width: 100%;\n  color: rgb(0 0 0 / 0.4);\n  content: 'Write a caption for the video (optional)';\n  line-height: 26px;\n}\n\n.tiptop-editor .file-block .file-detail .file-caption:empty:before {\n  pointer-events: none;\n  float: left;\n  height: 0px;\n  width: 100%;\n  color: rgb(0 0 0 / 0.4);\n  content: 'Write a caption for the file (optional)';\n  line-height: 26px;\n}\n\n.youtube-video,\n.vimeo-video {\n  font-size: 14px;\n  /* border: 1px solid #573CFF;\n  border-radius: 6px; */\n  background-color: #fff;\n  color: #101828;\n  margin-bottom: 20px;\n}\n\n.toolbar-button .menu-icon {\n  margin-top: 2px;\n}\n\n.toolbar-button .font-size-picker {\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.player-wrapper {\n  display: none;\n}\n\n.player-wrapper.player-ready {\n  display: block;\n  position: relative;\n  padding-top: 56.25%;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.player-wrapper.player-ready .react-player {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.tiptop-editor .image-preview .player-wrapper.player-ready {\n  border-top-right-radius: 6px;\n  border-top-left-radius: 6px;\n  line-height: 0;\n  overflow: hidden;\n  height: 350px;\n  display: block;\n  margin-bottom: 0;\n  border-radius: 0;\n}\n\n.tiptop-editor .node-vimeoBlock .player-wrapper.player-ready,\n.tiptop-editor .video-wrapper.youtube-video .player-wrapper.player-ready {\n  margin: 0 !important;\n}\n\n.tiptop-editor [data-type='video'] .video-wrapper .player-wrapper.player-ready {\n  height: auto;\n  min-height: 300px;\n}\n\n.tiptop-editor .video-title {\n  padding: 5px 0;\n  outline: none;\n}\n\n.node-youtubeBlock .video-wrapper.youtube-video .video-title {\n  padding-top: 0;\n}\n\n.toolbar-button .content-icon {\n  margin-top: 3px;\n}\n\n.tiptop-editor .video-wrapper .skeleton-video-wrapper {\n  position: relative;\n  padding-top: 56.25%;\n}\n\n.tiptop-editor .video-wrapper .skeleton-video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  background: #ececee;\n  border-radius: 6px 6px 0 0;\n  animation: loading 1.5s infinite;\n}\n\n.tiptop-editor .node-vimeoBlock .video-wrapper.vimeo-video .video-title {\n  margin-top: -6px !important;\n}\n\n.tiptop-editor .node-vimeoBlock .video-wrapper.vimeo-video .player-wrapper.player-ready {\n  margin-top: -1px;\n}\n\n\n/* publication */\n.tiptop-editor .publication-list.list .publication-item {\n  display: flex;\n  align-items: flex-start;\n  margin-top: 20px;\n}\n\n.tiptop-editor .publication-list.list .publication-item:first-child {\n  margin-top: 0 !important;\n}\n\n.tiptop-editor .publication-list.list .publication-data {\n  padding-left: 15px;\n  width: calc(100% - 25%);\n  font-size: 14px;\n}\n\n.tiptop-editor .publications-wrapper .publication-title.two-line {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n}\n\n.ProseMirror .publications-wrapper a {\n  pointer-events: none;\n  cursor: pointer;\n  color: #000;\n  text-decoration: none;\n  font-weight: 700;\n}\n\n.tiptop-editor .publications-wrapper .publication-description.four-line {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  margin-top: 0;\n  margin-bottom: 5px;\n  font-size: 14px;\n  line-height: 22px;\n}\n\n.tiptop-editor .publications-wrapper .publication-title {\n  margin-bottom: 0;\n  line-height: 22px;\n  font-size: 18px;\n  font-weight: 400;\n  color: #101828;\n}\n\n.tiptop-editor .publications-wrapper .publication-list.list .publication-image {\n  width: 25%;\n  border-radius: 6px;\n  line-height: 0;\n}\n\n.tiptop-editor .publications-wrapper .publication-image img {\n  width: auto;\n  height: auto;\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: cover;\n}\n\n.alignment-box .menu-title.layout-title {\n  margin-bottom: 0;\n}\n\n.tiptop-editor .publications-wrapper .publication-list.list {\n  display: block;\n}\n\n.tiptop-editor .node-publications .publications-wrapper,\n.tiptop-editor .node-products .products-node-wrapper {\n  margin-left: -14px;\n  margin-right: -14px;\n}\n\n.tiptop-editor .node-publications .publication-list {\n  /*border: 1px solid #573CFF;*/\n  border-radius: 6px;\n  padding: 14px;\n}\n\n.publication-image img {\n  width: 100%;\n  height: auto;\n}\n\n.tiptop-editor .node-publications .publication-list.grid {\n  display: grid;\n  align-items: start;\n  column-gap: 12px;\n  row-gap: 25px;\n  grid-template-columns: repeat(3, minmax(0px, 1fr));\n}\n\n.publication-list .publication-date {\n  font-size: 16px;\n  padding: 10px 0 0;\n  color: #101828;\n}\n\n.tiptop-editor .categories-box .categories-button {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #d0d5dd;\n  background: #fff;\n  padding: 10px 14px;\n  border-radius: 6px;\n  margin: 5px 0;\n  cursor: pointer;\n  height: 46px;\n  font-weight: 400;\n  color: #101828;\n}\n\n.tiptop-editor .bubble-toggle-menu.button-box .categories-box .select-categories {\n  font-size: 14px;\n  color: #101828;\n  line-height: 24px;\n}\n\n.tiptop-editor .publications-wrapper .categories-box .menu-title,\n.layout-box .menu-title {\n  font-size: 14px;\n  line-height: 20px;\n  color: #0A0A0A;\n}\n\n.tiptop-editor .page-not-found .NoResults {\n  padding-top: 0;\n  padding-bottom: 0;\n  text-align: center;\n  border-bottom-left-radius: 12px;\n  min-height: 300px;\n  align-items: center;\n  border-radius: 6px;\n  display: flex;\n  justify-content: center;\n  border: 0;\n}\n\n.tiptop-editor .NoResults .noResultsBody {\n  max-width: 350px;\n}\n\n.tiptop-editor .NoResults .noResultsBody>svg {\n  width: 170px;\n  margin-top: 12px;\n\n}\n\n.tiptop-editor .page-not-found .noResTitle {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 28px;\n  text-align: center;\n  color: #101828;\n  margin-top: 20px;\n  margin-bottom: 8px;\n}\n\n.tiptop-editor .page-not-found .noResDesc {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  color: #475467;\n  margin-bottom: 30px;\n}\n\n.viemo-urlInput {\n  margin-top: calc(1.5rem - 10px);\n}\n\n.image-node-wrapper .mediaGallery .ulpoadImageBlock {\n  padding-left: 36px;\n  padding-right: 36px;\n}\n\n.tiptop-editor .image-node-wrapper .textBlock {\n  margin-top: 0;\n  margin-bottom: 20px;\n  position: relative;\n  top: 0;\n}\n\n.tiptop-editor .image-node-wrapper .newpageLeftRow input {\n  background: #fff;\n  border: none;\n  border-radius: 6px;\n  box-shadow: 0 1px 2px #1018280d;\n  color: #667085;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  gap: 8px;\n  line-height: 24px;\n  outline: none;\n  padding: 14px 14px 12px;\n  width: 100%;\n}\n\n.tiptop-editor .image-node-wrapper .uploadFileBlock {\n  margin: 0 auto;\n  width: 100%;\n  min-height: 250px;\n  padding: 50px 10px;\n  box-shadow: 0 1px 2px #1018280d;\n  cursor: pointer;\n  justify-content: center;\n  position: relative;\n  z-index: 0;\n  border: 1px solid #573cff;\n  border-radius: 6px;\n}\n\n.image-node-wrapper .fileUploadBox .fileUploadCover_Img {\n  align-items: center;\n  background: #f2f4f7;\n  border: 6px solid #f9fafb;\n  border-radius: 50%;\n  display: flex;\n  height: 40px;\n  justify-content: center;\n  margin: 0 auto 5px;\n  padding: 5px !important;\n  width: 40px;\n}\n\n.tiptop-editor .image-node-wrapper .newPageImageUploadText,\n.uploadFileBlock .newPageImageUploadText {\n  color: #475467;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 24px;\n  user-select: none;\n  margin-bottom: 0;\n  padding-top: 0;\n  text-align: center;\n}\n\n.tiptop-editor .image-node-wrapper .newPageImageUploadText span {\n  color: #573cff;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.image-node-wrapper .image-size-text {\n  font-size: 14px;\n}\n\n.tiptop-editor .progress-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.tiptop-editor .popupBlock .progress-wrap {\n  margin: 0 auto;\n}\n\n.tiptop-editor .progress {\n  position: relative;\n  height: 7px;\n  width: 100%;\n  border: 1px solid rgb(246, 246, 250);\n  border-radius: 15px;\n  top: 0;\n  left: 0;\n}\n\n.tiptop-editor .popupBlock .progress {\n  width: 70%;\n}\n\n.tiptop-editor .progress .color {\n  position: absolute;\n  background-color: #573CFF;\n  width: 0px;\n  height: 6px;\n  border-radius: 15px;\n  animation: progress 4s infinite linear;\n}\n\n.image-node-wrapper .uploadRunning {\n  width: 100%;\n  min-height: 250px;\n  padding: 100px;\n  box-shadow: 0 1px 2px #1018280d;\n  position: relative;\n  z-index: 0;\n  border: 1px solid #573cff;\n  border-radius: 6px;\n}\n\n.image-block .video-caption,\n.node-youtubeBlock .video-wrapper .video-caption {\n  min-height: 24px;\n  text-align: left;\n  margin-bottom: 0 !important;\n  outline: none;\n}\n\n.image-block .video-caption:before,\n.node-youtubeBlock .video-wrapper .video-caption::before {\n  outline: none;\n}\n\n.image-block .video-caption:empty:before {\n  pointer-events: none;\n  float: left;\n  height: 0px;\n  width: 100%;\n  color: rgb(0 0 0 / 0.4);\n  content: 'Write a caption for the image (optional)';\n  font-size: 14px;\n  outline: none;\n  line-height: 26px;\n}\n\n.tiptop-editor .node-VideoBlock .video-wrapper .video-caption:empty:before {\n  pointer-events: none;\n  float: left;\n  height: 0px;\n  width: 100%;\n  color: rgb(0 0 0 / 0.4);\n  content: 'Write a caption for the video (optional)';\n  font-size: 14px;\n  outline: none;\n  line-height: 26px;\n}\n\n.tiptop-editor .image-block {\n  /* border: 1px solid #573cff; */\n  border-radius: 0.5rem;\n  margin-bottom: 20px;\n}\n\n.tiptop-editor .image-preview-cover {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.tiptop-editor .image-preview-cover .image-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  gap: 10px;\n}\n\n.tiptop-editor .image-block .image-preview.image-width-full,\n.tiptop-editor .video-wrapper .image-preview.image-width-wide,\n.tiptop-editor .logoslider-wapper.image-width-full {\n  width: calc(100vw - 312px - 375px - 36px - 40px - 40px);\n  position: relative;\n  left: 50%;\n  transform: translateX(-50%);\n  max-width: 1200px;\n}\n\n.tiptop-editor .image-block .image-preview img {\n  height: 100%;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 100%;\n  object-fit: cover;\n}\n\n.tiptop-editor .image-bubble-menu {\n  padding: 0.5rem !important;\n  top: -9px !important;\n  min-width: 5rem !important;\n  transform: translateX(-50%);\n}\n\n.tiptop-editor .image-bubble-menu.products {\n  padding: 0.5rem !important;\n  top: 0 !important;\n  min-width: 5rem !important;\n  transform: translateX(0);\n}\n\n.tiptop-editor .image-bubble-menu.page-bubble-menu {\n  min-width: 3rem !important;\n}\n\n.tiptop-editor .image-bubble-menu button {\n  padding: 0 !important;\n  display: block;\n  width: unset;\n  line-height: 0;\n}\n\n.tiptop-editor .image-bubble-menu .image-bubble-block {\n  display: flex;\n  justify-content: space-evenly;\n  gap: 10px;\n}\n\n.toggle-button-image {\n  padding: 9px !important;\n}\n\n.image-node-wrapper .errorMessages {\n  text-align: center;\n  margin-top: 10px;\n}\n\n/* .image-block {\n  padding: 10px;\n} */\n\n.node-fileBlock.ProseMirror-selectednode .fileblock-wrapper {\n  border: 1px solid #573cff;\n  border-radius: 6px;\n}\n\n.tiptop-editor .node-fileBlock .fileblock-wrapper {\n  margin-left: -10px;\n  margin-right: -10px;\n}\n\n.tiptop-editor .file-block .file-detail .filedescription .file-caption {\n  outline: none;\n  width: calc(100% - 75px);\n  font-size: 15px;\n  color: rgb(55 65 81);\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  margin-bottom: 0;\n}\n\n.file-caption:empty:before {\n  content: 'Enter a description'\n}\n\n.tiptop-editor .file-block .file-detail .file-caption.file-title {\n  color: #000;\n  font-weight: 600;\n  font-size: 16px;\n  outline: none;\n  margin-bottom: 0;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.tiptop-editor .fileblock-wrapper .image-block.file-block .uploadFileBlock {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  min-height: unset;\n  max-width: unset;\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  cursor: unset;\n  justify-content: unset;\n}\n\n.tiptop-editor .file-block .file-detail .filedescription,\n.tiptop-editor .file-block .uploadFileBlock .file-detail {\n  width: 100%;\n}\n\n.uploadFileBlock .newPagefileUploadText {\n  margin-top: 10px;\n  margin-bottom: 0;\n}\n\n.tiptop-editor .fileblock-wrapper .file-block {\n  padding: 10px;\n  margin: 0;\n}\n\n.tiptop-editor .fileblock-wrapper .file-block .featureImgMiddleContent svg {\n  height: 40px;\n}\n\n.tiptop-editor .fileblock-wrapper .file-block .featureImgMiddleContent .icon-img {\n  max-width: 40px;\n  margin-left: 0.4rem;\n}\n\n.tiptop-editor .fileblock-wrapper .file-block .featureImgMiddleContent .file-icon {\n  max-width: calc(40px + 0.4rem);\n}\n\n.tiptop-editor .newPageImageUploadText span {\n  color: #573cff;\n}\n\n.tiptop-editor .uploadFileBlock .newPageImageUploadText.fileupload {\n  display: block;\n}\n\n.tiptop-editor .uploadFileBlock .uploaded-file .newPagefileUploadText {\n  font-size: 14px;\n}\n\n.tiptop-editor .file-block .uploaded-file .newPagefileUploadText span {\n  color: #777;\n}\n\n.bubble-toggle-menu.file-bubble-menu {\n  min-width: 2.4rem !important;\n  top: -9px !important;\n  display: block;\n  padding: 2px 0 !important;\n}\n\n.file-bubble-menu .file-bubble .full-display-button {\n  padding: 5px !important;\n  margin-left: 2px;\n}\n\n.tiptop-editor .publications-wrapper .publication-list.grid .publication-item {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n}\n\n.tiptop-editor .publications-wrapper .publication-list.grid .publication-item .publication-image {\n  width: 100%;\n  height: 100%;\n  border-radius: 6px;\n  line-height: 0;\n  position: relative;\n  overflow: hidden;\n  height: 220px;\n}\n\n.tiptop-editor .publications-wrapper .publication-list.list .publication-item .publication-image .publicationTypeWrapper {\n  display: none;\n}\n\n.publicationTypeWrapper .corner-top-left path,\n.corner-top-right path,\n.corner-bottom-left path,\n.corner-bottom-right path {\n  fill: #fff;\n}\n\n.tiptop-editor .publications-wrapper .publication-list.grid .publication-item .publication-image .publicationTypeWrapper {\n  background-color: #fff;\n  color: #101828;\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-size: 15px;\n  line-height: 1.2;\n  padding: 6px 12px 12px 6px;\n  border-bottom-right-radius: 20px;\n}\n\n.tiptop-editor .publications-wrapper .publication-list.grid .publication-item .publication-image .publicationTypeWrapper .corner-top-left {\n  width: 18px;\n  height: 18px;\n  overflow: hidden;\n}\n\n.tiptop-editor .publications-wrapper .publication-list.grid .publication-item .publication-image .publicationTypeWrapper .corner-top-left.top {\n  position: absolute;\n  right: -18px;\n  top: 0;\n}\n\n.tiptop-editor .publications-wrapper .publication-list.grid .publication-item .publication-image .publicationTypeWrapper .corner-top-left.bottom {\n  position: absolute;\n  left: 0;\n  bottom: -18px;\n}\n\n.tiptop-editor .publications-wrapper .publication-list.grid .publication-data {\n  margin-top: 12px;\n}\n\n.publication-list.grid .publication-item .publication-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  overflow: hidden;\n}\n\n.bubble-toggle-menu.button-box .publication-count .zoom-range,\n.bubble-toggle-menu.button-box .publication-column .zoom-range {\n  width: 100%;\n}\n\n.bubble-toggle-menu.button-box .publication-count input.zoom-range,\n.bubble-toggle-menu.button-box .publication-column input.zoom-range {\n  height: 4px;\n  background-color: #0A2540;\n  border-radius: 6px;\n  appearance: none;\n  padding: 0;\n  margin-bottom: 10px;\n}\n\n.bubble-toggle-menu.button-box .publication-count input.zoom-range::-webkit-slider-thumb,\n.bubble-toggle-menu.button-box .publication-column input.zoom-range::-webkit-slider-thumb {\n  height: 15px;\n  width: 15px;\n  background-color: #0A2540;\n  border-radius: 50%;\n  appearance: none;\n  z-index: 99;\n  cursor: grab;\n}\n\n.bubble-toggle-menu.button-box .publication-count input.zoom-range.slider-cursor::-webkit-slider-thumb,\n.bubble-toggle-menu.button-box .publication-column input.zoom-range.slider-cursor::-webkit-slider-thumb {\n  cursor: grabbing;\n}\n\n.bubble-toggle-menu.button-box .publication-count input.zoom-range::-moz-range-thumb,\n.bubble-toggle-menu.button-box .publication-column input.zoom-range::-moz-range-thumb {\n  height: 15px;\n  width: 15px;\n  background-color: #344054;\n  border-radius: 50%;\n  appearance: none;\n  z-index: 99;\n}\n\n.bubble-toggle-menu.button-box .publication-count input.zoom-range::-ms-thumb,\n.bubble-toggle-menu.button-box .publication-column input.zoom-range::-ms-thumb {\n  height: 15px;\n  width: 15px;\n  background-color: #344054;\n  border-radius: 50%;\n  appearance: none;\n  z-index: 99;\n}\n\n.tiptop-editor .bubble-toggle-menu.button-box .publication-count .count-title,\n.tiptop-editor .bubble-toggle-menu.button-box .publication-column .column-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.tiptop-editor .bubble-toggle-menu.button-box .publication-count .count-title label,\n.tiptop-editor .bubble-toggle-menu.button-box .publication-column .column-title label {\n  margin-bottom: 0;\n  color: #0A0A0A;\n}\n\n.tiptop-editor .publications-wrapper .publication-list.grid.one-column {\n  grid-template-columns: repeat(1, minmax(0px, 1fr))\n}\n\n.tiptop-editor .publications-wrapper .publication-list.grid.two-column {\n  grid-template-columns: repeat(2, minmax(0px, 1fr))\n}\n\n.tiptop-editor .publications-wrapper .publication-list.grid.three-column {\n  grid-template-columns: repeat(3, minmax(0px, 1fr))\n}\n\n.tiptop-editor .publications-wrapper .publication-list.grid.four-column {\n  grid-template-columns: repeat(4, minmax(0px, 1fr))\n}\n\n.tiptop-editor .bubble-toggle-menu .content-type-menu.categories-menu {\n  width: calc(100% - 2rem);\n  margin-left: 1rem;\n  top: 83px;\n  max-height: 170px;\n  overflow-y: scroll;\n  box-shadow: none;\n  height: auto;\n  padding: 0;\n  border-radius: 6px;\n}\n\n.categories-menu .categories {\n  font-size: 14px;\n  color: #101828;\n  padding-left: 6px;\n  cursor: pointer;\n  margin: 0;\n  font-weight: 400;\n}\n\n.categories-box .categories {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  flex-wrap: wrap;\n  margin: 10px 0;\n}\n\n.categories-box .selected-categorie {\n  display: flex;\n  gap: 2px;\n  border: 1px solid #d0d5dd;\n  border-radius: 6px;\n  align-items: center;\n  font-size: 13px;\n  padding: 2px 6px;\n  padding-right: 0 !important;\n  background-color: #fff;\n}\n\n.categories-box .selected-categorie p {\n  margin: 0 !important;\n  font-weight: 400;\n}\n\n.categories-box .selected-categorie svg {\n  cursor: pointer;\n}\n\n.categories-menu .selectedcat:hover {\n  background: #f9f9f9;\n  color: #101828;\n}\n\n.tiptop-editor .bubble-toggle-menu .categories-menu .selectedcat {\n  display: flex;\n  justify-content: flex-start;\n  padding: 10px 16px 10px 10px;\n  color: #111827;\n  cursor: pointer;\n  align-items: center;\n}\n\n.tiptop-editor .bubble-toggle-menu .categories-menu .selectedcat p {\n  margin: 0;\n  line-height: 24px;\n}\n\n.content-type-menu.categories-menu input[type=\"checkbox\"]:before {\n  height: 18px;\n  width: 18px;\n}\n\n.tiptop-editor .bubble-toggle-menu.button-box .content-type-menu.categories-menu .selectedcat input {\n  height: 18px;\n  min-width: unset;\n  width: 20px;\n  flex: unset;\n  margin-left: 4px;\n  margin-right: 0;\n  cursor: pointer;\n  background: transparent;\n  appearance: unset;\n  border: none;\n  padding: 0;\n  box-shadow: none;\n  margin-top: 0;\n  margin-bottom: 0;\n  min-height: unset;\n}\n\n.column-bubble-menu {\n  padding-top: 9px !important;\n  min-width: 7rem !important;\n  top: -40px !important;\n}\n\n.AiWriter-node-wrapper {\n  border: 1px solid #573cff;\n  border-radius: 0.5rem;\n}\n\n.AiWriter-node-wrapper .aitext-generator {\n  color: rgba(0, 0, 0, 0.8);\n  font-size: 0.75rem;\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n  margin-left: 0.375rem;\n}\n\n.tiptop-editor .bubble-toggle-menu.button-box .publication-submit-button {\n  text-align: right;\n}\n\n.product .publication-submit-button {\n  margin-top: 10px;\n}\n\n.bubble-toggle-menu.button-box .publication-submit-button button {\n  width: auto;\n}\n\n/* .video-wrapper.video-preview .image-preview{\n  border: 1px solid #573cff;\n  border-radius: 0.5rem;\n  margin: 20px 0;\n  overflow: hidden;\n} */\n.tiptop-editor .node-VideoBlock.ProseMirror-selectednode .player-wrapper.player-ready {\n  border-radius: 6px;\n}\n\n.tiptop-editor .uploadFileBlock .videoMiddleContent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.tiptop-editor .video-wrapper .react-player {\n  margin-top: -5px;\n}\n\n.upload-thumbnail {\n  position: relative;\n  background: rgba(250, 250, 251, 1);\n  width: 100%;\n  height: 150px;\n  margin-bottom: 15px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.button-box .upload-thumbnail .uploadBtn svg {\n  position: absolute;\n  left: 112px;\n  top: 69px;\n  padding-top: 3px;\n}\n\n.image-bubble-menu-position {\n  top: -5px !important;\n}\n\n.loop-box p {\n  margin: 0 !important;\n}\n\n.loop-box .toggle-button span {\n  transform: translateX(0) !important;\n}\n\n.loop-box .toggle-button.checked span {\n  transform: translateX(0.9rem) !important;\n}\n\n.tiptop-editor .image-row .gallery-image {\n  position: relative;\n}\n\n.gallery-image:hover .delete-item-block,\n.gallery-image:hover .layout-wrapper {\n  display: block;\n}\n\n.layout-wrapper {\n  display: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #00000033;\n}\n\n.tiptop-editor .delete-item-block {\n  position: absolute;\n  top: 10px;\n  display: none;\n  right: 10px;\n  z-index: 9;\n}\n\n.tiptop-editor .delete-item-block .delete-item {\n  display: flex;\n  flex-direction: row-reverse;\n}\n\n.tiptop-editor .delete-item-block .delete-item .delete-button {\n  pointer-events: auto;\n  position: relative;\n  display: flex;\n  height: 1.8rem;\n  /* width: 1.8rem;  */\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0.375rem;\n  background-color: rgba(255, 255, 255, 0.9);\n  color: #1F2937;\n  transition: all 0.2s;\n}\n\n.tiptop-editor .delete-item-block .delete-item .delete-button svg {\n  stroke: #6b7280;\n  margin-left: 1px;\n}\n\n.tiptop-editor .delete-item-block .delete-item .delete-button:hover svg {\n  stroke: #0A0A0A;\n}\n\n.tiptop-editor .gallery-bubble {\n  min-width: 0 !important;\n}\n\n.tiptop-editor .products-node-wrapper .image-node-wrapper .textBlock {\n  margin-top: 0;\n}\n\n.tiptop-editor .products-node-wrapper .product-button {\n  margin-top: 10px;\n}\n\n.tiptop-editor .products-node-wrapper .products-content .product-title-wrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.tiptop-editor .products-content .product-title,\n.tiptop-editor .products-content .product-description {\n  cursor: text;\n}\n\n.tiptop-editor .products-content .product-title-wrapper:has(.rating) .product-title {\n  max-width: calc(100% - 110px);\n  font-weight: 600;\n}\n\n.tiptop-editor .products-content .product-title-wrapper .rating {\n  display: flex;\n  flex-direction: row;\n  margin: 0;\n  gap: 3px;\n}\n\n.tiptop-editor .products-content .product-title-wrapper .rating .highlighted svg {\n  fill: #F2AE40;\n}\n\n.tiptop-editor .products-node-wrapper .product-title {\n  margin-bottom: 5px;\n  line-height: unset;\n  font-weight: 400;\n}\n\n.tiptop-editor .products-node-wrapper .product-title:empty:before {\n  content: 'Product title' !important;\n  color: #7777;\n}\n\n.tiptop-editor .product-title:focus-visible {\n  outline: 0 !important;\n  border: 0 !important;\n}\n\n.tiptop-editor .product-description {\n  margin: 0 !important;\n  cursor: auto;\n}\n\n.tiptop-editor .product-description:empty:before {\n  content: 'Description' !important;\n  color: #7777;\n}\n\n.tiptop-editor .product-description:focus-visible {\n  outline: 0 !important;\n  border: 0 !important;\n}\n\n.node-products .products-node-wrapper {\n  border: 1px solid #573cff;\n  border-radius: 0.5rem;\n  padding: 14px;\n}\n\n.tiptop-editor .products-node-wrapper .image-block {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.tiptop-editor .products-node-wrapper .image-preview {\n  border: 0 !important;\n  border-radius: 0.5rem !important;\n  margin: 0;\n  line-height: 0;\n}\n\n.tiptop-editor .product .toggle-button span {\n  transform: translateX(0) !important;\n}\n\n.tiptop-editor .product .toggle-button.checked span {\n  transform: translateX(0.9rem) !important;\n}\n\n.tiptop-editor .product .toggle-button-label {\n  justify-content: space-between !important;\n}\n\n.tiptop-editor .product {\n  min-width: 18rem !important;\n  padding: 15px !important;\n}\n\n.tiptop-editor .product .button-element button {\n  background-color: #1c1c1c !important;\n  border: 1px solid #1c1c1c;\n  border-radius: 6px;\n  color: #fff;\n  cursor: pointer;\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 28px;\n  padding: 5px 10px !important;\n  transition: all .3s linear;\n}\n\n.tiptop-editor .product-button button {\n  width: 100% !important;\n}\n\n.tiptop-editor .products-node-wrapper .rating .rate {\n  font-size: 24px;\n}\n\n.tiptop-editor .product-bubble-block .button-wrapp:has(.rating) .rating-label {\n  margin-bottom: 3px;\n}\n\n.tiptop-editor .product-bubble-block .button-wrapp .rating .highlighted svg {\n  fill: #F2AE40;\n}\n\n.tiptop-editor .product-bubble-block .button-wrapp .rating {\n  text-align: right;\n  margin-bottom: 15px;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 3px;\n  margin-top: 10px;\n  color: #737373;\n}\n\n.tiptop-editor .AiWriter-wrapper,\n.tiptop-editor .category-wrapper {\n  padding: 0.5rem;\n  width: 100%;\n  background-color: white;\n  border-radius: 6px;\n  border: 1px solid #E5E7EB;\n  margin-top: 0;\n  margin-bottom: 20px;\n}\n\n.tiptop-editor.AiWriter-wrapper .aitext-generator {\n  display: flex;\n  flex-direction: column;\n  padding: 0.25rem;\n}\n\n.tiptop-editor .AiWriter-wrapper .aitext-generator label {\n  color: rgba(0, 0, 0, 0.8);\n  font-size: 0.75rem;\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n  margin-left: 0.375rem;\n}\n\n.tiptop-editor .node-aiWriter.ProseMirror-selectednode .AiWriter-wrapper {\n  overflow: unset;\n}\n\n.tiptop-editor .AiWriter-wrapper .prompt-textarea {\n  background-color: rgba(0, 0, 0, 0.05);\n  border: 0;\n  border-radius: 6px;\n  caret-color: black;\n  display: block;\n  color: black;\n  font-size: 0.875rem;\n  font-weight: 500;\n  height: 4.5rem;\n  padding: 0.25rem 0.5rem;\n  width: 100%;\n  margin-bottom: 0.5rem;\n  transition: background-color 0.2s, outline-color 0.2s;\n  max-width: 100%;\n  min-height: 100px;\n  resize: vertical;\n  margin-top: 0.5rem;\n}\n\n.tiptop-editor .AiWriter-wrapper .prompt-textarea:focus,\n.tiptop-editor .AiWriter-wrapper .prompt-textarea:active {\n  background-color: transparent;\n  outline: 1px solid black;\n}\n\n.tiptop-editor .AiWriter-wrapper .generator-menu {\n  display: flex;\n  justify-content: space-between;\n  width: auto;\n  gap: 0.25rem;\n}\n\n.tiptop-editor .AiWriter-wrapper .generator-menulist {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid transparent;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  border-radius: 0.375rem;\n  opacity: 1;\n  white-space: nowrap;\n  background-color: #F9FAFB;\n  color: #111827;\n  padding: 0.5rem 0.55rem;\n  transition: background-color 0.2s;\n  height: 38px;\n  position: relative;\n  cursor: pointer;\n}\n\n.tiptop-editor .AiWriter-wrapper .generator-menulist:hover {\n  background-color: #E5E7EB;\n}\n\n.tiptop-editor .AiWriter-wrapper .generator-menulist:active {\n  background-color: #EDE9FE;\n}\n\n.tiptop-editor .generator-menulist .menuitem {\n  padding: 0.5rem;\n  min-width: 12rem;\n  background-color: white;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  border: 1px solid #E5E7EB;\n  position: absolute;\n  top: 41px;\n  left: -4px;\n  z-index: 1;\n}\n\n.tiptop-editor .AiWriter-wrapper .menuitem .categories {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #6B7280;\n  text-align: left;\n  background-color: transparent;\n  width: 100%;\n  border-radius: 0.375rem;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.tiptop-editor .AiWriter-wrapper .menuitem .categories:hover {\n  background-color: #F3F4F6;\n  color: #1F2937;\n}\n\n.tiptop-editor .AiWriter-wrapper .generate-button {\n  display: flex;\n  justify-content: space-between;\n  width: auto;\n  gap: 0.25rem;\n}\n\n.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid black;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  border-radius: 0.375rem;\n  opacity: 1;\n  white-space: nowrap;\n  color: white;\n  background-color: black;\n  padding: 0.5rem 0.55rem;\n  transition: background-color 0.2s;\n  cursor: pointer;\n}\n\n.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button:hover {\n  background-color: #1F2937;\n}\n\n.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button:active {\n  background-color: #1E3A8A;\n}\n\n.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button:disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button.button-discard {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid transparent;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  border-radius: 0.375rem;\n  opacity: 1;\n  white-space: nowrap;\n  background-color: transparent;\n  color: #F87171;\n  padding: 0.5rem 0.55rem;\n  transition: background-color 0.2s, color 0.2s;\n  cursor: pointer;\n}\n\n.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button.button-discard:hover {\n  background-color: rgba(248, 113, 113, 0.1);\n  color: #F87171;\n}\n\n.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button.button-discard:active {\n  background-color: rgba(0, 0, 0, 0.1);\n  color: #1F2937;\n}\n\n.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button.button-discard:disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button.button-insert {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid transparent;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  border-radius: 0.375rem;\n  opacity: 1;\n  white-space: nowrap;\n  background-color: transparent;\n  color: #6B7280;\n  padding: 0.5rem 0.55rem;\n  transition: background-color 0.2s, color 0.2s;\n  cursor: pointer;\n}\n\n.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button.button-insert:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  color: #374151;\n}\n\n.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button.button-insert:active {\n  background-color: rgba(0, 0, 0, 0.1);\n  color: #1F2937;\n}\n\n.tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button.button-insert:disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.tiptop-editor .AiWriter-wrapper .preview-title {\n  color: rgba(0, 0, 0, 0.8);\n  font-size: 0.75rem;\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n  margin-left: 0.375rem;\n}\n\n.tiptop-editor .AiWriter-wrapper .aitext-preview {\n  background-color: white;\n  border-left: 4px solid #e5e7eb;\n  color: black;\n  font-size: 1rem;\n  max-height: 14rem;\n  margin-bottom: 1rem;\n  margin-left: 0.625rem;\n  overflow-y: auto;\n  padding-left: 1rem;\n  position: relative;\n}\n\n.tiptop-editor .AiWriter-wrapper .button .generate-button.insertbtn {\n  display: block;\n}\n\n.tiptop-editor .AiWriter-wrapper .button .generate-button .mobile-button {\n  display: none;\n}\n\n.tiptop-editor .generator-menu .ai-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.tiptop-editor .AiWriter-wrapper .dropdown .downarrow {\n  position: absolute;\n  top: 12px;\n}\n\n.tiptop-editor .logoslider-wapper {\n  margin-bottom: 20px;\n}\n\n.tiptop-editor .logoslider-wapper .swiper-wrapper {\n  align-items: center;\n}\n\n.tiptop-editor .logoslider-wapper .swiper-slide {\n  margin: 20px auto;\n}\n\n.tiptop-editor .logoslider-wapper .swiper-slide img {\n  max-width: 100%;\n}\n\n.tiptop-editor .bubble-toggle-menu .categories-button .menu-icon {\n  height: 24px !important;\n}\n\n.tiptop-editor .node-VideoBlock .video-wrapper {\n  margin-bottom: 20px;\n}\n\n.tiptop-editor .node-VideoBlock.ProseMirror-selectednode .video-wrapper.video-preview,\n.node-galleryBlock .image-block,\n.node-imageBlock .image-block .image-preview {\n  border: 0;\n  overflow: unset;\n}\n\n.tiptop-editor .ProseMirror-selectednode .video-wrapper .image-preview.image-width-wide,\n.tiptop-editor .ProseMirror-selectednode .video-wrapper .image-preview.image-width-default {\n  border: 1px solid #573cff;\n  border-radius: 0.5rem;\n}\n\n.node-fileBlock .fileblock-wrapper,\n.node-publications .publications-wrapper,\n.node-products .products-node-wrapper,\n.node-whychoosemalmart .whychoosemalmart-node-wrapper,\n.node-ourservices .ourservices-node-wrapper,\n.node-galleryBlock .image-preview,\n.node-VideoBlock .video-wrapper.video-preview,\n.node-logoSliderBlock .logoslider-wapper,\n.node-imageBlock .image-block .image-preview,\n.node-reviewBlock .review-node-wrapper {\n  border: 1px solid transparent;\n}\n\n/* .node-vimeoBlock .vimeo-video,.gallery-block .image-preview, .image-block .image-preview {\n  overflow: hidden;\n} */\n.node-aiWriter.ProseMirror-selectednode .AiWriter-wrapper,\n.node-categoryBlock.ProseMirror-selectednode .category-wrapper,\n.node-publications.ProseMirror-selectednode .publications-wrapper,\n.node-products.ProseMirror-selectednode .products-node-wrapper,\n.node-vimeoBlock.ProseMirror-selectednode .vimeo-video,\n.tiptop-editor .node-galleryBlock.ProseMirror-selectednode .image-preview,\n.node-VideoBlock.ProseMirror-selectednode .video-wrapper.video-preview,\n.node-imageBlock.ProseMirror-selectednode .image-block .image-preview,\n.tiptop-editor .node-logoSliderBlock.ProseMirror-selectednode .logoslider-wapper,\n.tiptop-editor .node-brand.ProseMirror-selectednode .brand-node-wrapper,\n.tiptop-editor .node-whychoosemalmart.ProseMirror-selectednode .whychoosemalmart-node-wrapper,\n.tiptop-editor .node-ourservices.ProseMirror-selectednode .ourservices-node-wrapper,\n.tiptop-editor .node-parentCategoryBlock.ProseMirror-selectednode .category-wrapper ,\n.tiptop-editor .node-reviewBlock.ProseMirror-selectednode .review-node-wrapper {\n  border: 1px solid #573cff;\n  border-radius: 0.5rem;\n  overflow: hidden;\n}\n\n.node-VideoBlock .video-preview,\n.node-imageBlock.ProseMirror-selectednode .image-preview,\n.gallery-block .gallery-preview {\n  border: none;\n  border-radius: 0;\n}\n\n.tiptop-editor .image-block .image-preview.image-width-default .image-title {\n  margin-top: -5px;\n}\n\n.tiptop-editor .image-block .video-title.image-title p {\n  font-size: 14px;\n}\n\n.tiptop-editor .video-wrapper.video-preview .player-wrapper.player-ready {\n  margin-top: 0;\n}\n\n.tiptop-editor .video-wrapper.video-preview .video-title {\n  margin-top: -5px;\n}\n\n.node-parentCategoryBlock{\n  margin-block: 20px;\n}\n\n.ProseMirror [data-type='columns'] [data-position='left']:hover,\n.ProseMirror [data-type='columns'] [data-position='right']:hover,\n.ProseMirror [data-type='columns'] [data-position='left'].has-focus,\n.ProseMirror [data-type='columns'] [data-position='right'].has-focus,\n.ProseMirror [data-type='columns'] [data-position='center']:hover,\n.ProseMirror [data-type='columns'] [data-position='center'].has-focus {\n  border: 1px solid #573cff;\n}\n\n.ProseMirror [data-type='columns'] [data-position='left'],\n.ProseMirror [data-type='columns'] [data-position='right'],\n.ProseMirror [data-type='columns'] [data-position='center'] {\n  border: 1px solid transparent;\n}\n\n.gallery-block .video-caption:empty:before {\n  content: 'Write a caption for the Gallery (Optional)'\n}\n\n.gallery-block {\n  position: relative;\n}\n\n.galley-layout-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #00000033;\n}\n\n.image-node-wrapper .dragging {\n  opacity: 0.6;\n}\n\n.tiptop-editor .image-node-wrapper .progress{\n  top: 20px;\n}\n\n.node-VideoBlock.ProseMirror-selectednode .image-preview,\n.node-imageBlock.ProseMirror-selectednode .image-preview,\n.node-galleryBlock.ProseMirror-selectednode .image-preview {\n  border: none;\n  border-radius: 0;\n}\n\n.node-image .tabTitle,\n.node-video .tabTitle,\n.node-gallery .tabTitle,\n.node-products .tabTitle,\n.node-file .tabTitle,\n.node-logoSlider .tabTitle {\n  list-style-type: none !important;\n  padding-inline-start: 0 !important;\n  padding: 0 24px !important;\n}\n\n.node-image .tabTitle li,\n.node-video .tabTitle li,\n.node-gallery .tabTitle li,\n.node-products .tabTitle li,\n.node-file .tabTitle li,\n.node-logoSlider .tabTitle li {\n  margin-bottom: 0 !important;\n  margin-top: 0 !important;\n}\n\n.node-image .popupTitle,\n.node-video .popupTitle,\n.node-gallery .popupTitle,\n.node-products .popupTitle,\n.node-file .popupTitle,\n.node-logoSlider .popupTitle {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 28px;\n  color: #101828;\n  margin-bottom: 10px;\n}\n\n.node-image .pageSearchInput input,\n.node-video .pageSearchInput input,\n.node-gallery .pageSearchInput input,\n.node-products .pageSearchInput input,\n.node-file .pageSearchInput input,\n.node-logoSlider .pageSearchInput input {\n  width: calc(100% - 5px);\n  height: 40px !important;\n  background: #ffffff;\n  border: 1px solid #eaecf0;\n  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);\n  border-radius: 6px;\n  padding-left: 40px;\n  outline: none;\n  right: 15px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  color: #667085;\n}\n\n.node-image .dropdown-wrapp ul,\n.node-video .dropdown-wrapp ul,\n.node-gallery .dropdown-wrapp ul,\n.node-products .dropdown-wrapp ul,\n.node-file .dropdown-wrapp ul,\n.node-logoSlider .dropdown-wrapp ul {\n  border: none;\n  padding: 10px;\n}\n\n.node-image .dropdown,\n.node-video .dropdown,\n.node-gallery .dropdown,\n.node-products .dropdown,\n.node-file .dropdown,\n.node-logoSlider .dropdown {\n  background: white;\n  border: 1px solid #eaecf0;\n  box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);\n  border-radius: 6px;\n  position: absolute;\n  right: 0;\n  top: 50px;\n  min-width: 170px;\n  z-index: 999999;\n}\n\n.node-file .dropdown.countryDropdown {\n  min-width: 160px;\n}\n\n.node-image .dropdown.addDropdown,\n.node-video .dropdown.addDropdown,\n.node-gallery .dropdown.addDropdown,\n.node-products .dropdown.addDropdown,\n.node-file .dropdown.addDropdown,\n.node-logoSlider .dropdown.addDropdown {\n  right: auto;\n}\n\n.node-image .dropdown.dateDropdown {\n  width: max-content;\n}\n\n.node-image .dropdown-wrapp ul li:not(:last-child),\n.node-video .dropdown-wrapp ul li:not(:last-child),\n.node-gallery .dropdown-wrapp ul li:not(:last-child),\n.node-products .dropdown-wrapp ul li:not(:last-child),\n.node-file .dropdown-wrapp ul li:not(:last-child),\n.node-logoSlider .dropdown-wrapp ul li:not(:last-child) {\n  margin-bottom: 10px;\n}\n\n.node-image .dropdown-wrapp ul li,\n.node-video .dropdown-wrapp ul li,\n.node-gallery .dropdown-wrapp ul li,\n.node-products .dropdown-wrapp ul li,\n.node-file .dropdown-wrapp ul li,\n.node-logoSlider .dropdown-wrapp ul li {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.node-image .media-grid-layout .list-search input[type=\"checkbox\"],\n.node-video .media-grid-layout .list-search input[type=\"checkbox\"],\n.node-gallery .media-grid-layout .list-search input[type=\"checkbox\"],\n.node-products .media-grid-layout .list-search input[type=\"checkbox\"],\n.node-file .media-grid-layout .list-search input[type=\"checkbox\"],\n.node-logoSlider .media-grid-layout .list-search input[type=\"checkbox\"] {\n  font-size: 0;\n  width: 18px;\n  height: 18px;\n  border: 1px solid transparent;\n  -o-appearance: none;\n  appearance: none;\n  position: relative;\n  padding: 0 0 0 0;\n  margin: 0;\n  margin-right: 9px !important;\n  right: 0;\n  top: 0;\n}\n\n.node-image .media-grid-layout input[type=\"checkbox\"]:not(:checked)::before,\n.node-video .media-grid-layout input[type=\"checkbox\"]:not(:checked)::before,\n.node-gallery .media-grid-layout input[type=\"checkbox\"]:not(:checked)::before,\n.node-products .media-grid-layout input[type=\"checkbox\"]:not(:checked)::before,\n.node-file .media-grid-layout input[type=\"checkbox\"]:not(:checked)::before,\n.node-logoSlider .media-grid-layout input[type=\"checkbox\"]:not(:checked)::before {\n  background-color: #fff;\n}\n\n.node-image .media-grid-layout input[type=\"checkbox\"]::before,\n.node-video .media-grid-layout input[type=\"checkbox\"]::before,\n.node-gallery .media-grid-layout input[type=\"checkbox\"]::before,\n.node-products .media-grid-layout input[type=\"checkbox\"]::before,\n.node-file .media-grid-layout input[type=\"checkbox\"]::before,\n.node-logoSlider .media-grid-layout input[type=\"checkbox\"]::before {\n  margin-right: 0;\n}\n\n.node-image .list-search input[type=\"checkbox\"]:before,\n.node-video .list-search input[type=\"checkbox\"]:before,\n.node-gallery .list-search input[type=\"checkbox\"]:before,\n.node-products .list-search input[type=\"checkbox\"]:before,\n.node-file .list-search input[type=\"checkbox\"]:before,\n.node-logoSlider .list-search input[type=\"checkbox\"]:before {\n  position: absolute;\n  left: 0;\n  top: -1px;\n  margin-right: 0;\n}\n\n.node-image input[type=\"checkbox\"]:before,\n.node-video input[type=\"checkbox\"]:before,\n.node-gallery input[type=\"checkbox\"]:before,\n.node-products input[type=\"checkbox\"]:before,\n.node-file input[type=\"checkbox\"]:before,\n.node-logoSlider input[type=\"checkbox\"]:before {\n  content: \"\";\n  font-size: 15px;\n  border: 1px solid #d0d5dd;\n  display: block;\n  width: 15px;\n  background: none;\n  height: 15px;\n  margin-right: 7px;\n  border-radius: 4px;\n  min-width: 18px;\n  min-height: 18px;\n  margin-right: 15px;\n  background-size: 60%;\n  background-position: 4px center;\n  background-repeat: no-repeat;\n  accent-color: #e6f2ff;\n}\n\n.node-image .dropdown-wrapp ul li span,\n.node-video .dropdown-wrapp ul li span,\n.node-gallery .dropdown-wrapp ul li span,\n.node-products .dropdown-wrapp ul li span,\n.node-file .dropdown-wrapp ul li span,\n.node-logoSlider .dropdown-wrapp ul li span {\n  margin-left: 0;\n  color: #101828;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.node-image input[type=\"checkbox\"]:checked:before,\n.node-video input[type=\"checkbox\"]:checked:before,\n.node-gallery input[type=\"checkbox\"]:checked:before,\n.node-products input[type=\"checkbox\"]:checked:before,\n.node-file input[type=\"checkbox\"]:checked:before,\n.node-logoSlider input[type=\"checkbox\"]:checked:before {\n  /* background-image: url('../../images/checkbox.svg'); */\n  border: 1px solid #2b59ff;\n  background-color: #fff;\n}\n\n.node-image .gridImg input,\n.node-video .gridImg input,\n.node-gallery .gridImg input,\n.node-products .gridImg input,\n.node-file .gridImg input,\n.node-logoSlider .gridImg input {\n  position: absolute !important;\n  top: 10px;\n  right: 10px;\n  appearance: none;\n  width: auto !important;\n  background: unset;\n  height: 0;\n  padding: 0;\n}\n\n.node-image .file-wrapper .filename,\n.node-video .file-wrapper .filename,\n.node-gallery .file-wrapper .filename,\n.node-products .file-wrapper .filename,\n.node-file .file-wrapper .filename,\n.node-logoSlider .file-wrapper .filename {\n  margin-top: 0 !important;\n  line-height: unset !important;\n}\n\n.node-image .file-wrapper .formUrlImg,\n.node-video .file-wrapper .formUrlImg,\n.node-gallery .file-wrapper .formUrlImg,\n.node-products .file-wrapper .formUrlImg,\n.node-file .file-wrapper .formUrlImg,\n.node-logoSlider .file-wrapper .formUrlImg {\n  margin-top: 14px;\n}\n\n.node-image .file-wrapper.show-wrapper,\n.node-video .file-wrapper.show-wrapper,\n.node-gallery .file-wrapper.show-wrapper,\n.node-products .file-wrapper.show-wrapper,\n.node-file .file-wrapper.show-wrapper,\n.node-logoSlider .file-wrapper.show-wrapper {\n  z-index: 0 !important;\n}\n\n.node-image .featuredImageModal input.zoom-range,\n.node-video .featuredImageModal input.zoom-range,\n.node-gallery .featuredImageModal input.zoom-range,\n.node-products .featuredImageModal input.zoom-range,\n.node-file .featuredImageModal input.zoom-range,\n.node-logoSlider .featuredImageModal input.zoom-range {\n  padding: 0 !important;\n}\n\n.node-image .ring-loader:before,\n.node-video .ring-loader:before,\n.node-gallery .ring-loader:before,\n.node-products .ring-loader:before,\n.node-file .ring-loader:before,\n.node-logoSlider .ring-loader:before {\n  border: 3px solid #fff !important;\n}\n\n.products-node-wrapper .gallery-image .image-preview {\n  position: relative;\n}\n\n.publications-wrapper .publication-image {\n  overflow: hidden;\n}\n\n.publications-wrapper .publication-image img {\n  width: 100%;\n  max-width: 100%;\n  height: 300px;\n  object-fit: cover;\n  transform: scale(1, 1);\n  transition-property: transform, filter, opacity;\n  transition-timing-function: cubic-bezier(0.57, 0.21, 0.69, 1);\n  transition-duration: 0.3s;\n}\n\n.publications-wrapper .publication-image:hover img {\n  transform: scale(1.05, 1.05);\n}\n\n.tiptop-editor .node-bookmarkBlock,\n.tiptop-editor .node-tableOfContentsNode,\n.tiptop-editor .node-spotifyBlock,\n.tiptop-editor .node-soundCloudBlock,\n.tiptop-editor .node-other,\n.tiptop-editor .node-products {\n  margin-bottom: 20px;\n}\n\n.tiptop-editor .node-fileBlock,\n.tiptop-editor .node-publications {\n  margin-bottom: 10px;\n}\n\n.dashboard.new-publication:has(.popupContainer),\n.dashboard.new-page:has(.popupContainer),\n.dashboard.new-newsletter:has(.popupContainer) {\n  position: relative;\n  z-index: 15;\n}\n\n.main-wrapper:has(.uploadMediaPopup) .sidebar, .main-wrapper:has(.uploadMediaPopup) .topbar-container, .main-wrapper:has(.uploadMediaPopup) .page-right-sidebar {\n  z-index: -1;\n}\n.tiptop-editor .main-wrapper .main-content {\n  z-index: 10;\n}\n\n.swiper-slider {\n  z-index: 50;\n  grid-column-gap: 1.5rem;\n  grid-row-gap: 1.5rem;\n  text-align: center;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  display: flex;\n  position: relative;\n  overflow: hidden;\n}\n\n.swiper-slider-container {\n  grid-column-gap: 1rem;\n  grid-row-gap: 1rem;\n  width: 100%;\n  display: flex;\n}\n\n.swiper-slider-list {\n  animation: logoSliderScroll 15s linear infinite;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  will-change: transform;\n  transform-style: preserve-3d;\n  animation-duration: 66.8s;\n  flex: none;\n}\n\n.swiper-items {\n  grid-column-gap: 1rem;\n  grid-row-gap: 1rem;\n  display: flex;\n}\n\n.swiper-slide-item {\n  height: 4.5rem;\n}\n\n.swiper-slide-item img {\n  vertical-align: middle;\n  max-width: 100%;\n  display: inline-block;\n  height: 100%;\n  border: 0;\n}\n\n.twitterBlock td,\n.twitterBlock th {\n  border: 0 !important\n}\n\n.twitterBlock tr td table tr td {\n  padding: 0;\n}\n\n.tiptop-editor .twitterBlock .userSubPanel .userName {\n  display: block;\n  font-size: 16px;\n  color: #1c2022;\n  font-weight: 700;\n  margin-bottom: 0;\n  line-height: unset;\n}\n\n.tiptop-editor .twitterBlock .userSubPanel .userNamewithLink {\n  display: block;\n  color: #697882;\n  font-size: 16px;\n  margin-bottom: 0;\n  line-height: unset;\n  margin-top: 0;\n}\n\n.tiptop-editor .twitterBlock .retweetCount {\n  margin-left: 5px\n}\n\n.tiptop-editor .twitterBlock .likeCount,\n.tiptop-editor .twitterBlock .retweetCount {\n  color: #697882;\n  font-size: 14px\n}\n\n.tiptop-editor .twitterBlock .likeCount span,\n.tiptop-editor .twitterBlock .retweetCount span {\n  color: #1C2022;\n  font-weight: bold;\n}\n\n.field-info {\n  font-weight: 400;\n}\n\n.tiptop-editor .category-grid-wrapper {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n.tiptop-editor .parent-category-grid-wrapper {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n.tiptop-editor .category-item {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 25px 30px;\n  flex-wrap: wrap;\n  border-radius: 8px;\n  background-color: #f6f6f6;\n  flex: 1 1;\n}\n\n.tiptop-editor .parent-category-grid-wrapper .category-item{\n  padding: 12px 20px;\n}\n\nbody:has(.layout-two-column .parent-category-grid-wrapper) .image-block .image-preview img {\n  max-height: 300px;\n}\n\nbody:has(.layout-two-column .parent-category-grid-wrapper) .image-block{\n  margin-bottom: 0;\n}\n\n.tiptop-editor .category-item img {\n  width: 100%;\n  object-fit: cover;\n  border-radius: 4px;\n  margin-bottom: 30px;\n}\n.tiptop-editor .parent-category-grid-wrapper .category-item{\n  background-color: #fff;\n  border: 1px solid #b4b4b4;\n  border-radius: 4px;\n}\n\n.tiptop-editor .parent-category-grid-wrapper .category-item img{\n  margin-bottom: 0;\n}\n\n.tiptop-editor .category-item .heading {\n  font-size: 24px;\n  font-weight: 600;\n  color: #55883b;\n}\n.tiptop-editor .parent-category-grid-wrapper .category-item .heading {\n  font-size: 16px;\n  font-weight: 600;\n  color: #55883b;\n  margin: 0;\n}\n\n.tiptop-editor .category-link {\n  background-color: #55883b;\n  color: #fff;\n  padding: 5px 8px;\n  border-radius: 4px;\n  text-decoration: none;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.tiptop-editor .top-deal-grid-wrapper {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 25px;\n  margin-bottom: 20px;\n}\n\n.tiptop-editor .top-deal-columns-block {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  border-radius: 8px;\n  background-color: #fff;\n}\n\n.tiptop-editor .top-deal-columns-block.layout-top-deal-two-column {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.tiptop-editor [data-type='columns'].top-deal-columns-block.is-editor-empty::before {\n  content: '';\n  display: none;\n}\n\n.tiptop-editor .top-deal-item img {\n  width: 100%;\n  height: 150px;\n  object-fit: cover;\n  border-radius: 4px;\n}\n\n.tiptop-editor .category-selector {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.tiptop-editor .product-grid {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0px, 1fr));\n  gap: 16px;\n}\n\n.tiptop-editor .product-card {\n  border: 1px solid #b4b4b4;\n  border-radius: 4px;\n  padding: 16px;\n  background: #fff;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.tiptop-editor .brand-content {\n  display: flex;\n  padding: 12px;\n  gap: 10px;\n}\n\n.tiptop-editor .discount-badge {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  background: #e53935;\n  color: #fff;\n  font-size: 12px;\n  padding: 3px 6px;\n  border-radius: 4px;\n}\n\n.tiptop-editor .product-image img {\n  width: 100%;\n  height: 150px;\n  object-fit: contain;\n}\n\n.tiptop-editor .product-category {\n  font-size: 12px;\n  color: #777;\n  margin: 0;\n}\n\n.tiptop-editor .product-title {\n  font-size: 14px;\n  font-weight: 600;\n  margin: 4px 0;\n}\n\n.tiptop-editor .price-wrapper {\n  margin: 6px 0;\n}\n\n.tiptop-editor .old-price {\n  text-decoration: line-through;\n  color: #999;\n  margin-right: 6px;\n}\n\n.tiptop-editor .new-price,\n.tiptop-editor .unit {\n  font-weight: 600;\n  color: #2e7d32;\n}\n\n.tiptop-editor .rating {\n  font-size: 12px;\n  margin: 6px 0;\n}\n\n.tiptop-editor .add-to-cart-btn {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #b4b4b4;\n  background: #fff;\n  cursor: pointer;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.products-bubble-block .button-wrapp {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 6px;\n}\n\n.products-bubble-block .button-wrapp input[type=\"checkbox\"]::before {\n  margin-right: 0;\n}\n\n.products-bubble-block .button-wrapp input[type=\"checkbox\"] {\n  margin: 0;\n}\n\n.tiptop-editor .bubble-toggle-menu .products-bubble-block .toggle-button-label {\n  margin: 0;\n  margin-bottom: 0;\n}\n\n.bubble-toggle-menu.button-box.image-bubble-menu.products,\n.bubble-toggle-menu.button-box.image-bubble-menu.brand {\n  padding: 12px !important;\n}\n\n.products-bubble-block .button-element button,\n.brand-bubble-block .button-element button {\n  line-height: unset !important;\n  padding: 8px 12px !important;\n  margin-top: 15px;\n}\n\n.products-node-wrapper .ringLoader:before,\n.brand-node-wrapper .ringLoader:before,\n.review-wrapper .ringLoader:before,\n.review-node-wrapper .ringLoader:before {\n  border: 2px solid #000000;\n}\n\n.brand-node-wrapper .brand-image {\n  height: 100px;\n  width: 200px;\n}\n\n.brand-node-wrapper .brand-image img {\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n}\n\n@media screen and (max-width: 1450px) {\n\n  .tiptop-editor .publications-wrapper .publication-list.grid.three-column,\n  .tiptop-editor .publications-wrapper .publication-list.grid.four-column {\n    grid-template-columns: repeat(2, minmax(0px, 1fr))\n  }\n\n  .tiptop-editor .publications-wrapper .publication-list.grid .publication-item .publication-image {\n    height: 160px;\n  }\n\n  .tiptop-editor .product-grid {\n    grid-template-columns: repeat(3, minmax(0px, 1fr));\n  }\n}\n\n@media screen and (max-width: 1260px) {\n\n  .new-publication .publication-Regular.newpageContent .newpageLeft,\n  .new-page .newpageLeft,\n  .new-newsletter .newpageLeft {\n    padding-right: 80px;\n    padding-left: 80px;\n  }\n\n  .tiptop-editor .video-wrapper .image-preview.image-width-wide,\n  .tiptop-editor .image-block .image-preview.image-width-full,\n  .tiptop-editor .logoslider-wapper.image-width-full {\n    width: calc(100vw - 312px - 36px - 36px - 40px);\n  }\n\n  .tiptop-editor .publication-list.list .publication-item {\n    display: flex;\n    align-items: flex-start;\n    margin-top: 20px;\n  }\n\n  .tiptop-editor .publications-wrapper .publication-list.list .publication-image {\n    width: 40%;\n  }\n\n  .tiptop-editor .publications-wrapper .publication-image img {\n    width: 100%;\n  }\n\n  .tiptop-editor .publication-list.list .publication-data {\n    width: 60%;\n    padding-left: 15px;\n    padding-top: 0;\n  }\n\n  .dashboard.new-publication:has(.popupContainer) .newpageRight,\n  .dashboard.new-page:has(.popupContainer) .newpageRight,\n  .dashboard.new-newsletter:has(.popupContainer) .newpageRight {\n    visibility: hidden;\n  }\n\n  .tiptop-editor .publications-wrapper .publication-list.grid .publication-item .publication-image {\n    height: 220px;\n  }\n\n  .tiptop-editor .product-grid {\n    grid-template-columns: repeat(2, minmax(0px, 1fr));\n  }\n}\n\n@media screen and (max-width: 1240px) {\n\n  .tiptop-editor .video-wrapper .image-preview.image-width-wide,\n  .tiptop-editor .image-block .image-preview.image-width-full,\n  .tiptop-editor .logoslider-wapper.image-width-full {\n    width: calc(100vw - 312px - 36px - 40px);\n  }\n}\n\n@media screen and (max-width: 1024px) {\n\n  .tiptop-editor .video-wrapper .image-preview.image-width-wide,\n  .tiptop-editor .image-block .image-preview.image-width-full,\n  .tiptop-editor .logoslider-wapper.image-width-full {\n    width: calc(90vw - 36px);\n  }\n\n  .tiptop-editor .publications-wrapper .publication-list.grid.three-column {\n    grid-template-columns: repeat(3, minmax(0px, 1fr))\n  }\n\n  .tiptop-editor .publications-wrapper .publication-list.grid.four-column {\n    grid-template-columns: repeat(4, minmax(0px, 1fr))\n  }\n\n  .tiptop-editor .publications-wrapper .publication-list.list .publication-image {\n    width: 30%;\n  }\n\n  .tiptop-editor .publications-wrapper .publication-image img {\n    width: 100%;\n  }\n\n  .tiptop-editor .publication-list.list .publication-data {\n    width: 70%;\n    padding-left: 15px;\n    padding-top: 0;\n  }\n\n  .new-publication .publication-Regular.newpageContent .newpageLeft,\n  .new-page .newpageContent .newpageLeft,\n  .new-newsletter .newpageContent .newpageLeft {\n    padding-right: 45px;\n    padding-left: 45px;\n  }\n\n  .tiptop-editor .DragHandleItems {\n    flex-wrap: wrap;\n  }\n\n  .DragHandleItems .DragHandleItem {\n    width: 100%;\n  }\n\n  .tiptop-editor [data-tippy-root] {\n    z-index: 5 !important;\n  }\n\n  .dashboard.new-publication:has(.popupContainer),\n  .dashboard.new-page:has(.popupContainer),\n  .dashboard.new-newsletter:has(.popupContainer) {\n    position: relative;\n    z-index: 20;\n  }\n\n  .main-wrapper .main-content {\n    z-index: 0;\n  }\n\n  .board:has(.popupContainer) .sidebar {\n    z-index: 0;\n  }\n\n  .tiptop-editor .product-grid {\n    grid-template-columns: repeat(5, minmax(0px, 1fr));\n  }\n\n}\n\n@media (max-width: 767px) {\n\n  .tiptop-editor .publications-wrapper .publication-list.grid {\n    grid-template-columns: repeat(2, minmax(0px, 1fr));\n    gap: 20px;\n  }\n\n  .tiptop-editor .linkBox {\n    flex-direction: column;\n  }\n\n  .tiptop-editor .textBlock.linkBox .linkImageSection {\n    width: 100% !important;\n  }\n\n  .tiptop-editor .linkBox .linkData {\n    width: 100%;\n    padding-left: 0;\n    padding-top: 15px;\n  }\n\n  .tiptop-editor .link-content img {\n    height: auto;\n  }\n\n  .tiptop-editor .video-wrapper .image-preview.image-width-wide,\n  .tiptop-editor .image-block .image-preview.image-width-full,\n  .tiptop-editor .logoslider-wapper.image-width-full {\n    width: calc(100vw - 36px);\n  }\n\n  .tiptop-editor .publications-wrapper .publication-list.grid.three-column,\n  .tiptop-editor .publications-wrapper .publication-list.grid.four-column {\n    grid-template-columns: repeat(2, minmax(0px, 1fr))\n  }\n\n  .tiptop-editor [data-type='video'] .video-wrapper .player-wrapper.player-ready {\n    min-height: auto;\n  }\n\n  .new-publication .publication-Regular.newpageContent .newpageLeft,\n  .new-page .newpageContent .newpageLeft,\n  .new-newsletter .newpageContent .newpageLeft {\n    margin-left: 22px;\n    margin-right: 22px !important;\n  }\n\n  .newpageContent .newpageLeft {\n    width: calc(100% - 44px);\n  }\n\n  .tiptop-editor .product-grid {\n    grid-template-columns: repeat(2, minmax(0px, 1fr));\n  }\n}\n\n@media (max-width: 590px) {\n  .tiptop-editor .publications-wrapper .publication-list.grid .publication-item .publication-image {\n    height: 160px;\n  }\n\n  .tiptop-editor .parent-category-grid-wrapper {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n\n@media (max-width: 430px) {\n  .tiptop-editor .tiptap.ProseMirror {\n    padding-bottom: 10px;\n  }\n\n  .publication-list.list .publication-item {\n    flex-direction: row;\n    margin-top: 20px;\n  }\n\n  .publication-list.list .publication-data {\n    width: 100%;\n    padding-left: 0;\n  }\n\n  .publication-list.list .publication-date {\n    font-size: 14px;\n  }\n\n  .tiptop-editor .publications-wrapper .publication-list.list .publication-image {\n    width: 30%;\n  }\n\n  .tiptop-editor .publication-list.list .publication-data {\n    width: 70%;\n    padding-left: 10px;\n  }\n\n  .publication-list.list .publication-image,\n  .publication-list.grid .publication-image {\n    width: 100%;\n  }\n\n  .publication-list.list .publication-image img,\n  .publication-list.grid .publication-image img {\n    width: 100%;\n  }\n\n  .tiptop-editor .publications-wrapper .tiptop-editor .publication-list.grid {\n    grid-template-columns: repeat(1, minmax(0px, 1fr));\n  }\n\n  .tiptop-editor .AiWriter-wrapper .generator-menulist,\n  .tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button {\n    padding: 0.5rem 0.60rem;\n    gap: 0.2rem;\n  }\n\n  .tiptop-editor .AiWriter-wrapper .generate-button .toolbar-button {\n    width: 100%;\n  }\n\n  .tiptop-editor .generator-menulist .menuitem {\n    width: 100%;\n    height: 11rem;\n    overflow-y: scroll;\n    margin-left: 4px;\n  }\n\n  .tiptop-editor .generator-menu .ai-button,\n  .tiptop-editor .AiWriter-wrapper .generator-menu {\n    flex-direction: column;\n  }\n\n  .AiWriter-wrapper .generator-menu {\n    gap: 0.5rem;\n  }\n\n  .tiptop-editor .AiWriter-wrapper .generate-button {\n    width: 100%;\n  }\n\n  .tiptop-editor .AiWriter-wrapper .button .generate-button.insertbtn {\n    display: none;\n  }\n\n  .tiptop-editor .AiWriter-wrapper .button .generate-button .mobile-button {\n    display: block;\n  }\n\n  .tiptop-editor .publications-wrapper .publication-list.grid.three-column,\n  .tiptop-editor .publications-wrapper .publication-list.grid.four-column,\n  .tiptop-editor .publications-wrapper .publication-list.grid.two-column {\n    grid-template-columns: repeat(1, minmax(0px, 1fr))\n  }\n}\n\n\n@keyframes rotate {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes prixClipFix {\n  0% {\n    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);\n  }\n\n  25% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);\n  }\n\n  50% {\n    clip-path: polygon(50% 50%,\n        0 0,\n        100% 0,\n        100% 100%,\n        100% 100%,\n        100% 100%);\n  }\n\n  75% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);\n  }\n\n  100% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);\n  }\n}\n\n@keyframes loading {\n  0% {\n    opacity: 0.6;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0.6;\n  }\n}\n\n@keyframes progress {\n  0% {\n    width: 0%;\n  }\n\n  25% {\n    width: 50%;\n  }\n\n  50% {\n    width: 75%;\n  }\n\n  75% {\n    width: 85%;\n  }\n\n  100% {\n    width: 100%;\n  }\n}\n\n;\n\n/* Why Choose Mal Mart Styles */\n.whychoosemalmart-node-wrapper {\n  margin-bottom: 20px;\n}\n\n.whychoosemalmart-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.whychoosemalmart-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 20px;\n}\n\n.whychoosemalmart-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.whychoosemalmart-image {\n  width: 70px;\n  height: 70px;\n  margin-bottom: 8px;\n}\n\n.whychooseus-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 30px;\n}\n\n.whychooseus-item {\n  display: flex;\n  flex-direction: column;\n  /* align-items: center;\n  text-align: center; */\n}\n\n.whychooseus-image {\n  width: 150px;\n  height: 110px;\n  margin-bottom: 8px;\n}\n\n.whychoosemalmart-image img, .whychooseus-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\nh3.whychoosemalmart-title {\n  font-size: 16px;\n  color: #1a1a1a;\n  margin-bottom: 4px;\n}\n\nh3.whychooseus-title {\n  font-size: 18px;\n  color: #1a1a1a;\n  margin-bottom: 4px;\n  text-align: left;\n  font-weight: 500;\n}\n\n/* Our Services Styles */\n.ourservices-node-wrapper {\n  margin-bottom: 20px;\n}\n\n.ourservices-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.ourservices-content h5{\n  font-size: 28px;\n  text-align: center;\n  font-weight: 600;\n  margin-bottom: 8px;\n  margin-top: 20px !important;\n}\n\n.ourservices-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 20px;\n}\n\n.ourservices-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.ourservices-image {\n  width: 150px;\n  height: 100px;\n}\n\n.ourservices-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\np.ourservices-title {\n  font-size: 18px;\n  color: #5f5f5f;\n  margin-bottom: 4px;\n  margin-top: 8px;\n  line-height: unset;\n}\n\n.ProseMirror p.ourservices-description {\n  font-size: 14px;\n  color: #737373;\n  margin: 0;\n  line-height: unset;\n}\n\n@media (max-width: 1024px) {\n  .ourservices-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 15px;\n  }\n}\n\n@media (max-width: 768px) {\n  .ourservices-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 15px;\n  }\n\n  .ourservices-item {\n    padding: 15px;\n  }\n\n  .ourservices-image {\n    width: 60px;\n    height: 60px;\n    margin-bottom: 10px;\n  }\n\n  .ourservices-title {\n    font-size: 16px;\n  }\n\n  .ourservices-description {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .ourservices-grid {\n    grid-template-columns: repeat(1, 1fr);\n    gap: 10px;\n  }\n\n  .ourservices-item {\n    padding: 15px;\n  }\n}\n\n/* Offers Block Styles */\n\n.offers-node-wrapper {\n  padding: 0.5rem;\n}\n\n.offers-content {\n  text-align: center;\n  padding: 20px;\n  background: #ffffff;\n  border-radius: 12px;\n}\n\n.offers-content h5{\n  font-size: 32px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 30px;\n  margin-top: 0;\n}\n\n.offers-grid {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.offers-item {\n    padding: 20px;\n    border-radius: 12px;\n    width: calc(33.33% - 20px);\n}\n\n.offers-image {\n  width: 150px;\n  height: 110px;\n  margin: 0 auto 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.offers-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\np.offers-title {\n  font-size: 18px;\n  color: #5f5f5f;\n  margin-bottom: 4px;\n  margin-top: 8px;\n  line-height: unset;\n}\n\n@media (max-width: 1024px) {\n  .offers-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 15px;\n  }\n}\n\n@media (max-width: 768px) {\n  .offers-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 15px;\n  }\n\n  .offers-item {\n    padding: 15px;\n  }\n\n  .offers-image {\n    width: 60px;\n    height: 60px;\n    margin-bottom: 10px;\n  }\n\n  .offers-title {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .offers-grid {\n    grid-template-columns: repeat(1, 1fr);\n    gap: 10px;\n  }\n\n  .offers-item {\n    padding: 15px;\n  }\n}\n\n/* Review Block Styles */\n.tiptop-editor .review-node-wrapper {\n  padding: 0.5rem;\n}\n\n.tiptop-editor .review-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n}\n\n.tiptop-editor .review-item {\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  border: 1px solid #b4b4b4;\n  border-radius: 16px;\n  background-color: #fff;\n}\n\n.tiptop-editor .review-stars {\n  display: flex;\n  margin-bottom: 16px;\n}\n\n.tiptop-editor .review-stars img{\n  height: 20px;\n  width: 20px;\n}\n\n.tiptop-editor .review-description {\n  flex: 1;\n  margin-bottom: 16px;\n}\n\n.tiptop-editor .review-name {\n  font-size: 14px;\n  color: #737373;\n}\n\n@media (max-width: 768px) {\n  .tiptop-editor .review-grid {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n\n@media (max-width: 1024px) {\n  .tiptop-editor .review-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.ProseMirror p.whychoosemalmart-description {\n  font-size: 16px;\n  color: #737373;\n  margin: 0;\n  line-height: unset;\n}\n\n/* Top Deal Styles */\n\n\n/* Responsive for Why Choose Mal Mart */\n@media (max-width: 1024px) {\n  .whychoosemalmart-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 15px;\n  }\n}\n\n@media (max-width: 768px) {\n\n  .whychoosemalmart-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 15px;\n  }\n\n  .whychoosemalmart-item, .whychooseus-item {\n    padding: 15px;\n  }\n\n  .whychoosemalmart-image, .whychooseus-image {\n    width: 60px;\n    height: 60px;\n    margin-bottom: 10px;\n  }\n\n  .whychoosemalmart-title {\n    font-size: 16px;\n  }\n\n  .whychoosemalmart-description {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .whychoosemalmart-grid {\n    grid-template-columns: repeat(1, 1fr);\n    gap: 10px;\n  }\n\n  .whychoosemalmart-item, .whychooseus-item {\n    padding: 15px;\n  }\n}\n\n/* Responsive for Top Deal */\n@media (max-width: 768px) {\n  .tiptop-editor .top-deal-grid-wrapper {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
